/**
 * @packageDocumentation
 * @category Translation
 */

import { Translation } from '@bomdisoft/translations';

export const metaDescription: Translation = {
  amharic: 'ጤና የሚጀምረው ከምግብ ነው',
  arabic: 'الصحة تبدأ من الطعام',
  bengali: 'সুস্থতার শুরু খাবার থেকে',
  chinese: '健康，从食物开始',
  english: 'Health begins with food',
  estonian: 'Tervis algab toidust',
  filipino: 'Nagsisimula sa pagkain ang kalusugan',
  french: 'La santé commence par l’alimentation',
  german: 'Gesundheit beginnt beim Essen',
  hindi: 'सेहत की शुरुआत भोजन से होती है',
  indonesian: 'Kesehatan berawal dari makanan',
  japanese: '健康は食から始まる',
  korean: '건강은 음식에서 시작됩니다',
  portuguese: 'A saúde começa na alimentação',
  russian: 'Здоровье начинается с еды',
  spanish: 'La salud empieza por la comida',
  swahili: 'Afya huanza na chakula',
  vietnamese: 'Sức khỏe bắt đầu từ thực phẩm',
};

export const tryAgain: Translation = {
  amharic: 'እባክዎ ቆይተው ይሞክሩ!',
  arabic: 'يرجى المحاولة لاحقاً!',
  bengali: 'অনুগ্রহ করে পরে চেষ্টা করুন!',
  chinese: '请稍后再试！',
  english: 'Please try later!',
  estonian: 'Palun proovige hiljem!',
  filipino: 'Mangyaring subukan mamaya!',
  french: `Merci d'essayer plus tard!`,
  german: `Bitte versuchen Sie es später!`,
  hindi: 'कृपया बाद में कोशिश करें!',
  indonesian: 'Silakan coba lagi nanti!',
  japanese: '後でもう一度お試しください！',
  korean: '나중에 다시 시도해주세요!',
  portuguese: 'Por favor, tente mais tarde!',
  russian: `Пожалуйста, попробуйте позднее!`,
  spanish: '¡Por favor, inténtalo más tarde!',
  swahili: 'Tafadhali jaribu baadaye!',
  vietnamese: 'Vui lòng thử lại sau!',
};

export const homeText: Translation = {
  amharic: 'መነሻ',
  arabic: 'الرئيسية',
  bengali: 'হোম',
  chinese: '首页',
  english: 'Home',
  estonian: `Kodu`,
  filipino: 'Tahanan',
  french: 'Domicile',
  german: `Heim`,
  hindi: 'होम',
  indonesian: 'Beranda',
  japanese: 'ホーム',
  korean: '홈',
  portuguese: 'Início',
  russian: `Дом`,
  spanish: 'Inicio',
  swahili: 'Nyumbani',
  vietnamese: 'Trang chủ',
};
export const productsText: Translation = {
  amharic: 'ምርቶች',
  arabic: 'المنتجات',
  bengali: 'পণ্য',
  chinese: '产品',
  english: 'Products',
  estonian: `Tooted`,
  filipino: 'Mga Produkto',
  french: 'Produits',
  german: `Produkte`,
  hindi: 'उत्पाद',
  indonesian: 'Produk',
  japanese: '製品',
  korean: '제품',
  portuguese: 'Produtos',
  russian: `Продукты`,
  spanish: 'Productos',
  swahili: 'Bidhaa',
  vietnamese: 'Sản phẩm',
};
export const produceText: Translation = {
  amharic: 'ምርት',
  arabic: 'المنتجات',
  bengali: 'উৎপাদন',
  chinese: '产品',
  english: 'Produce',
  estonian: `Saadused`,
  filipino: 'Mga Ani',
  french: 'Récolte',
  german: `Produkte`,
  hindi: 'उत्पादन',
  indonesian: 'Produk',
  japanese: '生産物',
  korean: '생산품',
  portuguese: 'Produtos',
  russian: `Производство`,
  spanish: 'Productos',
  swahili: 'Mazao',
  vietnamese: 'Sản phẩm',
};
export const terms: Translation = {
  amharic: 'ውሎች',
  arabic: 'الشروط',
  bengali: 'শর্তাবলী',
  chinese: '条款',
  english: 'Terms',
  estonian: `Kasutustingimused`,
  filipino: 'Mga Tuntunin',
  french: `Conditions d'utilisation`,
  german: `Nutzungsbedingungen`,
  hindi: 'शर्तें',
  indonesian: 'Ketentuan',
  japanese: '利用規約',
  korean: '약관',
  portuguese: 'Termos',
  russian: `Условия использования`,
  spanish: `Términos de servicio`,
  swahili: 'Masharti',
  vietnamese: 'Điều khoản',
};
export const privacy: Translation = {
  amharic: 'ግላዊነት',
  arabic: 'الخصوصية',
  bengali: 'গোপনীয়তা',
  chinese: '隐私',
  english: 'Privacy',
  estonian: `Privaatsuspoliitika`,
  filipino: 'Pribasiya',
  french: 'Politique de confidentialité',
  german: `Datenschutz-Bestimmungen`,
  hindi: 'गोपनीयता',
  indonesian: 'Privasi',
  japanese: 'プライバシー',
  korean: '개인정보 보호',
  portuguese: 'Privacidade',
  russian: `Политика конфиденциальности`,
  spanish: `Política de privacidad`,
  swahili: 'Faragha',
  vietnamese: 'Quyền riêng tư',
};
export const placeOrderText: Translation = {
  amharic: 'ትዕዛዝ ይስጡ',
  arabic: 'تقديم طلب',
  bengali: 'অর্ডার করুন',
  chinese: '下订单',
  english: 'Place an Order',
  estonian: 'Täida tellimus',
  filipino: 'Maglagay ng Order',
  french: 'Passer une commande',
  german: 'Eine Bestellung aufgeben',
  hindi: 'ऑर्डर करें',
  indonesian: 'Buat Pesanan',
  japanese: '注文する',
  korean: '주문하기',
  portuguese: 'Fazer um Pedido',
  russian: 'Сделать заказ',
  spanish: 'Realizar un Pedido',
  swahili: 'Weka Agizo',
  vietnamese: 'Đặt hàng',
};

export const orderStatusText: Translation = {
  amharic: 'የትዕዛዝ ሁኔታ',
  arabic: 'حالة الطلب',
  bengali: 'অর্ডার স্ট্যাটাস',
  chinese: '订单状态',
  english: 'Order Status',
  estonian: 'Telli kontrollimine',
  filipino: 'Status ng Order',
  french: 'Statut de la commande',
  german: 'Bestellung prüfen',
  hindi: 'ऑर्डर स्थिति',
  indonesian: 'Status Pesanan',
  japanese: '注文状況',
  korean: '주문 상태',
  portuguese: 'Status do Pedido',
  russian: 'Статус заказа',
  spanish: 'Estado del Pedido',
  swahili: 'Hali ya Agizo',
  vietnamese: 'Trạng thái Đơn hàng',
};

export const enterOrderIdText: Translation = {
  amharic: 'የትዕዛዝ መለያ ያስገቡ',
  arabic: 'أدخل معرف الطلب',
  bengali: 'অর্ডার ID লিখুন',
  chinese: '输入订单ID',
  english: 'Enter Order ID',
  estonian: 'Sisestage tellimuse ID',
  filipino: 'Ilagay ang Order ID',
  french: "Entrer l'ID de la commande",
  german: 'Bestellungs-ID eingeben',
  hindi: 'ऑर्डर ID दर्ज करें',
  indonesian: 'Masukkan ID Pesanan',
  japanese: '注文IDを入力',
  korean: '주문 ID 입력',
  portuguese: 'Digite o ID do Pedido',
  russian: 'Введите ID заказа',
  spanish: 'Ingresar ID del Pedido',
  swahili: 'Ingiza Kitambulisho cha Agizo',
  vietnamese: 'Nhập ID Đơn hàng',
};

export const cancelOrderText: Translation = {
  amharic: 'ትዕዛዝ ይቅር ይበሉ',
  arabic: 'إلغاء الطلب',
  bengali: 'অর্ডার বাতিল করুন',
  chinese: '取消订单',
  english: 'Cancel Order',
  estonian: 'Telli tühistamine',
  filipino: 'Kanselahin ang Order',
  french: 'Annuler la commande',
  german: 'Bestellung stornieren',
  hindi: 'ऑर्डर रद्द करें',
  indonesian: 'Batalkan Pesanan',
  japanese: '注文をキャンセル',
  korean: '주문 취소',
  portuguese: 'Cancelar Pedido',
  russian: 'Отменить заказ',
  spanish: 'Cancelar Pedido',
  swahili: 'Ghairi Agizo',
  vietnamese: 'Hủy đơn hàng',
};
export const okText: Translation = {
  amharic: 'እሺ',
  arabic: 'موافق',
  bengali: 'ঠিক আছে',
  chinese: '确定',
  english: 'OK',
  estonian: 'OK',
  filipino: 'OK',
  french: 'OK',
  german: 'OK',
  hindi: 'ठीक है',
  indonesian: 'OK',
  japanese: 'OK',
  korean: '확인',
  portuguese: 'OK',
  russian: 'OK',
  spanish: 'OK',
  swahili: 'Sawa',
  vietnamese: 'OK',
};
export const checkOrderText: Translation = {
  amharic: 'ትዕዛዝ ይፈትሹ',
  arabic: 'التحقق من الطلب',
  bengali: 'অর্ডার চেক করুন',
  chinese: '检查订单',
  english: 'Check Order',
  estonian: 'Telli kontrollimine',
  filipino: 'Tingnan ang Order',
  french: 'Vérifier la commande',
  german: 'Bestellung prüfen',
  hindi: 'ऑर्डर जांचें',
  indonesian: 'Periksa Pesanan',
  japanese: '注文を確認',
  korean: '주문 확인',
  portuguese: 'Verificar Pedido',
  russian: 'Проверить заказ',
  spanish: 'Verificar Pedido',
  swahili: 'Angalia Agizo',
  vietnamese: 'Kiểm tra Đơn hàng',
};
export const plantainsText: Translation = {
  amharic: 'ሙዝ',
  arabic: 'الموز',
  bengali: 'প্ল্যান্টেইন',
  chinese: '大蕉',
  english: 'Plantains',
  estonian: 'Jahubanaanid',
  filipino: 'Mga Saging na Saba',
  french: 'Bananes plantains',
  german: 'Kochbananen',
  hindi: 'केले',
  indonesian: 'Pisang',
  japanese: 'プランテン',
  korean: '플랜테인',
  portuguese: 'Bananas-da-terra',
  russian: 'Плантаны',
  spanish: 'Plátanos',
  swahili: 'Ndizi',
  vietnamese: 'Chuối',
};

export const plantainsInfoText: Translation = {
  amharic: 'ሙዝ በዓለም ብዙ ክፍሎች ውስጥ ዋና ምግብ ነው። እነሱ የነጭ እና ጣፋጭ የሙዝ ዓይነት ናቸው። ኦርጋኒክ እና በአካባቢው የተበቀለ።',
  arabic: 'الموز غذاء أساسي في أجزاء كثيرة من العالم. إنه نوع من الموز النشوي والحلو. عضوي ومزروع محلياً.',
  bengali: 'প্ল্যান্টেইন বিশ্বের অনেক অংশে একটি প্রধান খাদ্য। এগুলি এক ধরনের কলা যা শ্বেতসারযুক্ত এবং মিষ্টি। জৈব এবং স্থানীয়ভাবে জন্মানো।',
  chinese: '大蕉是世界许多地方的主食。它们是一种淀粉质且甜美的香蕉。有机和本地种植。',
  english: 'Plantains are a staple food in many parts of the world. They are a type of banana that is starchy and sweet. Organic and locally grown.',
  estonian: 'Jahubanaanid on kõige levinum toit kogu planeedil. Need on tüüp banan, mis on küllastunud ja maitsva. Organiliselt kasutatud ja kohalikult kasutatud.',
  filipino: 'Ang plantains ay isang staple food sa maraming bahagi ng mundo. Sila ay isang uri ng saging na starchy at matamis. Organic at locally grown.',
  french: 'Les plantains sont une nourriture de base dans de nombreuses régions du monde. Ce sont un type de banane qui est stérile et sucré. Organique et localement cultivé.',
  german: 'Kochbananen sind eine Grundnahrungsmittel in vielen Teilen der Welt. Sie sind eine Art Banane, die süß und körnig ist. Organisch und lokal angebaut.',
  hindi: 'केले दुनिया के कई हिस्सों में एक मुख्य भोजन हैं। वे एक प्रकार के केले हैं जो स्टार्चयुक्त और मीठे होते हैं। जैविक और स्थानीय रूप से उगाए गए।',
  indonesian: 'Pisang adalah makanan pokok di banyak bagian dunia. Mereka adalah jenis pisang yang bertepung dan manis. Organik dan ditanam secara lokal.',
  japanese: 'プランテンは世界の多くの地域で主食です。でんぷん質で甘いバナナの一種です。有機栽培および地元栽培。',
  korean: '플랜테인은 세계 여러 지역에서 주식입니다. 전분이 많고 달콤한 바나나의 일종입니다. 유기농 및 현지 재배.',
  portuguese: 'Bananas-da-terra são um alimento básico em muitas partes do mundo. São um tipo de banana que é rica em amido e doce. Orgânico e cultivado localmente.',
  russian: 'Плантаны - это основной продукт питания в большинстве частей мира. Это тип банана, который сладкий и крахмальный. Органический и местно выращенный.',
  spanish: 'Los plátanos son un alimento básico en muchas partes del mundo. Son un tipo de plátano que es almidonado y dulce. Orgánico y cultivado localmente.',
  swahili: 'Ndizi ni chakula cha msingi katika sehemu nyingi za ulimwengu. Ni aina ya ndizi ambayo ni wanga na tamu. Asili na inayolimwa ndani ya nchi.',
  vietnamese: 'Chuối là một loại thực phẩm chủ yếu ở nhiều nơi trên thế giới. Chúng là một loại chuối có tinh bột và ngọt. Hữu cơ và trồng tại địa phương.',
};

export const plantainChipsText: Translation = {
  amharic: 'የሙዝ ቺፕስ',
  arabic: 'رقائق الموز',
  bengali: 'প্ল্যান্টেইন চিপস',
  chinese: '大蕉片',
  english: 'Plantain Chips',
  estonian: 'Jahubanaani chips',
  filipino: 'Chips ng Saging',
  french: 'Chips de plantain',
  german: 'Kochbananen Chips',
  hindi: 'केले के चिप्स',
  indonesian: 'Keripik Pisang',
  japanese: 'プランテンチップ',
  korean: '플랜테인 칩',
  portuguese: 'Chips de Banana-da-terra',
  russian: 'Чипсы из плантанов',
  spanish: 'Chips de Plátano',
  swahili: 'Chips za Ndizi',
  vietnamese: 'Khoai tây chiên',
};
export const plantainFlourText: Translation = {
  amharic: 'የሙዝ ዱቄት',
  arabic: 'دقيق الموز',
  bengali: 'প্ল্যান্টেইন আটা',
  chinese: '大蕉粉',
  english: 'Plantain Flour',
  estonian: 'Jahubanaani jahu',
  filipino: 'Harina ng Saging',
  french: 'Farine de plantain',
  german: 'Kochbananenmehl',
  hindi: 'केले का आटा',
  indonesian: 'Tepung Pisang',
  japanese: 'プランテン粉',
  korean: '플랜테인 가루',
  portuguese: 'Farinha de Banana-da-terra',
  russian: 'Мука из плантанов',
  spanish: 'Harina de Plátano',
  swahili: 'Unga wa Ndizi',
  vietnamese: 'Bột chuối',
};

export const plantainSuckers: Translation = {
  amharic: 'የሙዝ ስኮተሮች',
  arabic: 'فسائل الموز',
  bengali: 'প্ল্যান্টেইন চোষক',
  chinese: '大蕉吸盘',
  english: 'Plantain Suckers',
  estonian: 'Jahubanaani võsud',
  filipino: 'Suplay ng Saging',
  french: 'Drageons de plantain',
  german: 'Kochbananen-Sauglinge',
  hindi: 'केले के अंकुर',
  indonesian: 'Tunas Pisang',
  japanese: 'プランテンの吸盤',
  korean: '플랜테인 새싹',
  portuguese: 'Rebentos de Banana-da-terra',
  russian: 'Ложки подорожника',
  spanish: 'Retoños de Plátano',
  swahili: 'Mazao ya Ndizi',
  vietnamese: 'Chồi chuối',
};

export const plantainBunches: Translation = {
  amharic: 'የሙዝ ቡድኖች',
  arabic: 'عناقيد الموز',
  bengali: 'প্ল্যান্টেইন গুচ্ছ',
  chinese: '大蕉串',
  english: 'Plantain Bunches',
  estonian: 'Jahubanaani kobarad',
  filipino: 'Buwig ng Saging',
  french: 'Bouquets de plantain',
  german: 'Bananenstauden',
  hindi: 'केले के गुच्छे',
  indonesian: 'Tandan Pisang',
  japanese: 'プランテンの房',
  korean: '플랜테인 송이',
  portuguese: 'Cachos de Banana-da-terra',
  russian: 'Пучки подорожника',
  spanish: 'Racimos de Plátano',
  swahili: 'Makundi ya Ndizi',
  vietnamese: 'Nải chuối',
};
export const ripePlantainsText: Translation = {
  amharic: 'የበሰለ ሙዝ',
  arabic: 'الموز الناضج',
  bengali: 'পাকা প্ল্যান্টেইন',
  chinese: '成熟的大蕉',
  english: 'Ripe Plantains',
  estonian: 'Küpsed jahubanaanid',
  filipino: 'Mga Hinog na Saging',
  french: 'Plantains mûrs',
  german: 'Reife Kochbananen',
  hindi: 'पके केले',
  indonesian: 'Pisang Matang',
  japanese: '熟したプランテン',
  korean: '익은 플랜테인',
  portuguese: 'Bananas-da-terra Maduras',
  russian: 'Спелые бананы',
  spanish: 'Plátanos Maduros',
  swahili: 'Ndizi Zilizoiva',
  vietnamese: 'Chuối chín',
};
export const palmNutOilText: Translation = {
  amharic: 'የዘይት ኮኮ ዘይት',
  arabic: 'زيت جوز النخيل',
  bengali: 'পাম বাদাম তেল',
  chinese: '棕榈坚果油',
  english: 'Palm Nut Oil',
  estonian: 'Palmnuuterõli',
  filipino: 'Langis ng Buto ng Palma',
  french: 'Huile de noix de palme',
  german: 'Palmkekseöl',
  hindi: 'पाम नट तेल',
  indonesian: 'Minyak Biji Kelapa Sawit',
  japanese: 'パームナッツオイル',
  korean: '야자 열매 기름',
  portuguese: 'Óleo de Noz de Palmeira',
  russian: 'Масло из кокосового ореха',
  spanish: 'Aceite de Nuez de Palma',
  swahili: 'Mafuta ya Njugu ya Mchikichi',
  vietnamese: 'Dầu hạt cọ',
};
export const palmOilText: Translation = {
  amharic: 'የዘይት ኮኮ ዘይት',
  arabic: 'زيت النخيل',
  bengali: 'পাম তেল',
  chinese: '棕榈油',
  english: 'Palm Oil',
  estonian: 'Palmõli',
  filipino: 'Langis ng Palma',
  french: 'Huile de palme',
  german: 'Palmöl',
  hindi: 'पाम तेल',
  indonesian: 'Minyak Kelapa Sawit',
  japanese: 'パームオイル',
  korean: '팜 오일',
  portuguese: 'Óleo de Palmeira',
  russian: 'Масло из пальмы',
  spanish: 'Aceite de Palma',
  swahili: 'Mafuta ya Mchikichi',
  vietnamese: 'Dầu cọ',
};
export const palmFruitsText: Translation = {
  amharic: 'የዘይት ኮኮ ፍራፍሬ',
  arabic: 'ثمار النخيل',
  bengali: 'পাম ফল',
  chinese: '棕榈果实',
  english: 'Palm Fruits',
  estonian: `Palmehed`,
  filipino: 'Mga Bunga ng Palma',
  french: `Fruits de palme`,
  german: `Palmenfrüchte`,
  hindi: 'पाम फल',
  indonesian: 'Buah Kelapa Sawit',
  japanese: 'パームフルーツ',
  korean: '야자 열매',
  portuguese: 'Frutos de Palmeira',
  russian: `Фрукты пальмы`,
  spanish: 'Frutos de Palma',
  swahili: 'Matunda ya Mchikichi',
  vietnamese: 'Quả cọ',
};
export const palmsText: Translation = {
  amharic: 'ዘይት ኮኮ',
  arabic: 'النخيل',
  bengali: 'পাম',
  chinese: '棕榈',
  english: 'Palms',
  estonian: 'Palmid',
  filipino: 'Mga Palma',
  french: 'Palmiers',
  german: 'Palmen',
  hindi: 'पाम',
  indonesian: 'Kelapa Sawit',
  japanese: 'パーム',
  korean: '야자',
  portuguese: 'Palmeiras',
  russian: 'Пальмы',
  spanish: 'Palmeras',
  swahili: 'Mikichi',
  vietnamese: 'Cọ',
};

export const palmsInfoText: Translation = {
  amharic: 'ዘይት ኮኮ የዘይት ኮኮ ዘይት የሚፈርሱ የዘይት ኮኮ ዛፍ ዓይነት ነው። በምግብ ማብሰያ እና እንደ ማጠቢያ ይጠቀማሉ።',
  arabic: 'النخيل هو نوع من أشجار النخيل التي تنتج زيت النخيل. تُستخدم في الطهي وكمواد تشحيم.',
  bengali: 'পাম হল এক ধরনের পাম গাছ যা পাম তেল উৎপাদন করে। এগুলি রান্নায় এবং লুব্রিকেন্ট হিসাবে ব্যবহৃত হয়।',
  chinese: '棕榈是一种生产棕榈油的棕榈树。它们用于烹饪和作为润滑剂。',
  english: 'Palms are a type of palm tree that produce palm oil. They are used in cooking and as a lubricant.',
  estonian: 'Palmed on tüüp palmeleht, mis toodab palmõli. Seda kasutatakse köögis ja kui vedelik.',
  filipino: 'Ang palms ay isang uri ng palm tree na gumagawa ng palm oil. Ginagamit ito sa pagluluto at bilang lubricant.',
  french: "Les palmes sont un type d'arbre à palme qui produit de l'huile de palme. Elle est utilisée dans la cuisine et comme lubrifiant.",
  german: 'Palmen sind eine Art Palm, die Palmöl produziert. Es wird in der Küche und als Schmieröl verwendet.',
  hindi: 'पाम एक प्रकार का पाम पेड़ है जो पाम तेल का उत्पादन करता है। इसका उपयोग खाना पकाने और स्नेहक के रूप में किया जाता है।',
  indonesian: 'Kelapa sawit adalah jenis pohon kelapa sawit yang menghasilkan minyak kelapa sawit. Digunakan dalam memasak dan sebagai pelumas.',
  japanese: 'パームはパームオイルを生産するパームの木の一種です。調理や潤滑剤として使用されます。',
  korean: '야자는 팜 오일을 생산하는 야자나무의 일종입니다. 요리와 윤활제로 사용됩니다.',
  portuguese: 'As palmeiras são um tipo de árvore de palma que produz óleo de palma. São usadas na culinária e como lubrificante.',
  russian: 'Пальмы - это тип пальмового дерева, который производит пальмовое масло. Оно используется в кулинарии и как смазка.',
  spanish: 'Las palmeras son un tipo de árbol de palma que produce aceite de palma. Se utilizan en la cocina y como lubricante.',
  swahili: 'Mikichi ni aina ya mti wa mchikichi ambao hutoa mafuta ya mchikichi. Hutumiwa katika kupikia na kama mafuta ya kuchanganya.',
  vietnamese: 'Cọ là một loại cây cọ sản xuất dầu cọ. Chúng được sử dụng trong nấu ăn và như một chất bôi trơn.',
};

export const palmBunches: Translation = {
  amharic: 'የዘይት ኮኮ ቡድኖች',
  arabic: 'عناقيد النخيل',
  bengali: 'পাম গুচ্ছ',
  chinese: '棕榈串',
  english: 'Palm Bunches',
  estonian: 'Palmikobarad',
  filipino: 'Buwig ng Palma',
  french: 'Bouquets de palme',
  german: 'Palmstauden',
  hindi: 'पाम गुच्छे',
  indonesian: 'Tandan Kelapa Sawit',
  japanese: 'パームの房',
  korean: '야자 송이',
  portuguese: 'Cachos de Palmeira',
  russian: 'Пучки пальмы',
  spanish: 'Racimos de Palma',
  swahili: 'Makundi ya Mchikichi',
  vietnamese: 'Chùm cọ',
};
export const cocoyamFlourText: Translation = {
  amharic: 'የኮኮያም ዱቄት',
  arabic: 'دقيق الكوكويام',
  bengali: 'কোকোয়াম আটা',
  chinese: '可可薯粉',
  english: 'Cocoyam Flour',
  estonian: 'Taaro jahu',
  filipino: 'Harina ng Gabi',
  french: 'Farine de cocoyam',
  german: 'Kokosnussmehl',
  hindi: 'कोकोयम आटा',
  indonesian: 'Tepung Cocoyam',
  japanese: 'ココヤム粉',
  korean: '코코얌 가루',
  portuguese: 'Farinha de Cocoyam',
  russian: 'Мука из кокояма',
  spanish: 'Harina de Cocoyam',
  swahili: 'Unga wa Cocoyam',
  vietnamese: 'Bột cocoyam',
};
export const cocoyamLeavesText: Translation = {
  amharic: 'የኮኮያም ቅጠሎች',
  arabic: 'أوراق الكوكويام',
  bengali: 'কোকোয়াম পাতা',
  chinese: '可可薯叶',
  english: 'Cocoyam Leaves',
  estonian: 'Taaro lehed',
  filipino: 'Mga Dahon ng Gabi',
  french: 'Feuilles de cocoyam',
  german: 'Kokosnuss-Blätter',
  hindi: 'कोकोयम पत्ते',
  indonesian: 'Daun Cocoyam',
  japanese: 'ココヤムの葉',
  korean: '코코얌 잎',
  portuguese: 'Folhas de Cocoyam',
  russian: 'Листья кокояма',
  spanish: 'Hojas de Cocoyam',
  swahili: 'Majani ya Cocoyam',
  vietnamese: 'Lá cocoyam',
};

export const cocoyamSuckersText: Translation = {
  amharic: 'የኮኮያም ስኮተሮች',
  arabic: 'فسائل الكوكويام',
  bengali: 'কোকোয়াম চোষক',
  chinese: '可可薯吸盘',
  english: 'Cocoyam Suckers',
  estonian: 'Taaro võsud',
  filipino: 'Suplay ng Gabi',
  french: 'Drageons de cocoyam',
  german: 'Kokosnuss-Sauglinge',
  hindi: 'कोकोयम अंकुर',
  indonesian: 'Tunas Cocoyam',
  japanese: 'ココヤムの吸盤',
  korean: '코코얌 새싹',
  portuguese: 'Rebentos de Cocoyam',
  russian: 'Ложки кокояма',
  spanish: 'Retoños de Cocoyam',
  swahili: 'Mazao ya Cocoyam',
  vietnamese: 'Chồi cocoyam',
};

export const cocoyamsInfoText: Translation = {
  amharic: 'ኮኮያም የነጭ እና ጣፋጭ የሥር አትክልት ዓይነት ነው። ኦርጋኒክ እና በአካባቢው የተበቀለ።',
  arabic: 'الكوكويام هو نوع من الخضروات الجذرية النشوية والحلوة. عضوي ومزروع محلياً.',
  bengali: 'কোকোয়াম হল এক ধরনের মূল সবজি যা শ্বেতসারযুক্ত এবং মিষ্টি। জৈব এবং স্থানীয়ভাবে জন্মানো।',
  chinese: '可可薯是一种淀粉质且甜美的根茎类蔬菜。有机和本地种植。',
  english: 'Cocoyams are a type of root vegetable that is starchy and sweet. Organic and locally grown.',
  estonian: 'Cocoyam on tüüp nurg, mis on küllastunud ja maitsva. Organiliselt kasutatud ja kohalikult kasutatud.',
  filipino: 'Ang cocoyams ay isang uri ng root vegetable na starchy at matamis. Organic at locally grown.',
  french: 'Les cocoyams sont une racine de légume qui est stérile et sucré. Organique et localement cultivé.',
  german: 'Kokosnüsse sind eine Art Wurzelgemüse, die süß und körnig ist. Organisch und lokal angebaut.',
  hindi: 'कोकोयम एक प्रकार की जड़ वाली सब्जी है जो स्टार्चयुक्त और मीठी होती है। जैविक और स्थानीय रूप से उगाई गई।',
  indonesian: 'Cocoyams adalah jenis umbi-umbian yang bertepung dan manis. Organik dan ditanam secara lokal.',
  japanese: 'ココヤムはでんぷん質で甘い根菜の一種です。有機栽培および地元栽培。',
  korean: '코코얌은 전분이 많고 달콤한 뿌리 채소의 일종입니다. 유기농 및 현지 재배.',
  portuguese: 'Cocoyams são um tipo de tubérculo que é rico em amido e doce. Orgânico e cultivado localmente.',
  russian: 'Кокоямы - это тип корневого овоща, который сладкий и крахмальный. Органический и местно выращенный.',
  spanish: 'Los cocoyams son un tipo de tubérculo que es rico en almidón y dulce. Orgánico y cultivado localmente.',
  swahili: 'Cocoyams ni aina ya mboga za mizizi ambazo ni wanga na tamu. Asili na zinazolimwa ndani ya nchi.',
  vietnamese: 'Cocoyams là một loại rau củ có tinh bột và ngọt. Hữu cơ và trồng tại địa phương.',
};

export const cocoyamsText: Translation = {
  amharic: 'ኮኮያም',
  arabic: 'الكوكويام',
  bengali: 'কোকোয়াম',
  chinese: '可可薯',
  english: 'Cocoyams',
  estonian: 'Taarod',
  filipino: 'Mga Gabi',
  french: 'Taros',
  german: 'Taro',
  hindi: 'कोकोयम',
  indonesian: 'Talas',
  japanese: 'ココヤム',
  korean: '코코얌',
  portuguese: 'Inhames',
  russian: 'Таро',
  spanish: 'Malangas',
  swahili: 'Magimbi',
  vietnamese: 'Khoai môn',
};
export const cocoaText: Translation = {
  amharic: 'ኮኮአ',
  arabic: 'الكاكاو',
  bengali: 'কোকো',
  chinese: '可可',
  english: 'Cocoa',
  estonian: 'Kakao',
  filipino: 'Kakaw',
  french: 'Cacao',
  german: 'Kakao',
  hindi: 'कोको',
  indonesian: 'Kakao',
  japanese: 'ココア',
  korean: '코코아',
  portuguese: 'Cacau',
  russian: 'Кокоа',
  spanish: 'Cacao',
  swahili: 'Kakao',
  vietnamese: 'Ca cao',
};
export const cocoaSuckersText: Translation = {
  amharic: 'የኮኮአ ስኮተሮች',
  arabic: 'فسائل الكاكاو',
  bengali: 'কোকো চোষক',
  chinese: '可可吸盘',
  english: 'Cocoa Suckers',
  estonian: 'Kakaovõsud',
  filipino: 'Suplay ng Kakaw',
  french: 'Drageons de cacao',
  german: 'Kakao-Sauglinge',
  hindi: 'कोको अंकुर',
  indonesian: 'Tunas Kakao',
  japanese: 'ココアの吸盤',
  korean: '코코아 새싹',
  portuguese: 'Rebentos de Cacau',
  russian: 'Ложки кокоа',
  spanish: 'Retoños de Cacao',
  swahili: 'Mazao ya Kakao',
  vietnamese: 'Chồi ca cao',
};
export const cocoaInfoText: Translation = {
  amharic: 'ኮኮአ በምግብ ማብሰያ እና እንደ ማጠቢያ የሚጠቀም የፍራፍሬ ዓይነት ነው።',
  arabic: 'الكاكاو هو نوع من الفاكهة المستخدمة في الطهي وكمواد تشحيم.',
  bengali: 'কোকো এক ধরনের ফল যা রান্নায় এবং লুব্রিকেন্ট হিসাবে ব্যবহৃত হয়।',
  chinese: '可可是一种用于烹饪和作为润滑剂的水果。',
  english: 'Cocoa is a type of fruit that is used in cooking and as a lubricant.',
  estonian: 'Kakao on tüüp puuvilja, mis on kasutatud köögis ja kui vedelik.',
  filipino: 'Ang cocoa ay isang uri ng prutas na ginagamit sa pagluluto at bilang lubricant.',
  french: 'Le cacao est un fruit qui est utilisé dans la cuisine et comme lubrifiant.',
  german: 'Kakao ist eine Art Frucht, die in der Küche und als Schmieröl verwendet wird.',
  hindi: 'कोको एक प्रकार का फल है जिसका उपयोग खाना पकाने और स्नेहक के रूप में किया जाता है।',
  indonesian: 'Kakao adalah jenis buah yang digunakan dalam memasak dan sebagai pelumas.',
  japanese: 'ココアは調理や潤滑剤として使用される果実の一種です。',
  korean: '코코아는 요리와 윤활제로 사용되는 과일의 일종입니다.',
  portuguese: 'O cacau é um tipo de fruto usado na culinária e como lubrificante.',
  russian: 'Кокоа - это тип фрукта, который используется в кулинарии и как смазка.',
  spanish: 'El cacao es un tipo de fruto que se utiliza en la cocina y como lubricante.',
  swahili: 'Kakao ni aina ya matunda yanayotumika katika kupikia na kama mafuta ya kuchanganya.',
  vietnamese: 'Ca cao là một loại trái cây được sử dụng trong nấu ăn và như một chất bôi trơn.',
};

export const cocoaBeansText: Translation = {
  amharic: 'የኮኮአ አበቦች',
  arabic: 'حبوب الكاكاو',
  bengali: 'কোকো বিন',
  chinese: '可可豆',
  english: 'Cocoa Beans',
  estonian: 'Kakaooad',
  filipino: 'Mga Buto ng Kakaw',
  french: 'Fèves de cacao',
  german: 'Kakao-Bohnen',
  hindi: 'कोको बीन्स',
  indonesian: 'Biji Kakao',
  japanese: 'ココア豆',
  korean: '코코아 콩',
  portuguese: 'Grãos de Cacau',
  russian: 'Кокосовые бобы',
  spanish: 'Granos de Cacao',
  swahili: 'Maharagwe ya Kakao',
  vietnamese: 'Hạt ca cao',
};
export const cocoaPowderText: Translation = {
  amharic: 'የኮኮአ ዱቄት',
  arabic: 'مسحوق الكاكاو',
  bengali: 'কোকো পাউডার',
  chinese: '可可粉',
  english: 'Cocoa Powder',
  estonian: 'Kakaopulber',
  filipino: 'Pulbos ng Kakaw',
  french: 'Poudre de cacao',
  german: 'Kakao-Mehl',
  hindi: 'कोको पाउडर',
  indonesian: 'Bubuk Kakao',
  japanese: 'ココアパウダー',
  korean: '코코아 가루',
  portuguese: 'Pó de Cacau',
  russian: 'Мука из кокоа',
  spanish: 'Polvo de Cacao',
  swahili: 'Unga wa Kakao',
  vietnamese: 'Bột ca cao',
};

export const productText: Translation = {
  amharic: 'ምርት',
  arabic: 'المنتج',
  bengali: 'পণ্য',
  chinese: '产品',
  english: 'Product',
  estonian: 'Toot',
  filipino: 'Produkto',
  french: 'Produit',
  german: 'Produkt',
  hindi: 'उत्पाद',
  indonesian: 'Produk',
  japanese: '製品',
  korean: '제품',
  portuguese: 'Produto',
  russian: 'Продукт',
  spanish: 'Producto',
  swahili: 'Bidhaa',
  vietnamese: 'Sản phẩm',
};
export const quantityText: Translation = {
  amharic: 'ብዛት',
  arabic: 'الكمية',
  bengali: 'পরিমাণ',
  chinese: '数量',
  english: 'Quantity',
  estonian: 'Kogus',
  filipino: 'Dami',
  french: 'Quantité',
  german: 'Menge',
  hindi: 'मात्रा',
  indonesian: 'Jumlah',
  japanese: '数量',
  korean: '수량',
  portuguese: 'Quantidade',
  russian: 'Количество',
  spanish: 'Cantidad',
  swahili: 'Kiasi',
  vietnamese: 'Số lượng',
};
export const contactText: Translation = {
  amharic: 'ያግኙ',
  arabic: 'اتصل',
  bengali: 'যোগাযোগ',
  chinese: '联系',
  english: 'Contact',
  estonian: 'Kontakt',
  filipino: 'Makipag-ugnayan',
  french: 'Contact',
  german: 'Kontakt',
  hindi: 'संपर्क',
  indonesian: 'Kontak',
  japanese: 'お問い合わせ',
  korean: '연락처',
  portuguese: 'Contato',
  russian: 'Контакт',
  spanish: 'Contacto',
  swahili: 'Wasiliana',
  vietnamese: 'Liên hệ',
};
export const deliveryText: Translation = {
  amharic: 'ማድረስ',
  arabic: 'التوصيل',
  bengali: 'ডেলিভারি',
  chinese: '配送',
  english: 'Delivery',
  estonian: 'Saatmine',
  filipino: 'Paghahatid',
  french: 'Livraison',
  german: 'Lieferung',
  hindi: 'डिलीवरी',
  indonesian: 'Pengiriman',
  japanese: '配送',
  korean: '배송',
  portuguese: 'Entrega',
  russian: 'Доставка',
  spanish: 'Entrega',
  swahili: 'Uwasilishaji',
  vietnamese: 'Giao hàng',
};
export const paymentText: Translation = {
  amharic: 'ክፍያ',
  arabic: 'الدفع',
  bengali: 'পেমেন্ট',
  chinese: '付款',
  english: 'Payment',
  estonian: 'Makse',
  filipino: 'Bayad',
  french: 'Paiement',
  german: 'Zahlung',
  hindi: 'भुगतान',
  indonesian: 'Pembayaran',
  japanese: '支払い',
  korean: '결제',
  portuguese: 'Pagamento',
  russian: 'Оплата',
  spanish: 'Pago',
  swahili: 'Malipo',
  vietnamese: 'Thanh toán',
};
export const phoneText: Translation = {
  amharic: 'ስልክ',
  arabic: 'الهاتف',
  bengali: 'ফোন',
  chinese: '电话',
  english: 'Phone',
  estonian: 'Telefon',
  filipino: 'Telepono',
  french: 'Téléphone',
  german: 'Telefon',
  hindi: 'फोन',
  indonesian: 'Telepon',
  japanese: '電話',
  korean: '전화',
  portuguese: 'Telefone',
  russian: 'Телефон',
  spanish: 'Teléfono',
  swahili: 'Simu',
  vietnamese: 'Điện thoại',
};
export const townText: Translation = {
  amharic: 'ከተማ',
  arabic: 'المدينة',
  bengali: 'শহর',
  chinese: '城镇',
  english: 'Town',
  estonian: 'Linn',
  filipino: 'Bayan',
  french: 'Ville',
  german: 'Stadt',
  hindi: 'शहर',
  indonesian: 'Kota',
  japanese: '町',
  korean: '도시',
  portuguese: 'Cidade',
  russian: 'Город',
  spanish: 'Ciudad',
  swahili: 'Jiji',
  vietnamese: 'Thị trấn',
};
export const agencyText: Translation = {
  amharic: 'ኤጀንሲ',
  arabic: 'الوكالة',
  bengali: 'এজেন্সি',
  chinese: '代理',
  english: 'Agency',
  estonian: 'Asutus',
  filipino: 'Ahensya',
  french: 'Agence',
  german: 'Agentur',
  hindi: 'एजेंसी',
  indonesian: 'Agensi',
  japanese: '代理店',
  korean: '대행사',
  portuguese: 'Agência',
  russian: 'Агентство',
  spanish: 'Agencia',
  swahili: 'Wakala',
  vietnamese: 'Đại lý',
};
export const paymentMethodText: Translation = {
  amharic: 'የክፍያ ዘዴ',
  arabic: 'طريقة الدفع',
  bengali: 'পেমেন্ট পদ্ধতি',
  chinese: '支付方式',
  english: 'Payment Method',
  estonian: 'Makseviis',
  filipino: 'Paraan ng Pagbabayad',
  french: 'Méthode de paiement',
  german: 'Zahlungsmethode',
  hindi: 'भुगतान विधि',
  indonesian: 'Metode Pembayaran',
  japanese: '支払い方法',
  korean: '결제 방법',
  portuguese: 'Método de Pagamento',
  russian: 'Способ оплаты',
  spanish: 'Método de Pago',
  swahili: 'Njia ya Malipo',
  vietnamese: 'Phương thức Thanh toán',
};
export const momoNumberText: Translation = {
  amharic: 'የMoMo ቁጥር',
  arabic: 'رقم MoMo',
  bengali: 'MoMo নম্বর',
  chinese: 'MoMo 号码',
  english: 'MoMo Number',
  estonian: 'MoMo number',
  filipino: 'Numero ng MoMo',
  french: 'Numéro MoMo',
  german: 'MoMo-Nummer',
  hindi: 'MoMo नंबर',
  indonesian: 'Nomor MoMo',
  japanese: 'MoMo番号',
  korean: 'MoMo 번호',
  portuguese: 'Número MoMo',
  russian: 'Номер MoMo',
  spanish: 'Número MoMo',
  swahili: 'Nambari ya MoMo',
  vietnamese: 'Số MoMo',
};
export const paypalIDText: Translation = {
  amharic: 'የPaypal መለያ',
  arabic: 'معرف PayPal',
  bengali: 'PayPal ID',
  chinese: 'PayPal ID',
  english: 'Paypal ID',
  estonian: 'Paypal ID',
  filipino: 'Paypal ID',
  french: 'ID Paypal',
  german: 'Paypal-ID',
  hindi: 'PayPal ID',
  indonesian: 'ID Paypal',
  japanese: 'PayPal ID',
  korean: 'PayPal ID',
  portuguese: 'ID do Paypal',
  russian: 'ID Paypal',
  spanish: 'ID de Paypal',
  swahili: 'Kitambulisho cha Paypal',
  vietnamese: 'ID Paypal',
};
export const orderTotalText: Translation = {
  amharic: 'የትዕዛዝ ጠቅላላ',
  arabic: 'إجمالي الطلب',
  bengali: 'অর্ডার মোট',
  chinese: '订单总额',
  english: 'Order Total',
  estonian: 'Tellimuse kogusumma',
  filipino: 'Kabuuan ng Order',
  french: 'Total de la commande',
  german: 'Bestellungssumme',
  hindi: 'ऑर्डर कुल',
  indonesian: 'Total Pesanan',
  japanese: '注文合計',
  korean: '주문 총액',
  portuguese: 'Total do Pedido',
  russian: 'Сумма заказа',
  spanish: 'Total del Pedido',
  swahili: 'Jumla ya Agizo',
  vietnamese: 'Tổng Đơn hàng',
};
export const enterNameText: Translation = {
  amharic: 'ስምዎን ያስገቡ',
  arabic: 'أدخل اسمك',
  bengali: 'আপনার নাম লিখুন',
  chinese: '输入您的姓名',
  english: 'Enter your name',
  estonian: 'Sisesta oma nimi',
  filipino: 'Ilagay ang iyong pangalan',
  french: 'Entrez votre nom',
  german: 'Geben Sie Ihren Namen ein',
  hindi: 'अपना नाम दर्ज करें',
  indonesian: 'Masukkan nama Anda',
  japanese: 'お名前を入力',
  korean: '이름을 입력하세요',
  portuguese: 'Digite seu nome',
  russian: 'Введите ваше имя',
  spanish: 'Ingresa tu nombre',
  swahili: 'Ingiza jina lako',
  vietnamese: 'Nhập tên của bạn',
};
export const enterPhoneText: Translation = {
  amharic: 'የስልክ ቁጥርዎን ያስገቡ',
  arabic: 'أدخل رقم هاتفك',
  bengali: 'আপনার ফোন নম্বর লিখুন',
  chinese: '输入您的电话号码',
  english: 'Enter your phone number',
  estonian: 'Sisesta oma telefoninumber',
  filipino: 'Ilagay ang iyong numero ng telepono',
  french: 'Entrez votre numéro de téléphone',
  german: 'Geben Sie Ihre Telefonnummer ein',
  hindi: 'अपना फोन नंबर दर्ज करें',
  indonesian: 'Masukkan nomor telepon Anda',
  japanese: '電話番号を入力',
  korean: '전화번호를 입력하세요',
  portuguese: 'Digite seu número de telefone',
  russian: 'Введите ваш номер телефона',
  spanish: 'Ingresa tu número de teléfono',
  swahili: 'Ingiza nambari yako ya simu',
  vietnamese: 'Nhập số điện thoại của bạn',
};
export const selectProductText: Translation = {
  amharic: 'ምርት ይምረጡ',
  arabic: 'اختر منتجاً',
  bengali: 'একটি পণ্য নির্বাচন করুন',
  chinese: '选择产品',
  english: 'Select a product',
  estonian: 'Vali toode',
  filipino: 'Pumili ng produkto',
  french: 'Sélectionnez un produit',
  german: 'Produkt auswählen',
  hindi: 'एक उत्पाद चुनें',
  indonesian: 'Pilih produk',
  japanese: '製品を選択',
  korean: '제품 선택',
  portuguese: 'Selecione um produto',
  russian: 'Выберите продукт',
  spanish: 'Selecciona un producto',
  swahili: 'Chagua bidhaa',
  vietnamese: 'Chọn sản phẩm',
};
export const selectPaymentMethodText: Translation = {
  amharic: 'የክፍያ ዘዴ ይምረጡ',
  arabic: 'اختر طريقة الدفع',
  bengali: 'একটি পেমেন্ট পদ্ধতি নির্বাচন করুন',
  chinese: '选择支付方式',
  english: 'Select a payment method',
  estonian: 'Vali makseviisi',
  filipino: 'Pumili ng paraan ng pagbabayad',
  french: 'Sélectionnez une méthode de paiement',
  german: 'Zahlungsmethode auswählen',
  hindi: 'एक भुगतान विधि चुनें',
  indonesian: 'Pilih metode pembayaran',
  japanese: '支払い方法を選択',
  korean: '결제 방법 선택',
  portuguese: 'Selecione um método de pagamento',
  russian: 'Выберите способ оплаты',
  spanish: 'Selecciona un método de pago',
  swahili: 'Chagua njia ya malipo',
  vietnamese: 'Chọn phương thức thanh toán',
};
export const enterMomoNumberText: Translation = {
  amharic: 'የMoMo ቁጥርዎን ያስገቡ',
  arabic: 'أدخل رقم MoMo الخاص بك',
  bengali: 'আপনার MoMo নম্বর লিখুন',
  chinese: '输入您的 MoMo 号码',
  english: 'Enter your MoMo number',
  estonian: 'Sisesta oma MoMo number',
  filipino: 'Ilagay ang iyong MoMo number',
  french: 'Entrez votre numéro MoMo',
  german: 'Geben Sie Ihre MoMo-Nummer ein',
  hindi: 'अपना MoMo नंबर दर्ज करें',
  indonesian: 'Masukkan nomor MoMo Anda',
  japanese: 'MoMo番号を入力',
  korean: 'MoMo 번호를 입력하세요',
  portuguese: 'Digite seu número MoMo',
  russian: 'Введите ваш номер MoMo',
  spanish: 'Ingresa tu número MoMo',
  swahili: 'Ingiza nambari yako ya MoMo',
  vietnamese: 'Nhập số MoMo của bạn',
};
export const enterPaypalIDText: Translation = {
  amharic: 'የPaypal መለያዎን ያስገቡ',
  arabic: 'أدخل معرف PayPal الخاص بك',
  bengali: 'আপনার PayPal ID লিখুন',
  chinese: '输入您的 PayPal ID',
  english: 'Enter your Paypal ID',
  estonian: 'Sisesta oma Paypal ID',
  filipino: 'Ilagay ang iyong Paypal ID',
  french: 'Entrez votre ID Paypal',
  german: 'Geben Sie Ihre Paypal-ID ein',
  hindi: 'अपना PayPal ID दर्ज करें',
  indonesian: 'Masukkan ID Paypal Anda',
  japanese: 'PayPal IDを入力',
  korean: 'PayPal ID를 입력하세요',
  portuguese: 'Digite seu ID do Paypal',
  russian: 'Введите ваш ID Paypal',
  spanish: 'Ingresa tu ID de Paypal',
  swahili: 'Ingiza kitambulisho chako cha Paypal',
  vietnamese: 'Nhập ID Paypal của bạn',
};
export const selectTownText: Translation = {
  amharic: 'ከተማ ይምረጡ',
  arabic: 'اختر مدينة',
  bengali: 'একটি শহর নির্বাচন করুন',
  chinese: '选择城镇',
  english: 'Select a town',
  estonian: 'Vali linn',
  filipino: 'Pumili ng bayan',
  french: 'Sélectionnez une ville',
  german: 'Stadt auswählen',
  hindi: 'एक शहर चुनें',
  indonesian: 'Pilih kota',
  japanese: '町を選択',
  korean: '도시 선택',
  portuguese: 'Selecione uma cidade',
  russian: 'Выберите город',
  spanish: 'Selecciona una ciudad',
  swahili: 'Chagua jiji',
  vietnamese: 'Chọn thị trấn',
};
export const selectAgencyText: Translation = {
  amharic: 'ኤጀንሲ ይምረጡ',
  arabic: 'اختر وكالة',
  bengali: 'একটি এজেন্সি নির্বাচন করুন',
  chinese: '选择代理',
  english: 'Select an agency',
  estonian: 'Vali asutus',
  filipino: 'Pumili ng ahensya',
  french: 'Sélectionnez un agence',
  german: 'Agentur auswählen',
  hindi: 'एक एजेंसी चुनें',
  indonesian: 'Pilih agensi',
  japanese: '代理店を選択',
  korean: '대행사 선택',
  portuguese: 'Selecione uma agência',
  russian: 'Выберите агентство',
  spanish: 'Selecciona una agencia',
  swahili: 'Chagua wakala',
  vietnamese: 'Chọn đại lý',
};
export const minOrderQuantityText: Translation = {
  amharic: 'ዝቅተኛው የትዕዛዝ ብዛት አልተሞላም',
  arabic: 'الحد الأدنى لكمية الطلب غير مستوفى',
  bengali: 'সর্বনিম্ন অর্ডার পরিমাণ পূরণ হয়নি',
  chinese: '未达到最低订单数量',
  english: 'Minimum order quantity not met',
  estonian: 'Minimaalne tellimuse kogus pole täidetud',
  filipino: 'Hindi naabot ang pinakamababang dami ng order',
  french: 'Quantité minimale de commande non atteinte',
  german: 'Mindestbestellmenge nicht erreicht',
  hindi: 'न्यूनतम ऑर्डर मात्रा पूरी नहीं हुई',
  indonesian: 'Jumlah pesanan minimum tidak terpenuhi',
  japanese: '最小注文数量に達していません',
  korean: '최소 주문 수량 미달',
  portuguese: 'Quantidade mínima do pedido não atendida',
  russian: 'Минимальная сумма заказа не достигнута',
  spanish: 'Cantidad mínima de pedido no cumplida',
  swahili: 'Kiasi cha chini cha agizo hakijafikiwa',
  vietnamese: 'Số lượng đơn hàng tối thiểu chưa đạt',
};
export const maxOrderQuantityText: Translation = {
  amharic: 'ከፍተኛው የትዕዛዝ ብዛት ተሻግሯል',
  arabic: 'تم تجاوز الحد الأقصى لكمية الطلب',
  bengali: 'সর্বোচ্চ অর্ডার পরিমাণ ছাড়িয়ে গেছে',
  chinese: '超过最大订单数量',
  english: 'Maximum order quantity exceeded',
  estonian: 'Maksimaalne tellimuse kogus ületatud',
  filipino: 'Lumampas sa pinakamataas na dami ng order',
  french: 'Quantité maximale de commande dépassée',
  german: 'Maximaler Bestellwert überschritten',
  hindi: 'अधिकतम ऑर्डर मात्रा पार हो गई',
  indonesian: 'Jumlah pesanan maksimum terlampaui',
  japanese: '最大注文数量を超えました',
  korean: '최대 주문 수량 초과',
  portuguese: 'Quantidade máxima do pedido excedida',
  russian: 'Максимальная сумма заказа превышена',
  spanish: 'Cantidad máxima de pedido excedida',
  swahili: 'Kiasi cha juu cha agizo kimezidi',
  vietnamese: 'Vượt quá số lượng đơn hàng tối đa',
};
export const successText: Translation = {
  amharic: 'ትዕዛዝ በተሳካ ሁኔታ ተቀምጧል',
  arabic: 'تم تقديم الطلب بنجاح',
  bengali: 'অর্ডার সফলভাবে দেওয়া হয়েছে',
  chinese: '订单提交成功',
  english: 'Order placed successfully',
  estonian: 'Tellimus edukalt täidetud',
  filipino: 'Matagumpay na na-place ang order',
  french: 'Commande passée avec succès',
  german: 'Bestellung erfolgreich platziert',
  hindi: 'ऑर्डर सफलतापूर्वक दिया गया',
  indonesian: 'Pesanan berhasil ditempatkan',
  japanese: '注文が正常に送信されました',
  korean: '주문이 성공적으로 접수되었습니다',
  portuguese: 'Pedido realizado com sucesso',
  russian: 'Заказ успешно размещен',
  spanish: 'Pedido realizado con éxito',
  swahili: 'Agizo limewekwa kwa mafanikio',
  vietnamese: 'Đặt hàng thành công',
};

export const noscriptMessage: Translation = {
  amharic: 'ይህን መተግበሪያ ለማስኬድ JavaScript ማንቃት አለብዎት።',
  arabic: 'يجب تمكين JavaScript لتشغيل هذا التطبيق.',
  bengali: 'এই অ্যাপটি চালাতে আপনাকে JavaScript সক্ষম করতে হবে।',
  chinese: '您需要启用 JavaScript 才能运行此应用。',
  english: 'You need to enable JavaScript to run this app.',
  estonian: 'Selle rakenduse käivitamiseks peate lubama JavaScripti.',
  filipino: 'Kailangan mong i-enable ang JavaScript para patakbuhin ang app na ito.',
  french: 'Vous devez activer JavaScript pour exécuter cette application.',
  german: 'Sie müssen JavaScript aktivieren, um diese App auszuführen.',
  hindi: 'इस ऐप को चलाने के लिए आपको JavaScript सक्षम करना होगा।',
  indonesian: 'Anda perlu mengaktifkan JavaScript untuk menjalankan aplikasi ini.',
  japanese: 'このアプリを実行するには JavaScript を有効にする必要があります。',
  korean: '이 앱을 실행하려면 JavaScript를 활성화해야 합니다.',
  portuguese: 'Você precisa ativar o JavaScript para executar este aplicativo.',
  russian: 'Для работы этого приложения необходимо включить JavaScript.',
  spanish: 'Necesitas habilitar JavaScript para ejecutar esta aplicación.',
  swahili: 'Unahitaji kuwezesha JavaScript ili kuendesha programu hii.',
  vietnamese: 'Bạn cần bật JavaScript để chạy ứng dụng này.',
};

export const skipToContent: Translation = {
  amharic: 'ወደ ዋናው ይዘት ይዝለሉ',
  arabic: 'تخطَّ إلى المحتوى الرئيسي',
  bengali: 'মূল বিষয়বস্তুতে যান',
  chinese: '跳到主要内容',
  english: 'Skip to main content',
  estonian: 'Liigu põhisisu juurde',
  filipino: 'Laktawan papunta sa pangunahing nilalaman',
  french: 'Passer au contenu principal',
  german: 'Zum Hauptinhalt springen',
  hindi: 'मुख्य सामग्री पर जाएँ',
  indonesian: 'Lewati ke konten utama',
  japanese: 'メインコンテンツへスキップ',
  korean: '본문으로 건너뛰기',
  portuguese: 'Pular para o conteúdo principal',
  russian: 'Перейти к основному содержанию',
  spanish: 'Saltar al contenido principal',
  swahili: 'Rukia hadi maudhui makuu',
  vietnamese: 'Chuyển đến nội dung chính',
};

export const somethingWentWrong: Translation = {
  amharic: 'ውይ! የሆነ ስህተት ተፈጥሯል።',
  arabic: 'عفواً! حدث خطأ ما.',
  bengali: 'ওহো! কিছু একটা ভুল হয়েছে।',
  chinese: '哎呀！出了点问题。',
  english: 'Oops! Something went wrong.',
  estonian: 'Oih! Midagi läks valesti.',
  filipino: 'Naku! May nangyaring mali.',
  french: 'Oups ! Une erreur est survenue.',
  german: 'Hoppla! Etwas ist schiefgelaufen.',
  hindi: 'ओह! कुछ गलत हो गया।',
  indonesian: 'Ups! Ada yang tidak beres.',
  japanese: 'おっと！問題が発生しました。',
  korean: '이런! 문제가 발생했습니다.',
  portuguese: 'Ops! Algo deu errado.',
  russian: 'Упс! Что-то пошло не так.',
  spanish: '¡Ups! Algo salió mal.',
  swahili: 'Lo! Kitu kimeenda vibaya.',
  vietnamese: 'Rất tiếc! Đã xảy ra lỗi.',
};

export const producePageTitle: Translation = {
  amharic: 'ምርት',
  arabic: 'المنتجات',
  bengali: 'উৎপাদন',
  chinese: '产品',
  english: 'Produce',
  estonian: 'Saadused',
  filipino: 'Mga Ani',
  french: 'Récolte',
  german: 'Erzeugnisse',
  hindi: 'उत्पादन',
  indonesian: 'Hasil Tani',
  japanese: '農産物',
  korean: '농산물',
  portuguese: 'Produtos Agrícolas',
  russian: 'Продукция',
  spanish: 'Productos Agrícolas',
  swahili: 'Mazao',
  vietnamese: 'Nông sản',
};

export const privacyPolicyPageTitle: Translation = {
  amharic: 'የግላዊነት ፖሊሲ',
  arabic: 'سياسة الخصوصية',
  bengali: 'গোপনীয়তা নীতি',
  chinese: '隐私政策',
  english: 'Privacy Policy',
  estonian: 'Privaatsuspoliitika',
  filipino: 'Patakaran sa Pribasiya',
  french: 'Politique de confidentialité',
  german: 'Datenschutzrichtlinie',
  hindi: 'गोपनीयता नीति',
  indonesian: 'Kebijakan Privasi',
  japanese: 'プライバシーポリシー',
  korean: '개인정보 처리방침',
  portuguese: 'Política de Privacidade',
  russian: 'Политика конфиденциальности',
  spanish: 'Política de Privacidad',
  swahili: 'Sera ya Faragha',
  vietnamese: 'Chính sách Bảo mật',
};

export const termsOfServicePageTitle: Translation = {
  amharic: 'የአገልግሎት ውሎች',
  arabic: 'شروط الخدمة',
  bengali: 'পরিষেবার শর্তাবলী',
  chinese: '服务条款',
  english: 'Terms of Service',
  estonian: 'Kasutustingimused',
  filipino: 'Mga Tuntunin ng Serbisyo',
  french: "Conditions d'utilisation",
  german: 'Nutzungsbedingungen',
  hindi: 'सेवा की शर्तें',
  indonesian: 'Ketentuan Layanan',
  japanese: '利用規約',
  korean: '서비스 약관',
  portuguese: 'Termos de Serviço',
  russian: 'Условия обслуживания',
  spanish: 'Términos de Servicio',
  swahili: 'Masharti ya Huduma',
  vietnamese: 'Điều khoản Dịch vụ',
};

export const mtnMobileMoney: Translation = {
  amharic: 'MTN ሞባይል ገንዘብ',
  arabic: 'إم تي إن موبايل موني',
  bengali: 'MTN মোবাইল মানি',
  chinese: 'MTN 移动货币',
  english: 'MTN Mobile Money',
  estonian: 'MTN Mobile Money',
  filipino: 'MTN Mobile Money',
  french: 'MTN Mobile Money',
  german: 'MTN Mobile Money',
  hindi: 'MTN मोबाइल मनी',
  indonesian: 'MTN Mobile Money',
  japanese: 'MTN モバイルマネー',
  korean: 'MTN 모바일 머니',
  portuguese: 'MTN Mobile Money',
  russian: 'MTN Mobile Money',
  spanish: 'MTN Mobile Money',
  swahili: 'Pesa ya Simu ya MTN',
  vietnamese: 'Tiền di động MTN',
};

export const paymentMethodIconAlt: Translation = {
  amharic: 'የክፍያ ዘዴ አዶ',
  arabic: 'أيقونة طريقة الدفع',
  bengali: 'পেমেন্ট পদ্ধতির আইকন',
  chinese: '支付方式图标',
  english: 'Payment method icon',
  estonian: 'Makseviisi ikoon',
  filipino: 'Icon ng paraan ng pagbabayad',
  french: 'Icône du mode de paiement',
  german: 'Symbol der Zahlungsmethode',
  hindi: 'भुगतान विधि आइकन',
  indonesian: 'Ikon metode pembayaran',
  japanese: '支払い方法のアイコン',
  korean: '결제 방법 아이콘',
  portuguese: 'Ícone do método de pagamento',
  russian: 'Значок способа оплаты',
  spanish: 'Icono del método de pago',
  swahili: 'Ikoni ya njia ya malipo',
  vietnamese: 'Biểu tượng phương thức thanh toán',
};

export const produceMainImageAlt: Translation = {
  amharic: 'ዋናው የምርት ምስል',
  arabic: 'الصورة الرئيسية للمنتج',
  bengali: 'প্রধান উৎপাদন চিত্র',
  chinese: '主要农产品图片',
  english: 'Main produce image',
  estonian: 'Peamine saaduse pilt',
  filipino: 'Pangunahing larawan ng ani',
  french: 'Image principale du produit',
  german: 'Hauptbild des Erzeugnisses',
  hindi: 'मुख्य उत्पाद छवि',
  indonesian: 'Gambar utama hasil tani',
  japanese: '農産物のメイン画像',
  korean: '주요 농산물 이미지',
  portuguese: 'Imagem principal do produto',
  russian: 'Основное изображение продукции',
  spanish: 'Imagen principal del producto',
  swahili: 'Picha kuu ya mazao',
  vietnamese: 'Hình ảnh nông sản chính',
};

export const logoAlt: Translation = {
  amharic: 'አርማ',
  arabic: 'الشعار',
  bengali: 'লোগো',
  chinese: '标志',
  english: 'Logo',
  estonian: 'Logo',
  filipino: 'Logo',
  french: 'Logo',
  german: 'Logo',
  hindi: 'लोगो',
  indonesian: 'Logo',
  japanese: 'ロゴ',
  korean: '로고',
  portuguese: 'Logótipo',
  russian: 'Логотип',
  spanish: 'Logotipo',
  swahili: 'Nembo',
  vietnamese: 'Biểu trưng',
};

export const navOrders: Translation = {
  amharic: 'ትዕዛዞች',
  arabic: 'الطلبات',
  bengali: 'অর্ডার',
  chinese: '订单',
  english: 'Orders',
  estonian: 'Tellimused',
  filipino: 'Mga Order',
  french: 'Commandes',
  german: 'Bestellungen',
  hindi: 'ऑर्डर',
  indonesian: 'Pesanan',
  japanese: '注文',
  korean: '주문',
  portuguese: 'Pedidos',
  russian: 'Заказы',
  spanish: 'Pedidos',
  swahili: 'Maagizo',
  vietnamese: 'Đơn hàng',
};

export const navDataDeletion: Translation = {
  amharic: 'የመለያ ስረዛ',
  arabic: 'حذف الحساب',
  bengali: 'অ্যাকাউন্ট মুছে ফেলা',
  chinese: '删除账户',
  english: 'Data Deletion',
  estonian: 'Konto kustutamine',
  filipino: 'Pagbura ng Data',
  french: 'Suppression des données',
  german: 'Datenlöschung',
  hindi: 'डेटा हटाना',
  indonesian: 'Penghapusan Data',
  japanese: 'データ削除',
  korean: '데이터 삭제',
  portuguese: 'Exclusão de dados',
  russian: 'Удаление данных',
  spanish: 'Eliminación de datos',
  swahili: 'Kufuta data',
  vietnamese: 'Xóa dữ liệu',
};

export const orderProduceText: Translation = {
  amharic: 'ምርት ይዘዙ',
  arabic: 'اطلب المحاصيل',
  bengali: 'ফসল অর্ডার করুন',
  chinese: '订购农产品',
  english: 'Order produce',
  estonian: 'Telli saadus',
  filipino: 'Mag-order ng Ani',
  french: 'Commander des produits',
  german: 'Erzeugnisse bestellen',
  hindi: 'उपज ऑर्डर करें',
  indonesian: 'Pesan Hasil Panen',
  japanese: '農産物を注文',
  korean: '농산물 주문',
  portuguese: 'Encomendar produtos',
  russian: 'Заказать урожай',
  spanish: 'Pedir productos',
  swahili: 'Agiza mazao',
  vietnamese: 'Đặt nông sản',
};

export const heroHeadline: Translation = {
  amharic: 'ከእርሻ ወደ ጠረጴዛዎ በቀጥታ',
  arabic: 'من المزرعة إلى مائدتك مباشرة',
  bengali: 'খামার থেকে সরাসরি আপনার টেবিলে',
  chinese: '从农场直达您的餐桌',
  english: 'Fresh produce, straight from the farm',
  estonian: 'Värske saadus otse talust',
  filipino: 'Sariwang ani, diretso mula sa bukid',
  french: 'Des produits frais, directement de la ferme',
  german: 'Frische Erzeugnisse, direkt vom Hof',
  hindi: 'ताज़ी उपज, सीधे खेत से',
  indonesian: 'Hasil panen segar, langsung dari kebun',
  japanese: '農場から食卓へ、新鮮なまま',
  korean: '농장에서 식탁까지, 신선하게',
  portuguese: 'Produtos frescos, direto da fazenda',
  russian: 'Свежие продукты прямо с фермы',
  spanish: 'Productos frescos, directo de la granja',
  swahili: 'Mazao mabichi, moja kwa moja kutoka shambani',
  vietnamese: 'Nông sản tươi, thẳng từ nông trại',
};

export const heroSubhead: Translation = {
  amharic: 'ፒሌፍ በራሱ እርሻዎች ላይ ያበቅለዋል: ግልጽ ምንጭ፣ ትኩስ ምርት፣ ወደ በርዎ ይደርሳል።',
  arabic: 'بيليف يزرعها في مزارعه الخاصة: مصدر شفاف، محاصيل طازجة، تصل إلى بابك.',
  bengali: 'পিলিফ নিজের খামারেই এটি চাষ করে: স্বচ্ছ উৎস, তাজা ফসল, আপনার দরজায় পৌঁছে দেয়।',
  chinese: 'Pieleaf 在自有农场种植：来源透明，产品新鲜，直送到家。',
  english: 'Pieleaf grows it on its own farms: transparent sourcing, fresh produce, delivered to your door.',
  estonian: 'Pieleaf kasvatab seda oma taludes: läbipaistev päritolu, värske saadus, kohaletoimetamine.',
  filipino: 'Sa sarili naming mga sakahan itinatanim ng Pieleaf: malinaw na pinagmulan, sariwang ani, hatid sa iyong pinto.',
  french: 'Pieleaf le cultive dans ses propres fermes : approvisionnement transparent, produits frais, livrés chez vous.',
  german: 'Pieleaf baut es auf eigenen Höfen an: transparente Herkunft, frische Erzeugnisse, geliefert bis vor die Tür.',
  hindi: 'पिलीफ इसे अपने ही खेतों में उगाता है: पारदर्शी स्रोत, ताज़ी उपज, आपके दरवाज़े तक।',
  indonesian: 'Pieleaf menanamnya di kebun kami sendiri: sumber transparan, hasil panen segar, diantar ke pintu Anda.',
  japanese: 'Pieleafは自社農場で育てています。透明な調達、新鮮な農産物をご自宅までお届けします。',
  korean: 'Pieleaf는 자사 농장에서 직접 재배합니다. 투명한 소싱, 신선한 농산물을 문 앞까지 배송합니다.',
  portuguese: 'A Pieleaf cultiva em fazendas próprias: origem transparente, produtos frescos, entregues à sua porta.',
  russian: 'Pieleaf выращивает это на собственных фермах: прозрачное происхождение, свежие продукты с доставкой до двери.',
  spanish: 'Pieleaf lo cultiva en sus propias granjas: origen transparente, productos frescos, entregados a tu puerta.',
  swahili: 'Pieleaf hulima katika mashamba yake mwenyewe: chanzo wazi, mazao mabichi, hufikishwa mlangoni pako.',
  vietnamese: 'Pieleaf trồng trên nông trại của chính mình: nguồn gốc minh bạch, nông sản tươi, giao tận cửa.',
};

export const howOrderingWorksTitle: Translation = {
  amharic: 'እንዴት ማዘዝ እንደሚቻል',
  arabic: 'كيف يتم الطلب',
  bengali: 'কীভাবে অর্ডার করবেন',
  chinese: '如何下单',
  english: 'How ordering works',
  estonian: 'Kuidas tellimine töötab',
  filipino: 'Paano Mag-order',
  french: 'Comment commander',
  german: 'So funktioniert die Bestellung',
  hindi: 'ऑर्डर कैसे करें',
  indonesian: 'Cara Memesan',
  japanese: 'ご注文の流れ',
  korean: '주문 방법',
  portuguese: 'Como pedir',
  russian: 'Как оформить заказ',
  spanish: 'Cómo pedir',
  swahili: 'Jinsi ya kuagiza',
  vietnamese: 'Cách đặt hàng',
};

export const stepBrowseTitle: Translation = {
  amharic: 'ያስሱ',
  arabic: 'تصفح',
  bengali: 'ব্রাউজ করুন',
  chinese: '浏览',
  english: 'Browse',
  estonian: 'Sirvi',
  filipino: 'Tingnan',
  french: 'Parcourir',
  german: 'Ansehen',
  hindi: 'ब्राउज़ करें',
  indonesian: 'Jelajahi',
  japanese: '選ぶ',
  korean: '둘러보기',
  portuguese: 'Ver',
  russian: 'Просмотр',
  spanish: 'Ver',
  swahili: 'Vinjari',
  vietnamese: 'Xem',
};

export const stepBrowseBody: Translation = {
  amharic: 'ከራሳችን እርሻዎች ትኩስ ኮኮዋ፣ ኮኮያም፣ ፓልም እና ሙዝ ያስሱ።',
  arabic: 'تصفح الكاكاو والكوكوياما والنخيل والموز الطازج من مزارعنا الخاصة.',
  bengali: 'আমাদের নিজস্ব খামার থেকে তাজা কোকো, কোকোয়াম, পাম এবং কলা দেখুন।',
  chinese: '浏览来自我们自有农场的新鲜可可、芋头、棕榈和车前草。',
  english: 'Browse fresh cocoa, cocoyam, palm, and plantain from our own farms.',
  estonian: 'Sirvi meie enda taludest pärit värsket kakaod, cocoyami, palmi ja jahubanaani.',
  filipino: 'Tingnan ang sariwang cocoa, cocoyam, palma, at saging mula sa sarili naming mga sakahan.',
  french: 'Parcourez le cacao, le cocoyam, le palmier et la banane plantain frais de nos propres fermes.',
  german: 'Entdecke frischen Kakao, Cocoyam, Palme und Kochbanane von unseren eigenen Höfen.',
  hindi: 'हमारे अपने खेतों से ताज़ा कोको, कोकोयाम, पाम और प्लांटेन ब्राउज़ करें।',
  indonesian: 'Jelajahi kakao, cocoyam, kelapa sawit, dan pisang tanduk segar dari kebun kami sendiri.',
  japanese: '自社農場から届く新鮮なカカオ、ココヤム、パーム、プランテンをご覧いただけます。',
  korean: '자사 농장에서 재배한 신선한 코코아, 코코얌, 팜, 플랜테인을 둘러보세요.',
  portuguese: 'Veja cacau, cocoyam, palma e banana-da-terra frescos das nossas próprias fazendas.',
  russian: 'Просмотрите свежее какао, кокояму, пальму и плантайн с наших собственных ферм.',
  spanish: 'Explora cacao, cocoyam, palma y plátano macho fresco de nuestras propias granjas.',
  swahili: 'Vinjari kakao, cocoyam, mchikichi, na ndizi mbichi kutoka mashamba yetu wenyewe.',
  vietnamese: 'Xem ca cao, khoai môn, cọ dầu và chuối lá tươi từ nông trại của chính chúng tôi.',
};

export const stepSelectTitle: Translation = {
  amharic: 'ይምረጡ',
  arabic: 'اختر',
  bengali: 'নির্বাচন করুন',
  chinese: '选择',
  english: 'Select',
  estonian: 'Vali',
  filipino: 'Pumili',
  french: 'Sélectionner',
  german: 'Auswählen',
  hindi: 'चुनें',
  indonesian: 'Pilih',
  japanese: '選択',
  korean: '선택',
  portuguese: 'Selecionar',
  russian: 'Выбрать',
  spanish: 'Seleccionar',
  swahili: 'Chagua',
  vietnamese: 'Chọn',
};

export const stepSelectBody: Translation = {
  amharic: 'ብዛት እና የማድረሻ ከተማዎን ይምረጡ።',
  arabic: 'اختر الكمية ومدينة التوصيل.',
  bengali: 'পরিমাণ এবং আপনার ডেলিভারি শহর নির্বাচন করুন।',
  chinese: '选择数量和配送城市。',
  english: 'Pick your quantity and delivery town.',
  estonian: 'Vali kogus ja tarnelinn.',
  filipino: 'Piliin ang dami at lungsod ng paghahatid.',
  french: 'Choisissez la quantité et la ville de livraison.',
  german: 'Wähle Menge und Lieferort.',
  hindi: 'अपनी मात्रा और डिलीवरी शहर चुनें।',
  indonesian: 'Pilih jumlah dan kota pengiriman.',
  japanese: '数量とお届け先の町を選択してください。',
  korean: '수량과 배송 지역을 선택하세요.',
  portuguese: 'Escolha a quantidade e a cidade de entrega.',
  russian: 'Выберите количество и город доставки.',
  spanish: 'Elige la cantidad y la ciudad de entrega.',
  swahili: 'Chagua kiasi na mji wa kusafirisha.',
  vietnamese: 'Chọn số lượng và thị trấn giao hàng.',
};

export const stepPayTitle: Translation = {
  amharic: 'ይክፈሉ',
  arabic: 'ادفع',
  bengali: 'পেমেন্ট করুন',
  chinese: '付款',
  english: 'Pay',
  estonian: 'Maksa',
  filipino: 'Magbayad',
  french: 'Payer',
  german: 'Bezahlen',
  hindi: 'भुगतान करें',
  indonesian: 'Bayar',
  japanese: '支払う',
  korean: '결제',
  portuguese: 'Pagar',
  russian: 'Оплатить',
  spanish: 'Pagar',
  swahili: 'Lipa',
  vietnamese: 'Thanh toán',
};

export const stepPayBody: Translation = {
  amharic: 'በሞባይል ገንዘብ በደህና ይክፈሉ።',
  arabic: 'ادفع بأمان عبر الأموال عبر الهاتف المحمول.',
  bengali: 'মোবাইল মানির মাধ্যমে নিরাপদে অর্থ প্রদান করুন।',
  chinese: '通过移动支付安全付款。',
  english: 'Pay securely with mobile money.',
  estonian: 'Maksa turvaliselt mobiilirahaga.',
  filipino: 'Magbayad nang ligtas gamit ang mobile money.',
  french: 'Payez en toute sécurité par mobile money.',
  german: 'Sicher per Mobile Money bezahlen.',
  hindi: 'मोबाइल मनी से सुरक्षित भुगतान करें।',
  indonesian: 'Bayar dengan aman menggunakan uang seluler.',
  japanese: 'モバイルマネーで安全にお支払いいただけます。',
  korean: '모바일 머니로 안전하게 결제하세요.',
  portuguese: 'Pague com segurança pelo mobile money.',
  russian: 'Оплатите безопасно через мобильные деньги.',
  spanish: 'Paga de forma segura con dinero móvil.',
  swahili: 'Lipa kwa usalama kwa pesa za simu.',
  vietnamese: 'Thanh toán an toàn bằng tiền di động.',
};

export const stepTrackTitle: Translation = {
  amharic: 'ይከታተሉ',
  arabic: 'تتبع',
  bengali: 'ট্র্যাক করুন',
  chinese: '追踪',
  english: 'Track',
  estonian: 'Jälgi',
  filipino: 'Subaybayan',
  french: 'Suivre',
  german: 'Verfolgen',
  hindi: 'ट्रैक करें',
  indonesian: 'Lacak',
  japanese: '追跡',
  korean: '추적',
  portuguese: 'Acompanhar',
  russian: 'Отследить',
  spanish: 'Rastrear',
  swahili: 'Fuatilia',
  vietnamese: 'Theo dõi',
};

export const stepTrackBody: Translation = {
  amharic: 'የትዕዛዝ ቁጥርዎን በመጠቀም ማድረሻውን ይከታተሉ።',
  arabic: 'تتبع التوصيل باستخدام رقم طلبك.',
  bengali: 'আপনার অর্ডার আইডি দিয়ে ডেলিভারি ট্র্যাক করুন।',
  chinese: '使用订单号追踪配送情况。',
  english: 'Track delivery using your order ID.',
  estonian: 'Jälgi tarnet oma tellimuse ID abil.',
  filipino: 'Subaybayan ang paghahatid gamit ang iyong order ID.',
  french: 'Suivez la livraison avec votre numéro de commande.',
  german: 'Verfolge die Lieferung mit deiner Bestellnummer.',
  hindi: 'अपनी ऑर्डर आईडी से डिलीवरी ट्रैक करें।',
  indonesian: 'Lacak pengiriman menggunakan ID pesanan Anda.',
  japanese: '注文IDで配送状況を確認できます。',
  korean: '주문 ID로 배송을 추적하세요.',
  portuguese: 'Acompanhe a entrega com o ID do seu pedido.',
  russian: 'Отслеживайте доставку по номеру заказа.',
  spanish: 'Rastrea la entrega con el ID de tu pedido.',
  swahili: 'Fuatilia usafirishaji kwa kutumia kitambulisho cha agizo lako.',
  vietnamese: 'Theo dõi giao hàng bằng mã đơn hàng của bạn.',
};

export const produceShowcaseTitle: Translation = {
  amharic: 'የምናምናቸው ምርቶች',
  arabic: 'ما نقدمه',
  bengali: 'আমরা যা সরবরাহ করি',
  chinese: '我们提供的产品',
  english: 'What we carry',
  estonian: 'Mida me pakume',
  filipino: 'Ang Aming Mga Produkto',
  french: 'Ce que nous proposons',
  german: 'Was wir führen',
  hindi: 'हम क्या पेश करते हैं',
  indonesian: 'Yang Kami Sediakan',
  japanese: '取り扱い品目',
  korean: '취급 품목',
  portuguese: 'O que oferecemos',
  russian: 'Что мы предлагаем',
  spanish: 'Lo que ofrecemos',
  swahili: 'Tunachouza',
  vietnamese: 'Sản phẩm chúng tôi cung cấp',
};

export const faqTitle: Translation = {
  amharic: 'ተደጋግመው የሚጠየቁ ጥያቄዎች',
  arabic: 'الأسئلة الشائعة',
  bengali: 'সচরাচর জিজ্ঞাসিত প্রশ্ন',
  chinese: '常见问题',
  english: 'Frequently asked questions',
  estonian: 'Korduma kippuvad küsimused',
  filipino: 'Mga Madalas Itanong',
  french: 'Questions fréquentes',
  german: 'Häufig gestellte Fragen',
  hindi: 'अक्सर पूछे जाने वाले प्रश्न',
  indonesian: 'Pertanyaan yang Sering Diajukan',
  japanese: 'よくある質問',
  korean: '자주 묻는 질문',
  portuguese: 'Perguntas frequentes',
  russian: 'Часто задаваемые вопросы',
  spanish: 'Preguntas frecuentes',
  swahili: 'Maswali yanayoulizwa mara kwa mara',
  vietnamese: 'Câu hỏi thường gặp',
};

export const faqPaymentQuestion: Translation = {
  amharic: 'ምን የመክፈያ ዘዴዎች ይቀበላሉ?',
  arabic: 'ما طرق الدفع التي تقبلونها؟',
  bengali: 'আপনারা কোন পেমেন্ট পদ্ধতি গ্রহণ করেন?',
  chinese: '你们接受哪些支付方式？',
  english: 'What payment methods do you accept?',
  estonian: 'Milliseid maksemeetodeid te aktsepteerite?',
  filipino: 'Anong mga paraan ng pagbabayad ang tinatanggap ninyo?',
  french: 'Quels moyens de paiement acceptez-vous ?',
  german: 'Welche Zahlungsmethoden akzeptiert ihr?',
  hindi: 'आप कौन से भुगतान तरीके स्वीकार करते हैं?',
  indonesian: 'Metode pembayaran apa yang Anda terima?',
  japanese: 'どのお支払い方法がご利用いただけますか？',
  korean: '어떤 결제 수단을 받나요?',
  portuguese: 'Quais métodos de pagamento vocês aceitam?',
  russian: 'Какие способы оплаты вы принимаете?',
  spanish: '¿Qué métodos de pago aceptan?',
  swahili: 'Mnakubali njia gani za malipo?',
  vietnamese: 'Bạn chấp nhận những phương thức thanh toán nào?',
};

export const faqPaymentAnswer: Translation = {
  amharic: 'በሞባይል ገንዘብ ይክፈላሉ። የሚገኙ የክፍያ ዘዴዎች ትዕዛዝ ሲያደርጉ ይታያሉ።',
  arabic: 'الدفع يتم عبر الأموال بالهاتف المحمول. تظهر طرق الدفع المتاحة عند إتمام الطلب.',
  bengali: 'পেমেন্ট মোবাইল মানির মাধ্যমে হয়। উপলব্ধ পেমেন্ট পদ্ধতি অর্ডার করার সময় দেখানো হয়।',
  chinese: '通过移动支付付款。可用的支付方式会在下单时显示。',
  english: 'Payment is by mobile money. The methods available to you are shown when you place your order.',
  estonian: 'Makse toimub mobiilirahaga. Saadaolevad makseviisid kuvatakse tellimuse vormistamisel.',
  filipino: 'Ang bayad ay sa pamamagitan ng mobile money. Makikita ang mga available na paraan kapag nag-order ka.',
  french: 'Le paiement se fait par mobile money. Les moyens disponibles vous sont présentés au moment de la commande.',
  german: 'Die Zahlung erfolgt per Mobile Money. Die verfügbaren Methoden werden dir bei der Bestellung angezeigt.',
  hindi: 'भुगतान मोबाइल मनी से होता है। उपलब्ध भुगतान विधियाँ ऑर्डर करते समय दिखाई जाती हैं।',
  indonesian: 'Pembayaran menggunakan uang seluler. Metode yang tersedia ditampilkan saat Anda memesan.',
  japanese: 'お支払いはモバイルマネーです。ご利用いただける方法はご注文時に表示されます。',
  korean: '결제는 모바일 머니로 진행됩니다. 이용 가능한 결제 수단은 주문 시 표시됩니다.',
  portuguese: 'O pagamento é feito por dinheiro móvel. Os métodos disponíveis são apresentados ao fazer o pedido.',
  russian: 'Оплата производится мобильными деньгами. Доступные способы отображаются при оформлении заказа.',
  spanish: 'El pago se realiza con dinero móvil. Los métodos disponibles se muestran al realizar el pedido.',
  swahili: 'Malipo hufanywa kwa pesa za simu. Njia zinazopatikana huonyeshwa unapoweka agizo.',
  vietnamese: 'Thanh toán bằng tiền di động. Các phương thức khả dụng sẽ hiển thị khi bạn đặt hàng.',
};

export const faqDeliveryQuestion: Translation = {
  amharic: 'ወደ የትኞቹ ከተሞች ያደርሳሉ?',
  arabic: 'إلى أي المدن توصلون؟',
  bengali: 'আপনারা কোন শহরে ডেলিভারি করেন?',
  chinese: '你们配送到哪些城市？',
  english: 'Which towns do you deliver to?',
  estonian: 'Millistesse linnadesse te tarnite?',
  filipino: 'Aling mga lungsod ang inyong hinahatiran?',
  french: 'Vers quelles villes livrez-vous ?',
  german: 'In welche Orte liefert ihr?',
  hindi: 'आप किन शहरों में डिलीवरी करते हैं?',
  indonesian: 'Kota mana saja yang Anda layani untuk pengiriman?',
  japanese: 'どちらの町へ配送していますか？',
  korean: '어느 지역까지 배송하나요?',
  portuguese: 'Para quais cidades vocês entregam?',
  russian: 'В какие города вы доставляете?',
  spanish: '¿A qué ciudades entregan?',
  swahili: 'Mnasafirisha kwa miji gani?',
  vietnamese: 'Bạn giao hàng đến những thị trấn nào?',
};

export const faqDeliveryAnswer: Translation = {
  amharic: 'የማድረሻ ከተማዎችዎ በትዕዛዝ ገጹ ላይ ይዘረዘራሉ፣ ገጹ ላይ ያለውን ከተማ ይምረጡ የሚገኙ ኤጀንሲዎችን ለማየት።',
  arabic: 'مدن التوصيل مدرجة في صفحة الطلب، اختر مدينتك لرؤية الوكالات المتاحة.',
  bengali: 'ডেলিভারি শহরগুলি অর্ডার পৃষ্ঠায় তালিকাভুক্ত, উপলব্ধ এজেন্সি দেখতে আপনার শহর নির্বাচন করুন।',
  chinese: '配送城市在下单页面列出，选择您的城市即可查看可用网点。',
  english: 'Delivery towns are listed on the order page, select yours to see available agencies.',
  estonian: 'Tarnelinnad on loetletud tellimuse lehel, vali oma linn, et näha saadaolevaid agentuure.',
  filipino: 'Nakalista ang mga lungsod ng paghahatid sa order page, piliin ang sa iyo para makita ang available na ahensya.',
  french: 'Les villes de livraison sont listées sur la page de commande, sélectionnez la vôtre pour voir les agences disponibles.',
  german: 'Die Lieferorte werden auf der Bestellseite angezeigt, wähle deinen Ort, um verfügbare Agenturen zu sehen.',
  hindi: 'डिलीवरी शहर ऑर्डर पेज पर सूचीबद्ध हैं, उपलब्ध एजेंसियां देखने के लिए अपना शहर चुनें।',
  indonesian: 'Kota pengiriman tercantum di halaman pesanan, pilih kota Anda untuk melihat agen yang tersedia.',
  japanese: 'お届け先の町はご注文ページに一覧表示されます。お住まいの町を選ぶと利用可能な代理店が表示されます。',
  korean: '배송 가능 지역은 주문 페이지에 나와 있습니다. 지역을 선택하면 이용 가능한 대리점을 볼 수 있습니다.',
  portuguese: 'As cidades de entrega estão listadas na página do pedido, selecione a sua para ver as agências disponíveis.',
  russian: 'Города доставки указаны на странице заказа, выберите свой город, чтобы увидеть доступные пункты.',
  spanish: 'Las ciudades de entrega figuran en la página del pedido, selecciona la tuya para ver las agencias disponibles.',
  swahili: 'Miji ya kusafirisha imeorodheshwa kwenye ukurasa wa agizo, chagua wako kuona mashirika yanayopatikana.',
  vietnamese: 'Các thị trấn giao hàng được liệt kê trên trang đặt hàng, chọn thị trấn của bạn để xem đại lý khả dụng.',
};

export const faqTrackingQuestion: Translation = {
  amharic: 'ትዕዛዜን እንዴት ማየት እችላለሁ?',
  arabic: 'كيف يمكنني تتبع طلبي؟',
  bengali: 'আমি কীভাবে আমার অর্ডার ট্র্যাক করব?',
  chinese: '如何追踪我的订单？',
  english: 'How do I track my order?',
  estonian: 'Kuidas ma saan oma tellimust jälgida?',
  filipino: 'Paano ko masusubaybayan ang aking order?',
  french: 'Comment suivre ma commande ?',
  german: 'Wie kann ich meine Bestellung verfolgen?',
  hindi: 'मैं अपना ऑर्डर कैसे ट्रैक करूं?',
  indonesian: 'Bagaimana cara melacak pesanan saya?',
  japanese: '注文はどのように追跡できますか？',
  korean: '주문을 어떻게 추적하나요?',
  portuguese: 'Como acompanho meu pedido?',
  russian: 'Как отследить мой заказ?',
  spanish: '¿Cómo rastreo mi pedido?',
  swahili: 'Ninawezaje kufuatilia agizo langu?',
  vietnamese: 'Làm sao để theo dõi đơn hàng của tôi?',
};

export const faqTrackingAnswer: Translation = {
  amharic: 'የትዕዛዝ ገጹ ላይ ያለውን መፈለጊያ በመጠቀም የትዕዛዝ ቁጥርዎን ያስገቡ።',
  arabic: 'أدخل رقم طلبك في مربع البحث على صفحة الطلبات.',
  bengali: 'অর্ডার পৃষ্ঠার সার্চ বক্স ব্যবহার করে আপনার অর্ডার আইডি লিখুন।',
  chinese: '在订单页面的搜索框中输入您的订单号。',
  english: 'Enter your order ID in the search box on the orders page.',
  estonian: 'Sisesta oma tellimuse ID tellimuste lehe otsingukasti.',
  filipino: 'Ilagay ang iyong order ID sa search box sa orders page.',
  french: 'Saisissez votre numéro de commande dans le champ de recherche de la page des commandes.',
  german: 'Gib deine Bestellnummer in das Suchfeld auf der Bestellseite ein.',
  hindi: 'ऑर्डर पेज के सर्च बॉक्स में अपनी ऑर्डर आईडी दर्ज करें।',
  indonesian: 'Masukkan ID pesanan Anda di kotak pencarian pada halaman pesanan.',
  japanese: 'ご注文ページの検索欄に注文IDを入力してください。',
  korean: '주문 페이지의 검색창에 주문 ID를 입력하세요.',
  portuguese: 'Digite o ID do seu pedido na caixa de busca da página de pedidos.',
  russian: 'Введите номер заказа в поле поиска на странице заказов.',
  spanish: 'Ingresa el ID de tu pedido en el cuadro de búsqueda de la página de pedidos.',
  swahili: 'Weka kitambulisho cha agizo lako kwenye kisanduku cha utafutaji kwenye ukurasa wa maagizo.',
  vietnamese: 'Nhập mã đơn hàng của bạn vào ô tìm kiếm trên trang đơn hàng.',
};

export const finalCtaTitle: Translation = {
  amharic: 'ዛሬ ትዕዛዝዎን ያድርጉ',
  arabic: 'اطلب اليوم',
  bengali: 'আজই অর্ডার করুন',
  chinese: '立即下单',
  english: 'Order today',
  estonian: 'Telli juba täna',
  filipino: 'Mag-order Ngayon',
  french: "Commandez aujourd'hui",
  german: 'Heute bestellen',
  hindi: 'आज ही ऑर्डर करें',
  indonesian: 'Pesan Hari Ini',
  japanese: '今すぐ注文',
  korean: '오늘 주문하기',
  portuguese: 'Peça hoje',
  russian: 'Заказать сегодня',
  spanish: 'Pide hoy',
  swahili: 'Agiza leo',
  vietnamese: 'Đặt hàng hôm nay',
};

export const footerTagline: Translation = {
  amharic: 'ከራሳችን እርሻዎች በቀጥታ ትኩስ ምርት።',
  arabic: 'منتجات طازجة مباشرة من مزارعنا الخاصة.',
  bengali: 'আমাদের নিজস্ব খামার থেকে সরাসরি তাজা ফসল।',
  chinese: '来自我们自有农场的新鲜产品，直达您手中。',
  english: 'Fresh produce, direct from our own farms.',
  estonian: 'Värske saadus otse meie enda taludest.',
  filipino: 'Sariwang ani, direkta mula sa sarili naming mga sakahan.',
  french: 'Des produits frais, directement de nos propres fermes.',
  german: 'Frische Erzeugnisse, direkt von unseren eigenen Höfen.',
  hindi: 'ताज़ी उपज, सीधे हमारे अपने खेतों से।',
  indonesian: 'Hasil panen segar, langsung dari kebun kami sendiri.',
  japanese: '自社農場からの新鮮な農産物。',
  korean: '자사 농장에서 직접 오는 신선한 농산물.',
  portuguese: 'Produtos frescos, direto das nossas próprias fazendas.',
  russian: 'Свежие продукты прямо с наших собственных ферм.',
  spanish: 'Productos frescos, directo de nuestras propias granjas.',
  swahili: 'Mazao mabichi, moja kwa moja kutoka mashamba yetu wenyewe.',
  vietnamese: 'Nông sản tươi, trực tiếp từ nông trại của chính chúng tôi.',
};

export const footerColProduce: Translation = {
  amharic: 'ምርት',
  arabic: 'المحاصيل',
  bengali: 'ফসল',
  chinese: '农产品',
  english: 'Produce',
  estonian: 'Saadus',
  filipino: 'Ani',
  french: 'Produits',
  german: 'Erzeugnisse',
  hindi: 'उपज',
  indonesian: 'Hasil Panen',
  japanese: '農産物',
  korean: '농산물',
  portuguese: 'Produtos',
  russian: 'Продукты',
  spanish: 'Productos',
  swahili: 'Mazao',
  vietnamese: 'Nông sản',
};

export const footerColLegal: Translation = {
  amharic: 'ህጋዊ',
  arabic: 'قانوني',
  bengali: 'আইনি',
  chinese: '法律',
  english: 'Legal',
  estonian: 'Õiguslik',
  filipino: 'Legal',
  french: 'Mentions légales',
  german: 'Rechtliches',
  hindi: 'कानूनी',
  indonesian: 'Hukum',
  japanese: '法的情報',
  korean: '법적 고지',
  portuguese: 'Jurídico',
  russian: 'Юридическая информация',
  spanish: 'Legal',
  swahili: 'Kisheria',
  vietnamese: 'Pháp lý',
};

export const legalEyebrow: Translation = {
  amharic: 'ህጋዊ',
  arabic: 'قانوني',
  bengali: 'আইনি',
  chinese: '法律',
  english: 'Legal',
  estonian: 'Õiguslik',
  filipino: 'Legal',
  french: 'Mentions légales',
  german: 'Rechtliches',
  hindi: 'कानूनी',
  indonesian: 'Hukum',
  japanese: '法的情報',
  korean: '법적 고지',
  portuguese: 'Jurídico',
  russian: 'Юридическая информация',
  spanish: 'Legal',
  swahili: 'Kisheria',
  vietnamese: 'Pháp lý',
};

export const heroClaimDirectTitle: Translation = {
  amharic: 'በቀጥታ ከእርሻዎች',
  arabic: 'مباشرة من المزارع',
  bengali: 'সরাসরি খামার থেকে',
  chinese: '直接来自农场',
  english: 'Direct from farms',
  estonian: 'Otse taludest',
  filipino: 'Direkta mula sa sakahan',
  french: 'Directement des fermes',
  german: 'Direkt vom Hof',
  hindi: 'सीधे खेतों से',
  indonesian: 'Langsung dari kebun',
  japanese: '農場から直接',
  korean: '농장에서 직접',
  portuguese: 'Direto das fazendas',
  russian: 'Напрямую с ферм',
  spanish: 'Directo de las granjas',
  swahili: 'Moja kwa moja kutoka mashambani',
  vietnamese: 'Trực tiếp từ nông trại',
};

export const heroClaimDirectBody: Translation = {
  amharic: 'በአብቃይና ገዢ መካከል ምንም መካከለኛ ሽፋን የለም።',
  arabic: 'لا توجد طبقة وسيطة بين المزارع والمشتري.',
  bengali: 'চাষী ও ক্রেতার মধ্যে কোনো মধ্যস্থ স্তর নেই।',
  chinese: '种植者与买家之间没有中间环节。',
  english: 'No middle layer between grower and buyer.',
  estonian: 'Kasvataja ja ostja vahel pole vahelüli.',
  filipino: 'Walang namamagitan sa magsasaka at mamimili.',
  french: 'Aucun intermédiaire entre le producteur et l’acheteur.',
  german: 'Keine Zwischenstufe zwischen Erzeuger und Käufer.',
  hindi: 'उत्पादक और खरीदार के बीच कोई बिचौलिया नहीं।',
  indonesian: 'Tanpa perantara antara petani dan pembeli.',
  japanese: '生産者と購入者の間に仲介はありません。',
  korean: '재배자와 구매자 사이에 중간 단계가 없습니다.',
  portuguese: 'Sem intermediários entre produtor e comprador.',
  russian: 'Никаких посредников между фермером и покупателем.',
  spanish: 'Sin intermediarios entre productor y comprador.',
  swahili: 'Hakuna mpatanishi kati ya mkulima na mnunuzi.',
  vietnamese: 'Không có khâu trung gian giữa người trồng và người mua.',
};

export const heroClaimPayTitle: Translation = {
  amharic: 'የሞባይል ገንዘብ',
  arabic: 'الأموال عبر الهاتف',
  bengali: 'মোবাইল মানি',
  chinese: '移动支付',
  english: 'Mobile money',
  estonian: 'Mobiiliraha',
  filipino: 'Mobile money',
  french: 'Paiement mobile',
  german: 'Mobile Money',
  hindi: 'मोबाइल मनी',
  indonesian: 'Uang seluler',
  japanese: 'モバイルマネー',
  korean: '모바일 머니',
  portuguese: 'Dinheiro móvel',
  russian: 'Мобильные деньги',
  spanish: 'Dinero móvil',
  swahili: 'Pesa za simu',
  vietnamese: 'Tiền di động',
};

export const heroClaimPayBody: Translation = {
  amharic: 'ከስልክዎ ይክፈሉ፣ ካርድ አያስፈልግም።',
  arabic: 'ادفع من هاتفك، دون الحاجة إلى بطاقة.',
  bengali: 'আপনার ফোন থেকে পেমেন্ট করুন, কার্ড লাগবে না।',
  chinese: '用手机付款，无需银行卡。',
  english: 'Pay from your phone, no card required.',
  estonian: 'Maksa telefonist, kaarti pole vaja.',
  filipino: 'Magbayad mula sa iyong telepono, walang card na kailangan.',
  french: 'Payez depuis votre téléphone, sans carte.',
  german: 'Zahle per Telefon, keine Karte nötig.',
  hindi: 'अपने फ़ोन से भुगतान करें, कार्ड की ज़रूरत नहीं।',
  indonesian: 'Bayar dari ponsel Anda, tanpa kartu.',
  japanese: 'カード不要、スマートフォンでお支払い。',
  korean: '카드 없이 휴대폰으로 결제하세요.',
  portuguese: 'Pague pelo telemóvel, sem cartão.',
  russian: 'Оплата с телефона, карта не нужна.',
  spanish: 'Paga desde tu teléfono, sin tarjeta.',
  swahili: 'Lipa kutoka simu yako, bila kadi.',
  vietnamese: 'Thanh toán từ điện thoại, không cần thẻ.',
};

export const heroClaimDeliveryTitle: Translation = {
  amharic: 'በከተማ ማድረስ',
  arabic: 'التوصيل حسب المدينة',
  bengali: 'শহর অনুযায়ী ডেলিভারি',
  chinese: '按城镇配送',
  english: 'Delivery by town',
  estonian: 'Tarne linna järgi',
  filipino: 'Paghahatid ayon sa bayan',
  french: 'Livraison par ville',
  german: 'Lieferung nach Ort',
  hindi: 'शहर के अनुसार डिलीवरी',
  indonesian: 'Pengiriman per kota',
  japanese: '町ごとの配送',
  korean: '지역별 배송',
  portuguese: 'Entrega por cidade',
  russian: 'Доставка по городам',
  spanish: 'Entrega por ciudad',
  swahili: 'Usafirishaji kwa mji',
  vietnamese: 'Giao hàng theo thị trấn',
};

export const heroClaimDeliveryBody: Translation = {
  amharic: 'ከተማዎን እና የመሰብሰቢያ ኤጀንሲዎን ይምረጡ።',
  arabic: 'اختر مدينتك ووكالة الاستلام.',
  bengali: 'আপনার শহর ও সংগ্রহ এজেন্সি বেছে নিন।',
  chinese: '选择您的城镇和取货网点。',
  english: 'Choose your town and collection agency.',
  estonian: 'Vali oma linn ja kogumisagentuur.',
  filipino: 'Piliin ang iyong bayan at ahensya ng koleksyon.',
  french: 'Choisissez votre ville et votre agence de retrait.',
  german: 'Wähle deinen Ort und die Abholstelle.',
  hindi: 'अपना शहर और संग्रह एजेंसी चुनें।',
  indonesian: 'Pilih kota dan agen pengambilan Anda.',
  japanese: 'お住まいの町と受取代理店を選択してください。',
  korean: '지역과 수령 대리점을 선택하세요.',
  portuguese: 'Escolha a sua cidade e agência de recolha.',
  russian: 'Выберите город и пункт выдачи.',
  spanish: 'Elige tu ciudad y agencia de recogida.',
  swahili: 'Chagua mji wako na wakala wa kukusanya.',
  vietnamese: 'Chọn thị trấn và đại lý nhận hàng của bạn.',
};

export const sourcingTitle: Translation = {
  amharic: 'ምንጭ',
  arabic: 'المصدر',
  bengali: 'উৎস',
  chinese: '来源',
  english: 'Sourcing',
  estonian: 'Hankimine',
  filipino: 'Pinagmulan',
  french: 'Approvisionnement',
  german: 'Herkunft',
  hindi: 'स्रोत',
  indonesian: 'Sumber',
  japanese: '調達',
  korean: '소싱',
  portuguese: 'Origem',
  russian: 'Источник',
  spanish: 'Origen',
  swahili: 'Chanzo',
  vietnamese: 'Nguồn cung',
};

export const sourcingNote: Translation = {
  amharic: 'አቅርቦት እንዴት እንደሚደርስዎ',
  arabic: 'كيف تصل الإمدادات إليك',
  bengali: 'সরবরাহ কীভাবে আপনার কাছে পৌঁছায়',
  chinese: '供应如何送达您手中',
  english: 'How supply reaches you',
  estonian: 'Kuidas tarne sinuni jõuab',
  filipino: 'Paano nakakarating sa iyo ang suplay',
  french: 'Comment l’approvisionnement vous parvient',
  german: 'Wie die Lieferung zu dir kommt',
  hindi: 'आपूर्ति आप तक कैसे पहुँचती है',
  indonesian: 'Bagaimana pasokan sampai kepada Anda',
  japanese: '供給が届くまで',
  korean: '공급이 전달되는 방식',
  portuguese: 'Como o fornecimento chega até si',
  russian: 'Как поставка доходит до вас',
  spanish: 'Cómo llega el suministro',
  swahili: 'Jinsi ugavi unavyokufikia',
  vietnamese: 'Nguồn cung đến với bạn thế nào',
};

export const sourcingDirectLabel: Translation = {
  amharic: 'ቀጥታ',
  arabic: 'مباشر',
  bengali: 'সরাসরি',
  chinese: '直接',
  english: 'Direct',
  estonian: 'Otse',
  filipino: 'Direkta',
  french: 'Direct',
  german: 'Direkt',
  hindi: 'सीधा',
  indonesian: 'Langsung',
  japanese: '直接',
  korean: '직접',
  portuguese: 'Direto',
  russian: 'Напрямую',
  spanish: 'Directo',
  swahili: 'Moja kwa moja',
  vietnamese: 'Trực tiếp',
};

export const sourcingDirectBody: Translation = {
  amharic: 'እያንዳንዱ ትዕዛዝ ከራሳችን እርሻዎች በአንዱ ላይ ይሰበሰባል፣ ያለ መካከለኛ ሽፋን።',
  arabic: 'كل طلب يُجنى في إحدى مزارعنا الخاصة، دون طبقة وسيطة.',
  bengali: 'প্রতিটি অর্ডার আমাদের নিজস্ব খামারের একটিতেই তোলা হয়, কোনো মধ্যস্থ ছাড়াই।',
  chinese: '每笔订单都在我们自有农场采摘，没有中间环节。',
  english: 'Every order is picked on one of our own farms, with no middle layer.',
  estonian: 'Iga tellimus korjatakse ühes meie enda talus, ilma vahelülita.',
  filipino: 'Bawat order ay inaani sa isa sa sarili naming mga sakahan, walang namamagitan.',
  french: 'Chaque commande est récoltée dans l’une de nos propres fermes, sans intermédiaire.',
  german: 'Jede Bestellung wird auf einem unserer eigenen Höfe geerntet, ohne Zwischenstufe.',
  hindi: 'हर ऑर्डर हमारे अपने खेतों में से एक पर तोड़ा जाता है, बिना किसी बिचौलिये के।',
  indonesian: 'Setiap pesanan dipanen di salah satu kebun kami sendiri, tanpa perantara.',
  japanese: 'すべての注文は自社農場のいずれかで収穫され、仲介はありません。',
  korean: '모든 주문은 자사 농장 중 한 곳에서 수확하며 중간 단계가 없습니다.',
  portuguese: 'Cada pedido é colhido em uma das nossas próprias fazendas, sem intermediários.',
  russian: 'Каждый заказ собирают на одной из наших собственных ферм, без посредников.',
  spanish: 'Cada pedido se recolecta en una de nuestras propias granjas, sin intermediarios.',
  swahili: 'Kila agizo huvunwa katika mojawapo ya mashamba yetu wenyewe, bila mpatanishi.',
  vietnamese: 'Mỗi đơn hàng được thu hoạch tại một trong các nông trại của chính chúng tôi, không qua trung gian.',
};

export const sourcingTransparentLabel: Translation = {
  amharic: 'ግልጽ',
  arabic: 'شفاف',
  bengali: 'স্বচ্ছ',
  chinese: '透明',
  english: 'Transparent',
  estonian: 'Läbipaistev',
  filipino: 'Malinaw',
  french: 'Transparent',
  german: 'Transparent',
  hindi: 'पारदर्शी',
  indonesian: 'Transparan',
  japanese: '透明',
  korean: '투명',
  portuguese: 'Transparente',
  russian: 'Прозрачно',
  spanish: 'Transparente',
  swahili: 'Wazi',
  vietnamese: 'Minh bạch',
};

export const sourcingTransparentBody: Translation = {
  amharic: 'ምንጭ የካታሎግ መስክ ነው፣ የግብይት ማስታወቂያ አይደለም።',
  arabic: 'المصدر حقل في الكتالوج، وليس ادعاءً تسويقياً.',
  bengali: 'উৎস ক্যাটালগের একটি তথ্য, বিপণন দাবি নয়।',
  chinese: '来源是目录中的一个字段，不是营销说辞。',
  english: 'Origin is a catalogue field, not a marketing claim.',
  estonian: 'Päritolu on kataloogi väli, mitte turundusväide.',
  filipino: 'Ang pinagmulan ay bahagi ng katalogo, hindi pang-marketing.',
  french: 'L’origine est une donnée du catalogue, pas un argument marketing.',
  german: 'Herkunft ist ein Katalogfeld, keine Marketingaussage.',
  hindi: 'मूल कैटलॉग का एक क्षेत्र है, कोई विपणन दावा नहीं।',
  indonesian: 'Asal adalah data katalog, bukan klaim pemasaran.',
  japanese: '産地はカタログの項目であり、宣伝文句ではありません。',
  korean: '원산지는 카탈로그 항목이며 마케팅 문구가 아닙니다.',
  portuguese: 'A origem é um campo do catálogo, não uma alegação de marketing.',
  russian: 'Происхождение: поле каталога, а не маркетинговое заявление.',
  spanish: 'El origen es un campo del catálogo, no una afirmación de marketing.',
  swahili: 'Chanzo ni sehemu ya katalogi, si dai la masoko.',
  vietnamese: 'Xuất xứ là một trường trong danh mục, không phải lời quảng cáo.',
};

export const sourcingLiveLabel: Translation = {
  amharic: 'ቀጥታ መረጃ',
  arabic: 'بيانات حية',
  bengali: 'সরাসরি তথ্য',
  chinese: '实时数据',
  english: 'Live data',
  estonian: 'Reaalajas andmed',
  filipino: 'Live na datos',
  french: 'Données en direct',
  german: 'Live-Daten',
  hindi: 'लाइव डेटा',
  indonesian: 'Data langsung',
  japanese: 'リアルタイムデータ',
  korean: '실시간 데이터',
  portuguese: 'Dados em tempo real',
  russian: 'Актуальные данные',
  spanish: 'Datos en vivo',
  swahili: 'Data hai',
  vietnamese: 'Dữ liệu trực tiếp',
};

export const sourcingLiveBody: Translation = {
  amharic: 'የካታሎግ ክምችት ከእርሻ መተግበሪያው እውነተኛ ምርትን ያንጸባርቃል።',
  arabic: 'مخزون الكتالوج يعكس الحصاد الفعلي من تطبيق المزرعة.',
  bengali: 'ক্যাটালগ স্টক খামার অ্যাপ থেকে প্রকৃত ফসল প্রতিফলিত করে।',
  chinese: '目录库存反映农场应用中的真实收成。',
  english: 'Catalogue stock reflects real harvests from the farm app.',
  estonian: 'Kataloogi laoseis kajastab talurakenduse tegelikku saaki.',
  filipino: 'Ang stock sa katalogo ay sumasalamin sa totoong ani mula sa farm app.',
  french: 'Le stock du catalogue reflète les récoltes réelles de l’application agricole.',
  german: 'Der Katalogbestand spiegelt echte Ernten aus der Farm-App wider.',
  hindi: 'कैटलॉग स्टॉक फ़ार्म ऐप से वास्तविक फ़सल दर्शाता है।',
  indonesian: 'Stok katalog mencerminkan panen nyata dari aplikasi pertanian.',
  japanese: 'カタログの在庫は農場アプリの実際の収穫を反映します。',
  korean: '카탈로그 재고는 농장 앱의 실제 수확을 반영합니다.',
  portuguese: 'O stock do catálogo reflete colheitas reais da app agrícola.',
  russian: 'Наличие в каталоге отражает реальный урожай из фермерского приложения.',
  spanish: 'El stock del catálogo refleja cosechas reales de la app agrícola.',
  swahili: 'Hisa ya katalogi inaonyesha mavuno halisi kutoka programu ya shamba.',
  vietnamese: 'Tồn kho danh mục phản ánh vụ thu hoạch thực từ ứng dụng nông trại.',
};

export const noAccountNeeded: Translation = {
  amharic: 'መለያ አያስፈልግም',
  arabic: 'لا حاجة لحساب',
  bengali: 'অ্যাকাউন্টের প্রয়োজন নেই',
  chinese: '无需账户',
  english: 'No account required',
  estonian: 'Kontot pole vaja',
  filipino: 'Walang kailangang account',
  french: 'Aucun compte requis',
  german: 'Kein Konto erforderlich',
  hindi: 'खाते की आवश्यकता नहीं',
  indonesian: 'Tidak perlu akun',
  japanese: 'アカウント不要',
  korean: '계정 불필요',
  portuguese: 'Não é necessária conta',
  russian: 'Аккаунт не нужен',
  spanish: 'No se necesita cuenta',
  swahili: 'Hakuna akaunti inayohitajika',
  vietnamese: 'Không cần tài khoản',
};

export const directFromFarmsNote: Translation = {
  amharic: 'በቀጥታ ከራሳችን እርሻዎች',
  arabic: 'مباشرة من مزارعنا الخاصة',
  bengali: 'সরাসরি আমাদের নিজস্ব খামার থেকে',
  chinese: '直接来自我们自有农场',
  english: 'Direct from our own farms',
  estonian: 'Otse meie enda taludest',
  filipino: 'Direkta mula sa sarili naming mga sakahan',
  french: 'Directement de nos propres fermes',
  german: 'Direkt von unseren eigenen Höfen',
  hindi: 'सीधे हमारे अपने खेतों से',
  indonesian: 'Langsung dari kebun kami sendiri',
  japanese: '自社農場から直接',
  korean: '자사 농장에서 직접',
  portuguese: 'Direto das nossas próprias fazendas',
  russian: 'Напрямую с наших собственных ферм',
  spanish: 'Directo de nuestras propias granjas',
  swahili: 'Moja kwa moja kutoka mashamba yetu wenyewe',
  vietnamese: 'Trực tiếp từ nông trại của chính chúng tôi',
};

export const ourProduceTitle: Translation = {
  amharic: 'የእኛ ምርት',
  arabic: 'منتجاتنا',
  bengali: 'আমাদের ফসল',
  chinese: '我们的农产品',
  english: 'Our produce',
  estonian: 'Meie saadused',
  filipino: 'Ang aming ani',
  french: 'Nos produits',
  german: 'Unsere Erzeugnisse',
  hindi: 'हमारी उपज',
  indonesian: 'Hasil panen kami',
  japanese: '取り扱い農産物',
  korean: '우리 농산물',
  portuguese: 'Os nossos produtos',
  russian: 'Наша продукция',
  spanish: 'Nuestros productos',
  swahili: 'Mazao yetu',
  vietnamese: 'Nông sản của chúng tôi',
};

export const ourProduceLede: Translation = {
  amharic: 'በራሳችን እርሻዎች ላይ የበቀለ፣ በከተማና በኤጀንሲ የሚደርስ።',
  arabic: 'مزروعة في مزارعنا الخاصة، وتُسلَّم حسب المدينة والوكالة.',
  bengali: 'আমাদের নিজস্ব খামারে চাষ করা, শহর ও এজেন্সি অনুযায়ী পৌঁছে দেওয়া।',
  chinese: '种植于我们自有农场，按城镇和网点配送。',
  english: 'Grown on our own farms, delivered by town and agency.',
  estonian: 'Kasvatatud meie enda taludes, tarnitud linna ja agentuuri kaupa.',
  filipino: 'Itinanim sa sarili naming mga sakahan, hinahatid ayon sa bayan at ahensya.',
  french: 'Cultivé dans nos propres fermes, livré par ville et agence.',
  german: 'Auf unseren eigenen Höfen angebaut, geliefert nach Ort und Agentur.',
  hindi: 'हमारे अपने खेतों में उगाया गया, शहर और एजेंसी के अनुसार वितरित।',
  indonesian: 'Ditanam di kebun kami sendiri, dikirim per kota dan agen.',
  japanese: '自社農場で栽培し、町と代理店ごとにお届けします。',
  korean: '자사 농장에서 재배하여 지역과 대리점별로 배송합니다.',
  portuguese: 'Cultivado nas nossas próprias fazendas, entregue por cidade e agência.',
  russian: 'Выращено на наших собственных фермах, доставка по городам и пунктам.',
  spanish: 'Cultivado en nuestras propias granjas, entregado por ciudad y agencia.',
  swahili: 'Yamelimwa katika mashamba yetu wenyewe, hufikishwa kwa mji na wakala.',
  vietnamese: 'Trồng tại nông trại của chính chúng tôi, giao theo thị trấn và đại lý.',
};

export const produceLineColumn: Translation = {
  amharic: 'የምርት መስመር',
  arabic: 'خط الإنتاج',
  bengali: 'ফসলের ধরন',
  chinese: '农产品类别',
  english: 'Produce line',
  estonian: 'Saaduse liin',
  filipino: 'Linya ng ani',
  french: 'Gamme de produits',
  german: 'Produktlinie',
  hindi: 'उपज श्रेणी',
  indonesian: 'Lini produk',
  japanese: '品目',
  korean: '품목',
  portuguese: 'Linha de produtos',
  russian: 'Линия продукции',
  spanish: 'Línea de productos',
  swahili: 'Aina ya mazao',
  vietnamese: 'Dòng nông sản',
};

export const unitColumn: Translation = {
  amharic: 'ክፍል',
  arabic: 'الوحدة',
  bengali: 'একক',
  chinese: '单位',
  english: 'Unit',
  estonian: 'Ühik',
  filipino: 'Yunit',
  french: 'Unité',
  german: 'Einheit',
  hindi: 'इकाई',
  indonesian: 'Satuan',
  japanese: '単位',
  korean: '단위',
  portuguese: 'Unidade',
  russian: 'Единица',
  spanish: 'Unidad',
  swahili: 'Kipimo',
  vietnamese: 'Đơn vị',
};

export const viewText: Translation = {
  amharic: 'ይመልከቱ',
  arabic: 'عرض',
  bengali: 'দেখুন',
  chinese: '查看',
  english: 'View',
  estonian: 'Vaata',
  filipino: 'Tingnan',
  french: 'Voir',
  german: 'Ansehen',
  hindi: 'देखें',
  indonesian: 'Lihat',
  japanese: '見る',
  korean: '보기',
  portuguese: 'Ver',
  russian: 'Смотреть',
  spanish: 'Ver',
  swahili: 'Angalia',
  vietnamese: 'Xem',
};

export const trackYourOrderTitle: Translation = {
  amharic: 'ትዕዛዝዎን ይከታተሉ',
  arabic: 'تتبع طلبك',
  bengali: 'আপনার অর্ডার ট্র্যাক করুন',
  chinese: '追踪您的订单',
  english: 'Track your order',
  estonian: 'Jälgi oma tellimust',
  filipino: 'Subaybayan ang iyong order',
  french: 'Suivez votre commande',
  german: 'Verfolge deine Bestellung',
  hindi: 'अपना ऑर्डर ट्रैक करें',
  indonesian: 'Lacak pesanan Anda',
  japanese: 'ご注文を追跡',
  korean: '주문 추적',
  portuguese: 'Acompanhe o seu pedido',
  russian: 'Отследите заказ',
  spanish: 'Rastrea tu pedido',
  swahili: 'Fuatilia agizo lako',
  vietnamese: 'Theo dõi đơn hàng',
};

export const trackYourOrderLede: Translation = {
  amharic: 'የማድረሻ ሁኔታን ለማየት በኤስኤምኤስ የላክንልዎትን የትዕዛዝ መለያ ያስገቡ።',
  arabic: 'أدخل رقم الطلب الذي أرسلناه إليك برسالة نصية لعرض حالة التوصيل.',
  bengali: 'ডেলিভারি স্ট্যাটাস দেখতে এসএমএসে পাঠানো অর্ডার আইডি লিখুন।',
  chinese: '输入我们通过短信发送的订单号以查看配送状态。',
  english: 'Enter the order ID we sent you by SMS to see delivery status.',
  estonian: 'Sisesta SMS-iga saadetud tellimuse ID, et näha tarne olekut.',
  filipino: 'Ilagay ang order ID na ipinadala namin sa SMS para makita ang status.',
  french: 'Saisissez le numéro de commande envoyé par SMS pour voir le statut.',
  german: 'Gib die per SMS gesendete Bestellnummer ein, um den Lieferstatus zu sehen.',
  hindi: 'डिलीवरी स्थिति देखने के लिए एसएमएस से भेजी गई ऑर्डर आईडी दर्ज करें।',
  indonesian: 'Masukkan ID pesanan yang kami kirim via SMS untuk melihat status.',
  japanese: 'SMSでお送りした注文IDを入力すると配送状況を確認できます。',
  korean: 'SMS로 보내드린 주문 ID를 입력하면 배송 상태를 확인할 수 있습니다.',
  portuguese: 'Introduza o ID do pedido enviado por SMS para ver o estado da entrega.',
  russian: 'Введите номер заказа из SMS, чтобы увидеть статус доставки.',
  spanish: 'Ingresa el ID del pedido que te enviamos por SMS para ver el estado.',
  swahili: 'Weka kitambulisho cha agizo tulichokutumia kwa SMS kuona hali ya usafirishaji.',
  vietnamese: 'Nhập mã đơn hàng chúng tôi gửi qua SMS để xem trạng thái giao hàng.',
};

export const faqAccountQuestion: Translation = {
  amharic: 'መለያ ያስፈልገኛል?',
  arabic: 'هل أحتاج إلى حساب؟',
  bengali: 'আমার কি অ্যাকাউন্ট দরকার?',
  chinese: '我需要账户吗？',
  english: 'Do I need an account?',
  estonian: 'Kas mul on vaja kontot?',
  filipino: 'Kailangan ko ba ng account?',
  french: 'Ai-je besoin d’un compte ?',
  german: 'Brauche ich ein Konto?',
  hindi: 'क्या मुझे खाता चाहिए?',
  indonesian: 'Apakah saya perlu akun?',
  japanese: 'アカウントは必要ですか？',
  korean: '계정이 필요한가요?',
  portuguese: 'Preciso de uma conta?',
  russian: 'Нужен ли аккаунт?',
  spanish: '¿Necesito una cuenta?',
  swahili: 'Je, ninahitaji akaunti?',
  vietnamese: 'Tôi có cần tài khoản không?',
};

export const faqAccountAnswer: Translation = {
  amharic: 'አያስፈልግም። ክፍያ በስልክ ቁጥር ነው፣ ምዝገባ አያስፈልግም።',
  arabic: 'لا. الدفع يتم برقم الهاتف، دون تسجيل.',
  bengali: 'না। চেকআউট ফোন নম্বর দিয়ে, সাইন-আপ লাগে না।',
  chinese: '不需要。结账使用手机号，无需注册。',
  english: 'No. Checkout is by phone number, no sign-up required.',
  estonian: 'Ei. Ostu vormistamine käib telefoninumbriga, registreerimist pole vaja.',
  filipino: 'Hindi. Ang checkout ay sa pamamagitan ng numero ng telepono, walang sign-up.',
  french: 'Non. Le paiement se fait par numéro de téléphone, sans inscription.',
  german: 'Nein. Die Bestellung läuft über die Telefonnummer, ohne Registrierung.',
  hindi: 'नहीं। चेकआउट फ़ोन नंबर से होता है, साइन-अप की ज़रूरत नहीं।',
  indonesian: 'Tidak. Checkout menggunakan nomor telepon, tanpa pendaftaran.',
  japanese: '不要です。電話番号でのご注文となり、登録は必要ありません。',
  korean: '아니요. 전화번호로 결제하며 가입이 필요 없습니다.',
  portuguese: 'Não. A compra é feita por número de telefone, sem registo.',
  russian: 'Нет. Оформление по номеру телефона, регистрация не нужна.',
  spanish: 'No. La compra se hace con número de teléfono, sin registro.',
  swahili: 'Hapana. Malipo hufanywa kwa namba ya simu, bila kujisajili.',
  vietnamese: 'Không. Thanh toán bằng số điện thoại, không cần đăng ký.',
};

export const footerColCompany: Translation = {
  amharic: 'ኩባንያ',
  arabic: 'الشركة',
  bengali: 'কোম্পানি',
  chinese: '公司',
  english: 'Company',
  estonian: 'Ettevõte',
  filipino: 'Kumpanya',
  french: 'Entreprise',
  german: 'Unternehmen',
  hindi: 'कंपनी',
  indonesian: 'Perusahaan',
  japanese: '会社情報',
  korean: '회사',
  portuguese: 'Empresa',
  russian: 'Компания',
  spanish: 'Empresa',
  swahili: 'Kampuni',
  vietnamese: 'Công ty',
};

export const footerColOrders: Translation = {
  amharic: 'ትዕዛዞች',
  arabic: 'الطلبات',
  bengali: 'অর্ডার',
  chinese: '订单',
  english: 'Orders',
  estonian: 'Tellimused',
  filipino: 'Mga order',
  french: 'Commandes',
  german: 'Bestellungen',
  hindi: 'ऑर्डर',
  indonesian: 'Pesanan',
  japanese: '注文',
  korean: '주문',
  portuguese: 'Pedidos',
  russian: 'Заказы',
  spanish: 'Pedidos',
  swahili: 'Maagizo',
  vietnamese: 'Đơn hàng',
};

export const footerCopyright: Translation = {
  amharic: '© {year} ፒሌፍ። መብቱ በሕግ የተጠበቀ ነው።',
  arabic: '© {year} بيليف. جميع الحقوق محفوظة.',
  bengali: '© {year} পিলিফ। সর্বস্বত্ব সংরক্ষিত।',
  chinese: '© {year} Pieleaf. 保留所有权利。',
  english: '© {year} Pieleaf. All rights reserved.',
  estonian: '© {year} Pieleaf. Kõik õigused kaitstud.',
  filipino: '© {year} Pieleaf. Nakalaan ang lahat ng karapatan.',
  french: '© {year} Pieleaf. Tous droits réservés.',
  german: '© {year} Pieleaf. Alle Rechte vorbehalten.',
  hindi: '© {year} Pieleaf. सर्वाधिकार सुरक्षित।',
  indonesian: '© {year} Pieleaf. Seluruh hak cipta dilindungi.',
  japanese: '© {year} Pieleaf. All rights reserved.',
  korean: '© {year} Pieleaf. All rights reserved.',
  portuguese: '© {year} Pieleaf. Todos os direitos reservados.',
  russian: '© {year} Pieleaf. Все права защищены.',
  spanish: '© {year} Pieleaf. Todos los derechos reservados.',
  swahili: '© {year} Pieleaf. Haki zote zimehifadhiwa.',
  vietnamese: '© {year} Pieleaf. Bảo lưu mọi quyền.',
};

export const allProduceText: Translation = {
  amharic: 'ሁሉም ምርት',
  arabic: 'كل المحاصيل',
  bengali: 'সব ফসল',
  chinese: '全部农产品',
  english: 'All produce',
  estonian: 'Kõik saadused',
  filipino: 'Lahat ng ani',
  french: 'Tous les produits',
  german: 'Alle Erzeugnisse',
  hindi: 'सभी उपज',
  indonesian: 'Semua hasil panen',
  japanese: 'すべての農産物',
  korean: '전체 농산물',
  portuguese: 'Todos os produtos',
  russian: 'Вся продукция',
  spanish: 'Todos los productos',
  swahili: 'Mazao yote',
  vietnamese: 'Tất cả nông sản',
};

export const unitPerKg: Translation = {
  amharic: 'በኪሎግራም',
  arabic: 'لكل كيلوغرام',
  bengali: 'প্রতি কেজি',
  chinese: '每公斤',
  english: 'Per kg',
  estonian: 'Kilogrammi kohta',
  filipino: 'Kada kilo',
  french: 'Au kilo',
  german: 'Pro kg',
  hindi: 'प्रति किलो',
  indonesian: 'Per kg',
  japanese: '1kgあたり',
  korean: 'kg당',
  portuguese: 'Por kg',
  russian: 'За кг',
  spanish: 'Por kg',
  swahili: 'Kwa kilo',
  vietnamese: 'Mỗi kg',
};

export const unitPerBag: Translation = {
  amharic: 'በከረጢት',
  arabic: 'لكل كيس',
  bengali: 'প্রতি ব্যাগ',
  chinese: '每袋',
  english: 'Per bag',
  estonian: 'Koti kohta',
  filipino: 'Kada sako',
  french: 'Au sac',
  german: 'Pro Sack',
  hindi: 'प्रति बोरी',
  indonesian: 'Per karung',
  japanese: '1袋あたり',
  korean: '자루당',
  portuguese: 'Por saco',
  russian: 'За мешок',
  spanish: 'Por saco',
  swahili: 'Kwa gunia',
  vietnamese: 'Mỗi bao',
};

export const unitPerLitre: Translation = {
  amharic: 'በሊትር',
  arabic: 'لكل لتر',
  bengali: 'প্রতি লিটার',
  chinese: '每升',
  english: 'Per litre',
  estonian: 'Liitri kohta',
  filipino: 'Kada litro',
  french: 'Au litre',
  german: 'Pro Liter',
  hindi: 'प्रति लीटर',
  indonesian: 'Per liter',
  japanese: '1Lあたり',
  korean: '리터당',
  portuguese: 'Por litro',
  russian: 'За литр',
  spanish: 'Por litro',
  swahili: 'Kwa lita',
  vietnamese: 'Mỗi lít',
};

export const unitPerBunch: Translation = {
  amharic: 'በዘለላ',
  arabic: 'لكل عنقود',
  bengali: 'প্রতি কাঁদি',
  chinese: '每串',
  english: 'Per bunch',
  estonian: 'Kobara kohta',
  filipino: 'Kada buwig',
  french: 'Au régime',
  german: 'Pro Staude',
  hindi: 'प्रति गुच्छा',
  indonesian: 'Per tandan',
  japanese: '1房あたり',
  korean: '한 송이당',
  portuguese: 'Por cacho',
  russian: 'За гроздь',
  spanish: 'Por racimo',
  swahili: 'Kwa mkungu',
  vietnamese: 'Mỗi buồng',
};

export const finalCtaBody: Translation = {
  amharic: 'ምርትዎን ይምረጡ፣ የማድረሻ ከተማና ኤጀንሲ ይምረጡ፣ ከስልክዎ ይክፈሉ። መለያ አያስፈልግም።',
  arabic: 'اختر محاصيلك ومدينة التوصيل والوكالة، وادفع من هاتفك. لا حاجة لحساب.',
  bengali: 'আপনার ফসল, ডেলিভারি শহর ও এজেন্সি বেছে নিন এবং ফোন থেকে পেমেন্ট করুন। অ্যাকাউন্ট লাগবে না।',
  chinese: '选择农产品、配送城镇和网点，用手机付款。无需账户。',
  english: 'Pick your produce, choose a delivery town and agency, and pay from your phone. No account needed.',
  estonian: 'Vali saadus, tarnelinn ja agentuur ning maksa telefonist. Kontot pole vaja.',
  filipino: 'Piliin ang ani, bayan at ahensya ng paghahatid, at magbayad mula sa telepono. Walang account na kailangan.',
  french: 'Choisissez vos produits, votre ville et agence de livraison, et payez depuis votre téléphone. Sans compte.',
  german: 'Wähle Erzeugnisse, Lieferort und Agentur und zahle per Telefon. Kein Konto nötig.',
  hindi: 'अपनी उपज, डिलीवरी शहर और एजेंसी चुनें, और फ़ोन से भुगतान करें। खाते की ज़रूरत नहीं।',
  indonesian: 'Pilih hasil panen, kota dan agen pengiriman, lalu bayar dari ponsel. Tanpa akun.',
  japanese: '農産物とお届け先の町・代理店を選び、スマートフォンでお支払い。アカウントは不要です。',
  korean: '농산물과 배송 지역·대리점을 고르고 휴대폰으로 결제하세요. 계정이 필요 없습니다.',
  portuguese: 'Escolha os produtos, a cidade e agência de entrega, e pague pelo telemóvel. Sem conta.',
  russian: 'Выберите продукты, город и пункт доставки и оплатите с телефона. Аккаунт не нужен.',
  spanish: 'Elige tus productos, ciudad y agencia de entrega, y paga desde tu teléfono. Sin cuenta.',
  swahili: 'Chagua mazao, mji na wakala wa usafirishaji, kisha lipa kutoka simu yako. Hakuna akaunti.',
  vietnamese: 'Chọn nông sản, thị trấn và đại lý giao hàng, rồi thanh toán từ điện thoại. Không cần tài khoản.',
};

export const navSecurity: Translation = {
  amharic: 'ደህንነት',
  arabic: 'الأمان',
  bengali: 'নিরাপত্তা',
  chinese: '安全',
  english: 'Security',
  estonian: 'Turvalisus',
  filipino: 'Seguridad',
  french: 'Sécurité',
  german: 'Sicherheit',
  hindi: 'सुरक्षा',
  indonesian: 'Keamanan',
  japanese: 'セキュリティ',
  korean: '보안',
  portuguese: 'Segurança',
  russian: 'Безопасность',
  spanish: 'Seguridad',
  swahili: 'Usalama',
  vietnamese: 'Bảo mật',
};

export const navGdpr: Translation = {
  amharic: 'GDPR',
  arabic: 'اللائحة العامة لحماية البيانات',
  bengali: 'GDPR',
  chinese: 'GDPR',
  english: 'GDPR',
  estonian: 'GDPR',
  filipino: 'GDPR',
  french: 'RGPD',
  german: 'DSGVO',
  hindi: 'GDPR',
  indonesian: 'GDPR',
  japanese: 'GDPR',
  korean: 'GDPR',
  portuguese: 'RGPD',
  russian: 'GDPR',
  spanish: 'RGPD',
  swahili: 'GDPR',
  vietnamese: 'GDPR',
};

export const navCookiePolicy: Translation = {
  amharic: 'የኩኪ ፖሊሲ',
  arabic: 'سياسة ملفات تعريف الارتباط',
  bengali: 'কুকি নীতি',
  chinese: 'Cookie 政策',
  english: 'Cookie policy',
  estonian: 'Küpsiste poliitika',
  filipino: 'Patakaran sa cookie',
  french: 'Politique relative aux cookies',
  german: 'Cookie-Richtlinie',
  hindi: 'कुकी नीति',
  indonesian: 'Kebijakan cookie',
  japanese: 'Cookieポリシー',
  korean: '쿠키 정책',
  portuguese: 'Política de cookies',
  russian: 'Политика использования файлов cookie',
  spanish: 'Política de cookies',
  swahili: 'Sera ya vidakuzi',
  vietnamese: 'Chính sách cookie',
};

export const securityPageTitle: Translation = {
  amharic: 'ደህንነት',
  arabic: 'الأمان',
  bengali: 'নিরাপত্তা',
  chinese: '安全',
  english: 'Security',
  estonian: 'Turvalisus',
  filipino: 'Seguridad',
  french: 'Sécurité',
  german: 'Sicherheit',
  hindi: 'सुरक्षा',
  indonesian: 'Keamanan',
  japanese: 'セキュリティ',
  korean: '보안',
  portuguese: 'Segurança',
  russian: 'Безопасность',
  spanish: 'Seguridad',
  swahili: 'Usalama',
  vietnamese: 'Bảo mật',
};

export const securityLastUpdated: Translation = {
  amharic: 'መጨረሻ የተዘመነው ነሐሴ 2, 2026',
  arabic: 'آخر تحديث في 2 أغسطس 2026',
  bengali: 'সর্বশেষ আপডেট ২ আগস্ট, ২০২৬',
  chinese: '最后更新于 2026 年 8 月 2 日',
  english: 'Last updated August 2, 2026',
  estonian: 'Viimati uuendatud 2. augustil 2026',
  filipino: 'Huling na-update noong Agosto 2, 2026',
  french: 'Dernière mise à jour le 2 août 2026',
  german: 'Zuletzt aktualisiert am 2. August 2026',
  hindi: 'अंतिम बार 2 अगस्त, 2026 को अपडेट किया गया',
  indonesian: 'Terakhir diperbarui 2 Agustus 2026',
  japanese: '最終更新日 2026年8月2日',
  korean: '2026년 8월 2일 최종 업데이트',
  portuguese: 'Atualizado pela última vez em 2 de agosto de 2026',
  russian: 'Последнее обновление 2 августа 2026 г.',
  spanish: 'Última actualización: 2 de agosto de 2026',
  swahili: 'Ilisasishwa mwisho Agosti 2, 2026',
  vietnamese: 'Cập nhật lần cuối ngày 2 tháng 8 năm 2026',
};

export const securityIntro: Translation = {
  amharic: 'Pieleaf ስልክ ቁጥር እና የሞባይል ገንዘብ በመጠቀም የእርሻ ምርቶችን እንዲያዙ ያስችልዎታል፣ መለያ ወይም መጠበቅ የሚያስፈልገው የይለፍ ቃል የለም። እኛ በእያንዳንዱ ደረጃ ትዕዛዝዎን እና መረጃዎን እንዴት እንደምንጠብቅ እነሆ።',
  arabic: 'يتيح لك Pieleaf طلب المنتجات الزراعية برقم هاتف والدفع عبر المحفظة الإلكترونية، دون حساب أو كلمة مرور تحتاج إلى حمايتها. إليك كيف نحمي طلبك وبياناتك في كل خطوة.',
  bengali: 'Pieleaf-এ আপনি ফোন নম্বর ও মোবাইল মানি দিয়ে খামারের ফসল অর্ডার করতে পারেন, কোনো অ্যাকাউন্ট বা রক্ষা করার মতো পাসওয়ার্ড লাগে না। প্রতিটি ধাপে আমরা কীভাবে আপনার অর্ডার ও তথ্য সুরক্ষিত রাখি, তা এখানে দেওয়া হলো।',
  chinese: 'Pieleaf 让您只需手机号码和移动支付即可订购农产品，无需账户，也没有密码需要保护。以下是我们在每一步如何保护您的订单和数据。',
  english: `Pieleaf lets you order farm produce with a phone number and mobile money, no account, no password to protect. Here's how we protect your order and your data at every step.`,
  estonian: 'Pieleaf võimaldab tellida talusaadusi telefoninumbri ja mobiilse makseviisiga, ilma kontota, ilma kaitsmist vajava paroolita. Siin on, kuidas me kaitseme sinu tellimust ja andmeid igas etapis.',
  filipino: 'Sa Pieleaf, maaari kang mag-order ng ani gamit lang ang numero ng telepono at mobile money, walang account, walang password na kailangang protektahan. Narito kung paano namin pinoprotektahan ang iyong order at datos sa bawat hakbang.',
  french: `Pieleaf vous permet de commander des produits agricoles avec un numéro de téléphone et le mobile money, sans compte ni mot de passe à protéger. Voici comment nous protégeons votre commande et vos données à chaque étape.`,
  german: 'Mit Pieleaf bestellst du landwirtschaftliche Erzeugnisse mit einer Telefonnummer und Mobile Money, kein Konto, kein Passwort zu schützen. So schützen wir deine Bestellung und deine Daten bei jedem Schritt.',
  hindi: 'Pieleaf से आप फ़ोन नंबर और मोबाइल मनी से खेत की उपज ऑर्डर कर सकते हैं, न कोई खाता, न सुरक्षित रखने के लिए कोई पासवर्ड। यहाँ बताया गया है कि हम हर कदम पर आपके ऑर्डर और आपके डेटा की सुरक्षा कैसे करते हैं।',
  indonesian: 'Pieleaf memungkinkan Anda memesan hasil pertanian hanya dengan nomor telepon dan uang elektronik (mobile money), tanpa akun, tanpa kata sandi yang perlu dilindungi. Berikut cara kami melindungi pesanan dan data Anda di setiap langkah.',
  japanese: 'Pieleafでは、電話番号とモバイルマネーだけで農産物を注文できます。アカウントも、守るべきパスワードもありません。ここでは、ご注文とデータをどのように保護しているかをご説明します。',
  korean: 'Pieleaf에서는 전화번호와 모바일 머니만으로 농산물을 주문할 수 있습니다. 계정도, 보호해야 할 비밀번호도 없습니다. 저희가 주문과 데이터를 단계마다 어떻게 보호하는지 안내해 드립니다.',
  portuguese: 'O Pieleaf permite que você peça produtos agrícolas com um número de telefone e dinheiro móvel, sem conta nem senha para proteger. Veja como protegemos o seu pedido e os seus dados em cada etapa.',
  russian: 'Pieleaf позволяет заказывать сельскохозяйственную продукцию по номеру телефона и с помощью мобильных денег, без учётной записи и пароля, которые нужно защищать. Вот как мы защищаем ваш заказ и ваши данные на каждом этапе.',
  spanish: 'Pieleaf te permite pedir productos agrícolas con un número de teléfono y dinero móvil, sin cuenta ni contraseña que proteger. Así protegemos tu pedido y tus datos en cada paso.',
  swahili: 'Pieleaf inakuruhusu kuagiza mazao ya shambani kwa nambari ya simu na pesa ya simu, hakuna akaunti, hakuna nenosiri la kulinda. Hivi ndivyo tunavyolinda oda yako na taarifa zako katika kila hatua.',
  vietnamese: 'Pieleaf cho phép bạn đặt nông sản chỉ bằng số điện thoại và ví điện tử di động, không cần tài khoản, không có mật khẩu nào phải bảo vệ. Đây là cách chúng tôi bảo vệ đơn hàng và dữ liệu của bạn ở mọi bước.',
};

export const securityDataHeading: Translation = {
  amharic: 'በመተላለፍ ላይ እና በማከማቻ ውስጥ ያለ የመረጃ ጥበቃ',
  arabic: 'حماية البيانات أثناء النقل والتخزين',
  bengali: 'ট্রানজিট ও সংরক্ষণে ডেটা সুরক্ষা',
  chinese: '传输和静态数据保护',
  english: 'Data protection in transit and at rest',
  estonian: 'Andmete kaitse edastamisel ja säilitamisel',
  filipino: 'Proteksyon ng datos habang naglalakbay at nakaimbak',
  french: 'Protection des données en transit et au repos',
  german: 'Datenschutz bei Übertragung und Speicherung',
  hindi: 'ट्रांज़िट और स्टोरेज में डेटा सुरक्षा',
  indonesian: 'Perlindungan data saat transit dan saat disimpan',
  japanese: '通信中および保存時のデータ保護',
  korean: '전송 중 및 저장 시 데이터 보호',
  portuguese: 'Proteção de dados em trânsito e em repouso',
  russian: 'Защита данных при передаче и хранении',
  spanish: 'Protección de datos en tránsito y en reposo',
  swahili: 'Ulinzi wa taarifa zikiwa njiani na zikiwa zimehifadhiwa',
  vietnamese: 'Bảo vệ dữ liệu khi truyền và khi lưu trữ',
};

export const securityDataBody: Translation = {
  amharic: 'በመሳሪያዎ እና በPieleaf መካከል ያለው እያንዳንዱ ግንኙነት በHTTPS/TLS የተመሰጠረ ነው፣ ስለዚህ የትዕዛዝዎ ዝርዝሮች በመተላለፍ ላይ ሊነበቡ አይችሉም። መረጃዎ በራሳችን የመረጃ ቋት ውስጥ ይቀመጣል፣ የተከማቸ መረጃ ይመሰጠራል መዳረሻውም ለተፈቀደላቸው ስርዓቶች ብቻ ይገደባል።',
  arabic: 'كل اتصال بين جهازك و Pieleaf مشفّر باستخدام HTTPS/TLS، بحيث لا يمكن قراءة تفاصيل طلبك أثناء النقل. تُخزَّن بياناتك في قاعدة البيانات الخاصة بنا، حيث تُشفَّر البيانات المخزنة ويقتصر الوصول إليها على الأنظمة المصرح لها فقط.',
  bengali: 'আপনার ডিভাইস ও Pieleaf-এর মধ্যে প্রতিটি সংযোগ HTTPS/TLS দিয়ে এনক্রিপ্ট করা থাকে, ফলে ট্রানজিটের সময় আপনার অর্ডারের তথ্য পড়া যায় না। আপনার তথ্য আমাদের নিজস্ব ডেটাবেসে সংরক্ষিত থাকে, যেখানে সংরক্ষিত তথ্য এনক্রিপ্ট করা হয় এবং শুধুমাত্র অনুমোদিত সিস্টেমে প্রবেশাধিকার সীমিত রাখা হয়।',
  chinese: '您的设备与 Pieleaf 之间的每一次连接都使用 HTTPS/TLS 加密，因此订单信息在传输过程中无法被读取。您的数据存储在我们自己的数据库中，静态数据经过加密，并仅限授权系统访问。',
  english: `Every connection between your device and Pieleaf is encrypted with HTTPS/TLS, so your order details can't be read in transit. Your data is stored in our own database, which encrypts data at rest and restricts access to authorized systems only.`,
  estonian: 'Iga ühendus sinu seadme ja Pieleafi vahel on krüptitud HTTPS/TLS-iga, nii et sinu tellimuse andmeid ei saa edastamise ajal lugeda. Sinu andmeid hoitakse meie enda andmebaasis, kus säilitatavad andmed on krüpteeritud ja juurdepääs on piiratud ainult volitatud süsteemidele.',
  filipino:
    'Bawat koneksyon sa pagitan ng iyong device at Pieleaf ay naka-encrypt gamit ang HTTPS/TLS, kaya hindi mababasa ang mga detalye ng iyong order habang ito ay naglalakbay. Ang iyong datos ay nakaimbak sa aming sariling database, na nag-e-encrypt ng datos na nakaimbak at naglilimita ng access sa mga awtorisadong sistema lamang.',
  french: `Chaque connexion entre votre appareil et Pieleaf est chiffrée avec HTTPS/TLS, afin que les détails de votre commande ne puissent pas être lus en transit. Vos données sont stockées dans notre propre base de données, qui chiffre les données au repos et restreint l'accès aux seuls systèmes autorisés.`,
  german:
    'Jede Verbindung zwischen deinem Gerät und Pieleaf ist mit HTTPS/TLS verschlüsselt, sodass deine Bestelldetails während der Übertragung nicht gelesen werden können. Deine Daten werden in unserer eigenen Datenbank gespeichert, die Daten im Ruhezustand verschlüsselt und den Zugriff auf autorisierte Systeme beschränkt.',
  hindi: 'आपके डिवाइस और Pieleaf के बीच हर कनेक्शन HTTPS/TLS से एन्क्रिप्ट किया गया है, इसलिए ट्रांज़िट के दौरान आपके ऑर्डर की जानकारी नहीं पढ़ी जा सकती। आपका डेटा हमारे अपने डेटाबेस में संग्रहीत किया जाता है, जो स्टोरेज में डेटा को एन्क्रिप्ट करता है और केवल अधिकृत सिस्टम तक ही पहुँच सीमित रखता है।',
  indonesian:
    'Setiap koneksi antara perangkat Anda dan Pieleaf dienkripsi dengan HTTPS/TLS, sehingga detail pesanan Anda tidak dapat dibaca saat transit. Data Anda disimpan dalam basis data milik kami sendiri, yang mengenkripsi data saat disimpan dan membatasi akses hanya untuk sistem yang berwenang.',
  japanese: 'お使いの端末とPieleaf間のすべての通信はHTTPS/TLSで暗号化されているため、ご注文情報が通信中に読み取られることはありません。データは当社自身のデータベースに保存され、保存時のデータは暗号化されたうえで、アクセスは許可されたシステムのみに制限されています。',
  korean: '사용자의 기기와 Pieleaf 간의 모든 연결은 HTTPS/TLS로 암호화되어 있어 전송 중에 주문 정보를 읽을 수 없습니다. 데이터는 저희가 직접 운영하는 데이터베이스에 저장되며, 저장된 데이터는 암호화되고 승인된 시스템만 접근할 수 있도록 제한됩니다.',
  portuguese:
    'Cada ligação entre o seu dispositivo e o Pieleaf é encriptada com HTTPS/TLS, para que os detalhes do seu pedido não possam ser lidos em trânsito. Os seus dados são armazenados na nossa própria base de dados, que encripta os dados em repouso e restringe o acesso apenas a sistemas autorizados.',
  russian:
    'Каждое соединение между вашим устройством и Pieleaf защищено шифрованием HTTPS/TLS, поэтому детали вашего заказа нельзя прочитать при передаче. Ваши данные хранятся в нашей собственной базе данных, которая шифрует данные при хранении и ограничивает доступ только авторизованным системам.',
  spanish: 'Cada conexión entre tu dispositivo y Pieleaf está cifrada con HTTPS/TLS, de modo que los detalles de tu pedido no se puedan leer en tránsito. Tus datos se almacenan en nuestra propia base de datos, que cifra los datos en reposo y restringe el acceso solo a sistemas autorizados.',
  swahili: 'Kila muunganisho kati ya kifaa chako na Pieleaf umesimbwa kwa HTTPS/TLS, hivyo maelezo ya oda yako hayawezi kusomwa yakiwa njiani. Taarifa zako huhifadhiwa katika hifadhidata yetu wenyewe, ambapo taarifa zilizohifadhiwa husimbwa na ufikiaji huzuiwa kwa mifumo iliyoidhinishwa pekee.',
  vietnamese:
    'Mọi kết nối giữa thiết bị của bạn và Pieleaf đều được mã hóa bằng HTTPS/TLS, vì vậy thông tin đơn hàng của bạn không thể bị đọc khi truyền đi. Dữ liệu của bạn được lưu trữ trong cơ sở dữ liệu của riêng chúng tôi, nơi dữ liệu được mã hóa khi lưu trữ và quyền truy cập chỉ giới hạn cho các hệ thống được ủy quyền.',
};

export const securityPaymentsHeading: Translation = {
  amharic: 'ክፍያዎች እንዴት እንደሚሠሩ',
  arabic: 'كيفية عمل المدفوعات',
  bengali: 'পেমেন্ট যেভাবে কাজ করে',
  chinese: '支付如何运作',
  english: 'How payments work',
  estonian: 'Kuidas maksed toimivad',
  filipino: 'Paano gumagana ang pagbabayad',
  french: 'Fonctionnement des paiements',
  german: 'So funktionieren Zahlungen',
  hindi: 'भुगतान कैसे काम करता है',
  indonesian: 'Cara kerja pembayaran',
  japanese: 'お支払いの仕組み',
  korean: '결제 방식',
  portuguese: 'Como funcionam os pagamentos',
  russian: 'Как работают платежи',
  spanish: 'Cómo funcionan los pagos',
  swahili: 'Jinsi malipo yanavyofanya kazi',
  vietnamese: 'Cách thức thanh toán hoạt động',
};

export const securityPaymentsBody: Translation = {
  amharic: 'ትዕዛዝ ሲከፍሉ፣ ግብይቱን ለማጽደቅ ወደ የሞባይል ገንዘብ አቅራቢዎ ይመራሉ። Pieleaf የሞባይል ገንዘብ ፒንዎን በፍጹም አያይም ወይም አያከማችም፣ እንዲሁም የካርድ ቁጥሮችን አንቀበልም ወይም አናከማችም። የክፍያ ማረጋገጫ ለእኛ የሚተላለፈው አቅራቢዎ ግብይቱን ካጸደቀ በኋላ ብቻ ነው።',
  arabic: 'عند دفع ثمن طلب، تتم إعادة توجيهك إلى مزود المحفظة الإلكترونية الخاص بك لتفويض المعاملة. لا يرى Pieleaf أو يخزّن رمز PIN الخاص بمحفظتك الإلكترونية أبدًا، ولا نقبل أو نخزّن أرقام البطاقات. لا يصلنا تأكيد الدفع إلا بعد موافقة مزودك على المعاملة.',
  bengali: 'আপনি যখন কোনো অর্ডারের জন্য অর্থ প্রদান করেন, তখন লেনদেন অনুমোদনের জন্য আপনাকে আপনার মোবাইল মানি প্রদানকারীর কাছে পুনঃনির্দেশিত করা হয়। Pieleaf কখনোই আপনার মোবাইল মানি পিন দেখে না বা সংরক্ষণ করে না, এবং আমরা কার্ড নম্বর গ্রহণ বা সংরক্ষণ করি না। প্রদানকারী লেনদেন অনুমোদন করার পরেই আমাদের কাছে পেমেন্ট নিশ্চিতকরণ পাঠানো হয়।',
  chinese: '支付订单时，您会被重定向到您的移动支付服务商以授权交易。Pieleaf 绝不会查看或存储您的移动支付 PIN 码，我们也不接受或存储银行卡号。只有在您的服务商批准交易后，支付确认信息才会返回给我们。',
  english: `When you pay for an order, you're redirected to your mobile money provider to authorize the transaction. Pieleaf never sees or stores your mobile money PIN, and we don't accept or store card numbers. Payment confirmation is passed back to us only after your provider has approved the transaction.`,
  estonian:
    'Kui maksad tellimuse eest, suunatakse sind tehingu autoriseerimiseks oma mobiilse makseteenuse pakkuja juurde. Pieleaf ei näe ega salvesta kunagi sinu mobiilse makse PIN-koodi ning me ei võta vastu ega salvesta kaardinumbreid. Maksekinnitus edastatakse meile alles pärast seda, kui su pakkuja on tehingu heaks kiitnud.',
  filipino:
    'Kapag nagbabayad ka para sa isang order, ire-redirect ka sa iyong mobile money provider upang pahintulutan ang transaksyon. Hindi kailanman nakikita o nag-iimbak ang Pieleaf ng iyong mobile money PIN, at hindi kami tumatanggap o nag-iimbak ng mga numero ng card. Ang kumpirmasyon ng bayad ay ipinapasa lang sa amin matapos aprubahan ng iyong provider ang transaksyon.',
  french: `Lorsque vous payez une commande, vous êtes redirigé vers votre opérateur de mobile money pour autoriser la transaction. Pieleaf ne voit ni ne stocke jamais votre code PIN de mobile money, et nous n'acceptons ni ne conservons de numéros de carte. La confirmation du paiement ne nous est transmise qu'après l'approbation de la transaction par votre opérateur.`,
  german:
    'Wenn du eine Bestellung bezahlst, wirst du zu deinem Mobile-Money-Anbieter weitergeleitet, um die Transaktion zu autorisieren. Pieleaf sieht oder speichert deine Mobile-Money-PIN niemals, und wir akzeptieren oder speichern keine Kartennummern. Die Zahlungsbestätigung wird uns erst übermittelt, nachdem dein Anbieter die Transaktion genehmigt hat.',
  hindi: 'जब आप किसी ऑर्डर का भुगतान करते हैं, तो लेन-देन को अधिकृत करने के लिए आपको आपके मोबाइल मनी प्रदाता के पास भेज दिया जाता है। Pieleaf कभी भी आपका मोबाइल मनी पिन नहीं देखता या संग्रहीत नहीं करता, और हम कार्ड नंबर स्वीकार या संग्रहीत नहीं करते। भुगतान की पुष्टि हमें तभी भेजी जाती है जब आपके प्रदाता ने लेन-देन को स्वीकृत कर दिया हो।',
  indonesian:
    'Saat Anda membayar pesanan, Anda akan diarahkan ke penyedia uang elektronik Anda untuk mengizinkan transaksi tersebut. Pieleaf tidak pernah melihat atau menyimpan PIN uang elektronik Anda, dan kami tidak menerima atau menyimpan nomor kartu. Konfirmasi pembayaran hanya diteruskan kepada kami setelah penyedia Anda menyetujui transaksi.',
  japanese: 'ご注文のお支払いの際は、取引を承認するためにご利用のモバイルマネー提供元にリダイレクトされます。Pieleafがお客様のモバイルマネーのPINコードを見たり保存したりすることは一切なく、カード番号の受け取りや保存も行いません。決済の確認は、提供元が取引を承認した後にのみ当社へ送られます。',
  korean: '주문 결제 시 거래를 승인하기 위해 모바일 머니 제공업체로 이동하게 됩니다. Pieleaf는 사용자의 모바일 머니 PIN을 절대 보거나 저장하지 않으며, 카드 번호도 수집하거나 저장하지 않습니다. 결제 확인은 제공업체가 거래를 승인한 이후에만 저희에게 전달됩니다.',
  portuguese:
    'Ao pagar um pedido, é redirecionado para o seu operador de dinheiro móvel para autorizar a transação. O Pieleaf nunca vê nem armazena o seu PIN de dinheiro móvel, e não aceitamos nem armazenamos números de cartão. A confirmação do pagamento só nos é transmitida depois de o seu operador ter aprovado a transação.',
  russian:
    'При оплате заказа вас перенаправляют к вашему оператору мобильных денег для подтверждения транзакции. Pieleaf никогда не видит и не сохраняет ваш PIN-код мобильных денег, и мы не принимаем и не храним номера карт. Подтверждение оплаты передаётся нам только после того, как ваш оператор одобрил транзакцию.',
  spanish:
    'Cuando pagas un pedido, se te redirige a tu proveedor de dinero móvil para autorizar la transacción. Pieleaf nunca ve ni almacena tu PIN de dinero móvil, y no aceptamos ni almacenamos números de tarjeta. La confirmación del pago solo nos llega después de que tu proveedor haya aprobado la transacción.',
  swahili: 'Unapolipia oda, unaelekezwa kwa mtoa huduma wako wa pesa ya simu ili kuidhinisha muamala. Pieleaf haioni wala kuhifadhi PIN yako ya pesa ya simu, na hatukubali wala kuhifadhi namba za kadi. Uthibitisho wa malipo hutumwa kwetu tu baada ya mtoa huduma wako kuidhinisha muamala.',
  vietnamese:
    'Khi bạn thanh toán cho một đơn hàng, bạn sẽ được chuyển đến nhà cung cấp ví điện tử di động để ủy quyền giao dịch. Pieleaf không bao giờ nhìn thấy hay lưu trữ mã PIN ví điện tử di động của bạn, và chúng tôi không nhận hay lưu trữ số thẻ. Xác nhận thanh toán chỉ được gửi lại cho chúng tôi sau khi nhà cung cấp của bạn đã phê duyệt giao dịch.',
};

export const securityPersonalDataHeading: Translation = {
  amharic: 'የስልክ ቁጥርዎ እና የግል መረጃዎ',
  arabic: 'رقم هاتفك وبياناتك الشخصية',
  bengali: 'আপনার ফোন নম্বর ও ব্যক্তিগত তথ্য',
  chinese: '您的电话号码与个人信息',
  english: 'Your phone number and personal data',
  estonian: 'Sinu telefoninumber ja isikuandmed',
  filipino: 'Ang iyong numero ng telepono at personal na datos',
  french: 'Votre numéro de téléphone et vos données personnelles',
  german: 'Deine Telefonnummer und persönlichen Daten',
  hindi: 'आपका फ़ोन नंबर और व्यक्तिगत डेटा',
  indonesian: 'Nomor telepon dan data pribadi Anda',
  japanese: 'お客様の電話番号と個人情報',
  korean: '고객님의 전화번호와 개인정보',
  portuguese: 'O seu número de telefone e dados pessoais',
  russian: 'Ваш номер телефона и личные данные',
  spanish: 'Tu número de teléfono y tus datos personales',
  swahili: 'Nambari yako ya simu na taarifa binafsi',
  vietnamese: 'Số điện thoại và dữ liệu cá nhân của bạn',
};

export const securityPersonalDataBody: Translation = {
  amharic: 'ግዢው ለእንግዳ ብቻ ስለሚደረግ፣ የምንይዘው የግል መረጃ ትዕዛዙ ለሚያስፈልገው ብቻ የተገደበ ነው፦ የስልክ ቁጥርዎ፣ የመላኪያ ከተማ እና ወኪል፣ እና ያዘዙት ምርት። ይህን መረጃ ትዕዛዝዎን ለማስፈጸም እና ስለ እሱ ለመገናኘት ብቻ እንጠቀማለን፣ ለሶስተኛ ወገኖችም አንሸጠውም።',
  arabic: 'بما أن الدفع يتم فقط كضيف، فإن البيانات الشخصية التي نحتفظ بها تقتصر على ما يحتاجه الطلب: رقم هاتفك، ومدينة ووكالة التسليم، والمنتجات التي طلبتها. نستخدم هذه المعلومات لتنفيذ طلبك والتواصل بشأنه، ولا نبيعها لأطراف ثالثة.',
  bengali: 'যেহেতু চেকআউট শুধু গেস্ট হিসেবেই করা যায়, তাই আমরা যে ব্যক্তিগত তথ্য রাখি তা কেবল অর্ডারের প্রয়োজনের মধ্যেই সীমাবদ্ধ: আপনার ফোন নম্বর, ডেলিভারি শহর ও এজেন্সি, এবং আপনার অর্ডার করা ফসল। আমরা এই তথ্য শুধুমাত্র আপনার অর্ডার সম্পন্ন করতে ও তা নিয়ে যোগাযোগ করতে ব্যবহার করি, এবং তৃতীয় পক্ষের কাছে বিক্রি করি না।',
  chinese: '由于结账仅支持访客模式，我们保存的个人信息仅限于订单所需内容：您的电话号码、配送城市和网点，以及您订购的农产品。我们使用这些信息来履行并沟通您的订单，且不会将其出售给第三方。',
  english: `Because checkout is guest-only, the personal data we hold is limited to what an order needs: your phone number, delivery city and agency, and the produce you ordered. We use this information to fulfill and communicate about your order, and we don't sell it to third parties.`,
  estonian:
    'Kuna ostu saab sooritada ainult külalisena, piirduvad meie hoitavad isikuandmed sellega, mida tellimus vajab: sinu telefoninumber, tarnelinn ja agentuur ning tellitud saadused. Kasutame seda teavet sinu tellimuse täitmiseks ja sellega seotud suhtluseks ega müü seda kolmandatele osapooltele.',
  filipino:
    'Dahil ang checkout ay guest-only, ang personal na datos na hawak namin ay limitado lamang sa kinakailangan ng order: ang iyong numero ng telepono, bayan at ahensya ng paghahatid, at ang aning iyong in-order. Ginagamit namin ang impormasyong ito upang tuparin at ipaalam ang tungkol sa iyong order, at hindi namin ito ibinebenta sa mga ikatlong partido.',
  french: `Comme le paiement se fait uniquement en tant qu'invité, les données personnelles que nous détenons se limitent à ce dont une commande a besoin : votre numéro de téléphone, votre ville et agence de livraison, et les produits commandés. Nous utilisons ces informations pour honorer votre commande et communiquer à son sujet, et nous ne les vendons pas à des tiers.`,
  german:
    'Da der Checkout nur als Gast erfolgt, beschränken sich die persönlichen Daten, die wir speichern, auf das, was eine Bestellung benötigt: deine Telefonnummer, Lieferort und Agentur sowie die bestellten Erzeugnisse. Wir verwenden diese Informationen, um deine Bestellung auszuführen und darüber zu kommunizieren, und verkaufen sie nicht an Dritte.',
  hindi: 'चूँकि चेकआउट केवल गेस्ट के रूप में होता है, हम जो व्यक्तिगत डेटा रखते हैं वह केवल उतना ही होता है जितना ऑर्डर के लिए ज़रूरी है: आपका फ़ोन नंबर, डिलीवरी शहर और एजेंसी, और आपके द्वारा ऑर्डर की गई उपज। हम इस जानकारी का उपयोग आपके ऑर्डर को पूरा करने और उसके बारे में संवाद करने के लिए करते हैं, और इसे तीसरे पक्ष को नहीं बेचते।',
  indonesian:
    'Karena checkout hanya tersedia sebagai tamu, data pribadi yang kami simpan terbatas pada apa yang dibutuhkan pesanan: nomor telepon Anda, kota dan agen pengiriman, serta hasil panen yang Anda pesan. Kami menggunakan informasi ini untuk memenuhi dan mengomunikasikan pesanan Anda, dan tidak menjualnya kepada pihak ketiga.',
  japanese: 'チェックアウトはゲスト限定であるため、当社が保有する個人情報は注文に必要な範囲に限られます。具体的には、電話番号、お届け先の町と代理店、ご注文いただいた農産物です。これらの情報はご注文の履行およびそれに関するご連絡のためにのみ使用し、第三者に販売することはありません。',
  korean: '결제는 비회원(게스트) 방식으로만 이루어지므로, 저희가 보유하는 개인정보는 주문에 필요한 범위로 한정됩니다: 전화번호, 배송 지역과 대리점, 그리고 주문한 농산물입니다. 이 정보는 주문 이행 및 관련 안내를 위해서만 사용하며, 제3자에게 판매하지 않습니다.',
  portuguese:
    'Como o checkout é apenas para convidados, os dados pessoais que guardamos limitam-se ao que um pedido precisa: o seu número de telefone, a cidade e agência de entrega, e os produtos que encomendou. Usamos esta informação para concretizar e comunicar sobre o seu pedido, e não a vendemos a terceiros.',
  russian:
    'Поскольку оформление заказа доступно только как гостю, личные данные, которые мы храним, ограничены тем, что необходимо для заказа: ваш номер телефона, город и пункт доставки, а также заказанная продукция. Мы используем эту информацию для выполнения заказа и связи с вами по его поводу и не продаём её третьим лицам.',
  spanish:
    'Como el pago se realiza únicamente como invitado, los datos personales que conservamos se limitan a lo que un pedido necesita: tu número de teléfono, la ciudad y agencia de entrega, y los productos que pediste. Usamos esta información para completar tu pedido y comunicarnos contigo al respecto, y no la vendemos a terceros.',
  swahili: 'Kwa kuwa malipo hufanyika kama mgeni pekee, taarifa binafsi tunazoshikilia ni zile tu zinazohitajika kwa oda: nambari yako ya simu, mji na wakala wa usafirishaji, na mazao uliyoagiza. Tunatumia taarifa hii kutimiza na kuwasiliana kuhusu oda yako, na hatuiuzi kwa wahusika wengine.',
  vietnamese:
    'Vì thanh toán chỉ dành cho khách vãng lai, dữ liệu cá nhân chúng tôi lưu giữ chỉ giới hạn ở những gì đơn hàng cần: số điện thoại, thành phố và đại lý giao hàng, cùng nông sản bạn đã đặt. Chúng tôi sử dụng thông tin này để hoàn tất và liên lạc về đơn hàng của bạn, và không bán nó cho bên thứ ba.',
};

export const securityAccessHeading: Translation = {
  amharic: 'የመዳረሻ ቁጥጥሮች',
  arabic: 'ضوابط الوصول',
  bengali: 'প্রবেশাধিকার নিয়ন্ত্রণ',
  chinese: '访问控制',
  english: 'Access controls',
  estonian: 'Juurdepääsu kontroll',
  filipino: 'Kontrol sa access',
  french: `Contrôles d'accès`,
  german: 'Zugriffskontrollen',
  hindi: 'एक्सेस नियंत्रण',
  indonesian: 'Kontrol akses',
  japanese: 'アクセス管理',
  korean: '접근 통제',
  portuguese: 'Controlos de acesso',
  russian: 'Контроль доступа',
  spanish: 'Controles de acceso',
  swahili: 'Udhibiti wa ufikiaji',
  vietnamese: 'Kiểm soát truy cập',
};

export const securityAccessBody: Translation = {
  amharic: 'እርሻዎች ዝርዝሮቻቸውን እና ትዕዛዝ አፈጻጸምን ለገዢዎች ከሚታየው መደብር ተለይቶ ለእነሱ በተዘጋጀ የተለየ መተግበሪያ በኩል ያስተዳድራሉ። ወደ ትዕዛዝ እና የደንበኛ መረጃ ውስጣዊ መዳረሻ Pieleafን ለማንቀሳቀስ ለሚያስፈልጋቸው ሰራተኞች ብቻ የተገደበ ነው።',
  arabic: 'تدير المزارع قوائمها وعمليات تنفيذ الطلبات من خلال تطبيق منفصل مصمم لها، منفصل عن واجهة المتجر الخاصة بالمشترين. يقتصر الوصول الداخلي إلى بيانات الطلبات والعملاء على الموظفين الذين يحتاجون إليه لتشغيل Pieleaf.',
  bengali: 'খামারগুলো ক্রেতা-মুখী স্টোরফ্রন্ট থেকে আলাদা, তাদের জন্য তৈরি একটি পৃথক অ্যাপের মাধ্যমে তাদের তালিকা ও অর্ডার পূরণ পরিচালনা করে। অর্ডার ও গ্রাহকের তথ্যে অভ্যন্তরীণ প্রবেশাধিকার শুধুমাত্র সেইসব কর্মীদের মধ্যে সীমাবদ্ধ, যাদের Pieleaf পরিচালনার জন্য এটি প্রয়োজন।',
  chinese: '农场通过专为其打造的独立应用管理商品上架和订单履行，该应用与面向买家的商城相互独立。订单和客户数据的内部访问权限仅限于运营 Pieleaf 所需的员工。',
  english: `Farms manage their listings and fulfillment through a separate app built for them, kept apart from the buyer-facing storefront. Internal access to order and customer data is limited to the staff who need it to operate Pieleaf.`,
  estonian: 'Talud haldavad oma kuulutusi ja tellimuste täitmist eraldi neile loodud rakenduse kaudu, mis on ostjatele mõeldud poest eraldatud. Sisemine juurdepääs tellimuste ja klientide andmetele on piiratud töötajatega, kes seda Pieleafi käitamiseks vajavad.',
  filipino:
    'Pinamamahalaan ng mga sakahan ang kanilang mga listahan at pagtupad ng order sa pamamagitan ng hiwalay na app na ginawa para sa kanila, hiwalay sa storefront na nakaharap sa mamimili. Ang internal na access sa datos ng order at customer ay limitado lamang sa mga kawani na nangangailangan nito upang paganahin ang Pieleaf.',
  french: `Les exploitations agricoles gèrent leurs annonces et l'exécution des commandes via une application distincte conçue pour elles, séparée de la vitrine destinée aux acheteurs. L'accès interne aux données des commandes et des clients est limité au personnel qui en a besoin pour faire fonctionner Pieleaf.`,
  german: 'Betriebe verwalten ihre Angebote und die Auftragsabwicklung über eine eigene, für sie entwickelte App, die von der käuferseitigen Storefront getrennt ist. Der interne Zugriff auf Bestell- und Kundendaten ist auf die Mitarbeitenden beschränkt, die ihn benötigen, um Pieleaf zu betreiben.',
  hindi: 'फार्म अपनी लिस्टिंग और ऑर्डर पूर्ति को खरीदार-केंद्रित स्टोरफ्रंट से अलग, उनके लिए बनाए गए एक अलग ऐप के माध्यम से प्रबंधित करते हैं। ऑर्डर और ग्राहक डेटा तक आंतरिक पहुँच केवल उन कर्मचारियों तक सीमित है जिन्हें Pieleaf चलाने के लिए इसकी आवश्यकता है।',
  indonesian: 'Pertanian mengelola daftar produk dan pemenuhan pesanan melalui aplikasi terpisah yang dibuat khusus untuk mereka, terpisah dari etalase yang menghadap pembeli. Akses internal ke data pesanan dan pelanggan dibatasi hanya untuk staf yang membutuhkannya guna mengoperasikan Pieleaf.',
  japanese: '各農場は、買い手向けのストアフロントとは切り離された専用アプリを通じて、出品情報と注文の履行を管理しています。注文情報や顧客情報への社内アクセスは、Pieleafの運営に必要なスタッフのみに限定されています。',
  korean: '농장은 구매자용 스토어와는 별도로 마련된 전용 앱을 통해 상품 목록과 주문 이행을 관리합니다. 주문 및 고객 데이터에 대한 내부 접근 권한은 Pieleaf 운영에 필요한 직원으로 한정됩니다.',
  portuguese: 'As quintas gerem os seus produtos e o cumprimento das encomendas através de uma aplicação separada, criada para elas, mantida à parte da montra voltada para o comprador. O acesso interno aos dados de encomendas e clientes é limitado à equipa que precisa dele para operar o Pieleaf.',
  russian: 'Фермерские хозяйства управляют своими товарами и выполнением заказов через отдельное приложение, созданное специально для них, отдельно от витрины для покупателей. Внутренний доступ к данным заказов и клиентов ограничен сотрудниками, которым он необходим для работы Pieleaf.',
  spanish: 'Las fincas gestionan sus productos y el cumplimiento de pedidos a través de una aplicación independiente creada para ellas, separada del escaparate orientado al comprador. El acceso interno a los datos de pedidos y clientes se limita al personal que lo necesita para operar Pieleaf.',
  swahili: 'Mashamba yanasimamia orodha zao na utimizaji wa oda kupitia programu tofauti iliyoundwa kwa ajili yao, tofauti na duka linalowakabili wanunuzi. Ufikiaji wa ndani wa taarifa za oda na wateja umezuiliwa kwa wafanyakazi wanaohitaji hiyo ili kuendesha Pieleaf.',
  vietnamese: 'Các nông trại quản lý danh sách sản phẩm và việc thực hiện đơn hàng qua một ứng dụng riêng được xây dựng cho họ, tách biệt với gian hàng dành cho người mua. Quyền truy cập nội bộ vào dữ liệu đơn hàng và khách hàng chỉ giới hạn cho nhân viên cần dùng để vận hành Pieleaf.',
};

export const securityResponsibilityHeading: Translation = {
  amharic: 'የጋራ ኃላፊነት',
  arabic: 'المسؤولية المشتركة',
  bengali: 'যৌথ দায়িত্ব',
  chinese: '共同责任',
  english: 'Shared responsibility',
  estonian: 'Jagatud vastutus',
  filipino: 'Ibinahaging responsibilidad',
  french: 'Responsabilité partagée',
  german: 'Geteilte Verantwortung',
  hindi: 'साझा ज़िम्मेदारी',
  indonesian: 'Tanggung jawab bersama',
  japanese: '責任の共有',
  korean: '책임 공유',
  portuguese: 'Responsabilidade partilhada',
  russian: 'Совместная ответственность',
  spanish: 'Responsabilidad compartida',
  swahili: 'Wajibu wa pamoja',
  vietnamese: 'Trách nhiệm chung',
};

export const securityResponsibilityBody: Translation = {
  amharic: 'Pieleafን የሚያንቀሳቅሱትን ስርዓቶች እኛ እንጠብቃለን። እርስዎ ስልክዎን እና የሞባይል ገንዘብ ፒንዎን ለራስዎ ብቻ በመያዝ፣ እና ፒንዎን የራስዎ አቅራቢ መተግበሪያ ወይም መልእክት ውስጥ ብቻ በማስገባት፣ Pieleaf ነኝ በሚል ገጽ ላይ በጭራሽ ሳይሆን፣ ትዕዛዝዎ ደህንነቱ የተጠበቀ እንዲሆን ይረዳሉ።',
  arabic: 'نحن نؤمّن الأنظمة التي تشغّل Pieleaf. وتساعد أنت في الحفاظ على أمان طلبك بالاحتفاظ بهاتفك ورمز PIN الخاص بمحفظتك الإلكترونية لنفسك، وبإدخال رمز PIN فقط داخل تطبيق أو رسالة مزودك الخاص، وليس أبدًا على صفحة تدّعي أنها Pieleaf.',
  bengali: 'Pieleaf-কে চালু রাখা সিস্টেমগুলো আমরা সুরক্ষিত রাখি। আপনি আপনার ফোন ও মোবাইল মানি পিন নিজের কাছে গোপন রেখে, এবং শুধুমাত্র আপনার প্রদানকারীর নিজস্ব অ্যাপ বা প্রম্পটে পিন প্রবেশ করিয়ে, কখনোই Pieleaf বলে দাবি করা কোনো পেজে নয়, আপনার অর্ডার সুরক্ষিত রাখতে সাহায্য করেন।',
  chinese: '我们负责保护支撑 Pieleaf 运行的系统。您可以通过妥善保管手机和移动支付 PIN 码，并且只在您所使用服务商自己的应用或提示中输入 PIN 码，绝不在任何自称是 Pieleaf 的页面上输入，来共同保障订单安全。',
  english: `We secure the systems that power Pieleaf. You help keep your order safe by keeping your phone and your mobile money PIN to yourself, and by only entering your mobile money PIN inside your provider's own app or prompt, never on a page claiming to be Pieleaf.`,
  estonian:
    'Meie tagame Pieleafi toimimiseks vajalike süsteemide turvalisuse. Sina aitad kaasa tellimuse turvalisusele, hoides oma telefoni ja mobiilse makse PIN-koodi ainult enda teada ning sisestades PIN-koodi ainult oma teenusepakkuja enda rakenduses või viibas, mitte kunagi lehel, mis väidab end olevat Pieleaf.',
  filipino:
    'Pinapanatili naming ligtas ang mga sistemang nagpapatakbo sa Pieleaf. Tumutulong ka sa kaligtasan ng iyong order sa pamamagitan ng pananatiling pribado ng iyong telepono at mobile money PIN, at sa paglalagay ng PIN sa loob lang ng sariling app o prompt ng iyong provider, hindi kailanman sa pahinang nagpapanggap na Pieleaf.',
  french: `Nous sécurisons les systèmes qui font fonctionner Pieleaf. Vous contribuez à la sécurité de votre commande en gardant votre téléphone et votre code PIN de mobile money pour vous, et en ne saisissant votre code PIN que dans l'application ou l'invite de votre propre opérateur, jamais sur une page prétendant être Pieleaf.`,
  german:
    'Wir sichern die Systeme, die Pieleaf antreiben. Du trägst zur Sicherheit deiner Bestellung bei, indem du dein Telefon und deine Mobile-Money-PIN für dich behältst und deine PIN nur in der App oder Eingabeaufforderung deines eigenen Anbieters eingibst, niemals auf einer Seite, die vorgibt, Pieleaf zu sein.',
  hindi: 'हम उन सिस्टम्स को सुरक्षित रखते हैं जो Pieleaf को चलाते हैं। आप अपना फ़ोन और अपना मोबाइल मनी पिन अपने पास सुरक्षित रखकर, और अपना पिन केवल अपने प्रदाता के अपने ऐप या प्रॉम्प्ट में दर्ज करके, कभी भी Pieleaf होने का दावा करने वाले किसी पेज पर नहीं, अपना ऑर्डर सुरक्षित रखने में मदद करते हैं।',
  indonesian:
    'Kami mengamankan sistem yang menjalankan Pieleaf. Anda membantu menjaga keamanan pesanan Anda dengan menjaga kerahasiaan ponsel dan PIN uang elektronik Anda, serta hanya memasukkan PIN di dalam aplikasi atau prompt milik penyedia Anda sendiri, tidak pernah di halaman yang mengaku sebagai Pieleaf.',
  japanese: 'Pieleafを支えるシステムの安全確保は当社が担っています。お客様は、ご自身の携帯電話とモバイルマネーのPINコードを他人に教えないこと、そしてPINコードはご利用のプロバイダー自身のアプリや画面でのみ入力し、Pieleafを名乗る画面では絶対に入力しないことで、ご注文の安全にご協力いただけます。',
  korean: '저희는 Pieleaf를 구동하는 시스템의 보안을 책임집니다. 고객님은 휴대폰과 모바일 머니 PIN을 본인만 알도록 지키고, PIN은 반드시 해당 제공업체 자체 앱이나 화면에서만 입력하여(Pieleaf를 사칭하는 페이지에서는 절대 입력하지 않음) 주문 보안을 함께 지켜주실 수 있습니다.',
  portuguese:
    'Nós protegemos os sistemas que fazem o Pieleaf funcionar. Você ajuda a manter o seu pedido seguro guardando o seu telefone e o seu PIN de dinheiro móvel só para si, e introduzindo o PIN apenas na aplicação ou na mensagem do seu próprio operador, nunca numa página que diga ser o Pieleaf.',
  russian:
    'Мы обеспечиваем безопасность систем, на которых работает Pieleaf. Вы помогаете обезопасить свой заказ, храня свой телефон и PIN-код мобильных денег при себе и вводя PIN-код только в приложении или подсказке своего собственного оператора, никогда на странице, которая выдаёт себя за Pieleaf.',
  spanish:
    'Nosotros protegemos los sistemas que hacen funcionar Pieleaf. Tú ayudas a mantener tu pedido seguro guardando tu teléfono y tu PIN de dinero móvil para ti mismo, e introduciendo tu PIN únicamente dentro de la app o el mensaje de tu propio proveedor, nunca en una página que diga ser Pieleaf.',
  swahili: 'Sisi tunalinda mifumo inayoendesha Pieleaf. Wewe unasaidia kulinda oda yako kwa kutunza simu yako na PIN yako ya pesa ya simu wewe mwenyewe, na kwa kuweka PIN yako ndani ya programu au ujumbe wa mtoa huduma wako pekee, kamwe si kwenye ukurasa unaodai kuwa Pieleaf.',
  vietnamese: 'Chúng tôi bảo mật các hệ thống vận hành Pieleaf. Bạn giúp bảo vệ đơn hàng của mình bằng cách giữ kín điện thoại và mã PIN ví điện tử di động của mình, và chỉ nhập mã PIN trong chính ứng dụng hoặc lời nhắc của nhà cung cấp của bạn, không bao giờ trên một trang tự nhận là Pieleaf.',
};

export const securityVulnerabilityHeading: Translation = {
  amharic: 'ተጋላጭነት ሪፖርት ያድርጉ',
  arabic: 'الإبلاغ عن ثغرة أمنية',
  bengali: 'একটি দুর্বলতা রিপোর্ট করুন',
  chinese: '报告安全漏洞',
  english: 'Report a vulnerability',
  estonian: 'Teata turvanõrkusest',
  filipino: 'Mag-ulat ng kahinaan',
  french: 'Signaler une vulnérabilité',
  german: 'Sicherheitslücke melden',
  hindi: 'किसी सुरक्षा खामी की रिपोर्ट करें',
  indonesian: 'Laporkan kerentanan',
  japanese: '脆弱性の報告',
  korean: '취약점 신고',
  portuguese: 'Reportar uma vulnerabilidade',
  russian: 'Сообщить об уязвимости',
  spanish: 'Reportar una vulnerabilidad',
  swahili: 'Ripoti udhaifu',
  vietnamese: 'Báo cáo lỗ hổng bảo mật',
};

export const securityVulnerabilityBody: Translation = {
  amharic: 'ከPieleaf ጋር የተያያዘ የደህንነት ችግር አግኝተዋል ብለው ካሰቡ፣ እባክዎ ዝርዝሮችን በኢሜይል ወደ {email} ይላኩልን፣ ምርመራ አድርገን እንድንመልስልዎ።',
  arabic: 'إذا كنت تعتقد أنك اكتشفت مشكلة أمنية في Pieleaf، يرجى إرسال بريد إلكتروني يحتوي على التفاصيل إلى {email} حتى نتمكن من التحقيق والرد.',
  bengali: 'যদি আপনি মনে করেন যে আপনি Pieleaf-এ কোনো নিরাপত্তা সমস্যা খুঁজে পেয়েছেন, তাহলে অনুগ্রহ করে বিস্তারিত জানিয়ে {email}-এ ইমেইল করুন, যাতে আমরা তদন্ত করে সাড়া দিতে পারি।',
  chinese: '如果您认为发现了 Pieleaf 的安全问题，请将详细信息发送邮件至 {email}，以便我们进行调查并回复。',
  english: `If you believe you've found a security issue with Pieleaf, please email {email} with details so we can investigate and respond.`,
  estonian: 'Kui arvad, et oled leidnud Pieleafiga seotud turvaprobleemi, saada palun üksikasjad e-kirjaga aadressile {email}, et saaksime seda uurida ja vastata.',
  filipino: 'Kung sa tingin mo ay nakahanap ka ng isyu sa seguridad sa Pieleaf, mangyaring mag-email ng mga detalye sa {email} upang maimbestigahan at masagot namin ito.',
  french: `Si vous pensez avoir découvert un problème de sécurité concernant Pieleaf, veuillez envoyer un e-mail avec les détails à {email} afin que nous puissions enquêter et vous répondre.`,
  german: 'Wenn du glaubst, ein Sicherheitsproblem bei Pieleaf gefunden zu haben, sende bitte eine E-Mail mit den Details an {email}, damit wir es untersuchen und antworten können.',
  hindi: 'यदि आपको लगता है कि आपको Pieleaf में कोई सुरक्षा समस्या मिली है, तो कृपया विवरण के साथ {email} पर ईमेल करें ताकि हम जांच कर सकें और जवाब दे सकें।',
  indonesian: 'Jika Anda yakin telah menemukan masalah keamanan pada Pieleaf, silakan kirim email berisi detailnya ke {email} agar kami dapat menyelidiki dan menanggapinya.',
  japanese: 'Pieleafにセキュリティ上の問題を発見されたと思われる場合は、詳細を{email}までメールでお送りください。調査のうえご返信いたします。',
  korean: 'Pieleaf에서 보안 문제를 발견하셨다고 생각되시면 {email}로 자세한 내용을 이메일로 보내주세요. 저희가 조사 후 답변드리겠습니다.',
  portuguese: 'Se acredita ter encontrado um problema de segurança no Pieleaf, envie um e-mail com os detalhes para {email} para que possamos investigar e responder.',
  russian: 'Если вы считаете, что обнаружили проблему безопасности в Pieleaf, пожалуйста, отправьте письмо с подробностями на {email}, чтобы мы могли расследовать и ответить.',
  spanish: 'Si crees que has encontrado un problema de seguridad en Pieleaf, envía los detalles por correo electrónico a {email} para que podamos investigar y responder.',
  swahili: 'Ikiwa unaamini umegundua tatizo la usalama katika Pieleaf, tafadhali tuma barua pepe yenye maelezo kwa {email} ili tuweze kuchunguza na kujibu.',
  vietnamese: 'Nếu bạn cho rằng mình đã phát hiện một vấn đề bảo mật liên quan đến Pieleaf, vui lòng gửi email kèm chi tiết đến {email} để chúng tôi có thể điều tra và phản hồi.',
};

export const gdprPageTitle: Translation = { ...navGdpr };

export const gdprMetaDescription: Translation = {
  amharic: 'Pieleaf ከEU አጠቃላይ የመረጃ ጥበቃ ደንብ ጋር እንዴት እንደሚስማማ።',
  arabic: 'كيف يمتثل Pieleaf للائحة العامة لحماية البيانات في الاتحاد الأوروبي.',
  bengali: 'Pieleaf কীভাবে EU সাধারণ ডেটা সুরক্ষা প্রবিধান মেনে চলে।',
  chinese: 'Pieleaf 如何遵守欧盟《通用数据保护条例》。',
  english: 'How Pieleaf complies with the EU General Data Protection Regulation.',
  estonian: 'Kuidas Pieleaf järgib ELi isikuandmete kaitse üldmäärust.',
  filipino: 'Paano sumusunod ang Pieleaf sa EU General Data Protection Regulation.',
  french: "Comment Pieleaf se conforme au Règlement général sur la protection des données de l'UE.",
  german: 'Wie Pieleaf die EU-Datenschutz-Grundverordnung einhält.',
  hindi: 'Pieleaf EU सामान्य डेटा संरक्षण विनियमन का अनुपालन कैसे करता है।',
  indonesian: 'Bagaimana Pieleaf mematuhi Peraturan Perlindungan Data Umum UE.',
  japanese: 'Pieleaf が EU の一般データ保護規則をどのように遵守しているか。',
  korean: 'Pieleaf가 EU 일반 개인정보 보호 규정을 준수하는 방법.',
  portuguese: 'Como o Pieleaf cumpre o Regulamento Geral de Proteção de Dados da UE.',
  russian: 'Как Pieleaf соблюдает Общий регламент ЕС по защите данных.',
  spanish: 'Cómo Pieleaf cumple con el Reglamento General de Protección de Datos de la UE.',
  swahili: 'Jinsi Pieleaf inavyozingatia Kanuni ya Jumla ya Ulinzi wa Data ya EU.',
  vietnamese: 'Cách Pieleaf tuân thủ Quy định Chung về Bảo vệ Dữ liệu của EU.',
};

export const gdprLastUpdated: Translation = {
  amharic: 'መጨረሻ የተዘመነው ነሐሴ 2, 2026',
  arabic: 'آخر تحديث في 2 أغسطس 2026',
  bengali: 'সর্বশেষ আপডেট ২ আগস্ট, ২০২৬',
  chinese: '最后更新于 2026 年 8 月 2 日',
  english: 'Last updated August 2, 2026',
  estonian: 'Viimati uuendatud 2. augustil 2026',
  filipino: 'Huling na-update noong Agosto 2, 2026',
  french: 'Dernière mise à jour le 2 août 2026',
  german: 'Zuletzt aktualisiert am 2. August 2026',
  hindi: 'अंतिम बार 2 अगस्त, 2026 को अपडेट किया गया',
  indonesian: 'Terakhir diperbarui 2 Agustus 2026',
  japanese: '最終更新日 2026年8月2日',
  korean: '2026년 8월 2일 최종 업데이트',
  portuguese: 'Atualizado pela última vez em 2 de agosto de 2026',
  russian: 'Последнее обновление 2 августа 2026 г.',
  spanish: 'Última actualización: 2 de agosto de 2026',
  swahili: 'Ilisasishwa mwisho Agosti 2, 2026',
  vietnamese: 'Cập nhật lần cuối ngày 2 tháng 8 năm 2026',
};

export const gdprIntro: Translation = {
  amharic: 'Pieleaf የEU እና UK ነዋሪዎችን በአጠቃላይ የመረጃ ጥበቃ ደንብ (GDPR) እና በUK GDPR ስር ይይዛል። ይህ ገጽ የትኞቹን የግል መረጃዎች እንደምንሰበስብ፣ ለምን እንደምንሰበስብ እና በእነሱ ላይ ያሉዎትን መብቶች ያጠቃልላል።',
  arabic: 'يتعامل Pieleaf مع المقيمين في الاتحاد الأوروبي والمملكة المتحدة وفق اللائحة العامة لحماية البيانات (GDPR) وGDPR للمملكة المتحدة. تلخّص هذه الصفحة البيانات الشخصية التي نجمعها، وسبب جمعها، والحقوق التي تتمتع بها بشأنها.',
  bengali: 'Pieleaf EU ও UK বাসিন্দাদের সাধারণ ডেটা সুরক্ষা প্রবিধান (GDPR) ও UK GDPR-এর অধীনে বিবেচনা করে। এই পৃষ্ঠা আমরা কোন ব্যক্তিগত ডেটা সংগ্রহ করি, কেন করি এবং তার উপর আপনার কী অধিকার আছে তা সংক্ষেপে তুলে ধরে।',
  chinese: 'Pieleaf 依据《通用数据保护条例》（GDPR）和英国 GDPR 对待欧盟和英国居民。本页概述我们收集哪些个人数据、为何收集，以及你对这些数据享有的权利。',
  english: 'Pieleaf treats EU and UK residents under the General Data Protection Regulation (GDPR) and UK GDPR. This page summarizes what personal data we collect, why we collect it, and the rights you have over it.',
  estonian: 'Pieleaf kohtleb ELi ja Ühendkuningriigi elanikke isikuandmete kaitse üldmääruse (GDPR) ja Ühendkuningriigi GDPR-i alusel. See leht võtab kokku, milliseid isikuandmeid me kogume, miks me neid kogume, ja millised õigused sul nende suhtes on.',
  filipino: 'Tinatrato ng Pieleaf ang mga residente ng EU at UK sa ilalim ng General Data Protection Regulation (GDPR) at UK GDPR. Binubuod ng pahinang ito kung anong personal na data ang kinokolekta namin, bakit namin ito kinokolekta, at ang mga karapatan mong meron dito.',
  french: "Pieleaf traite les résidents de l'UE et du Royaume-Uni conformément au Règlement général sur la protection des données (RGPD) et au RGPD britannique. Cette page résume les données personnelles que nous collectons, pourquoi nous les collectons, et les droits dont vous disposez.",
  german: 'Pieleaf behandelt Einwohner der EU und des Vereinigten Königreichs gemäß der Datenschutz-Grundverordnung (DSGVO) und der UK-DSGVO. Diese Seite fasst zusammen, welche personenbezogenen Daten wir erheben, warum wir sie erheben, und welche Rechte du daran hast.',
  hindi: 'Pieleaf EU और UK निवासियों को सामान्य डेटा संरक्षण विनियमन (GDPR) और UK GDPR के तहत मानता है। यह पेज बताता है कि हम कौन-सा व्यक्तिगत डेटा एकत्र करते हैं, क्यों करते हैं, और उस पर आपके पास कौन-से अधिकार हैं।',
  indonesian: 'Pieleaf memperlakukan penduduk UE dan Inggris di bawah Peraturan Perlindungan Data Umum (GDPR) dan UK GDPR. Halaman ini merangkum data pribadi apa yang kami kumpulkan, mengapa kami mengumpulkannya, dan hak yang Anda miliki atasnya.',
  japanese: 'Pieleaf は、EU および英国の居住者を一般データ保護規則（GDPR）および英国 GDPR の下で取り扱います。本ページは、当社が収集する個人データの内容、収集理由、そしてお客様が持つ権利をまとめたものです。',
  korean: 'Pieleaf는 EU 및 영국 거주자를 일반 개인정보 보호 규정(GDPR) 및 영국 GDPR에 따라 취급합니다. 이 페이지는 당사가 수집하는 개인정보, 수집 이유, 그리고 귀하가 가진 권리를 요약합니다.',
  portuguese: 'A Pieleaf trata residentes da UE e do Reino Unido sob o Regulamento Geral de Proteção de Dados (GDPR) e o UK GDPR. Esta página resume quais dados pessoais coletamos, por que os coletamos e os direitos que você tem sobre eles.',
  russian: 'Pieleaf обрабатывает данные жителей ЕС и Великобритании в соответствии с Общим регламентом по защите данных (GDPR) и UK GDPR. На этой странице кратко описано, какие персональные данные мы собираем, почему мы их собираем и какие права у вас есть в отношении них.',
  spanish: 'Pieleaf trata a los residentes de la UE y el Reino Unido conforme al Reglamento General de Protección de Datos (RGPD) y al RGPD del Reino Unido. Esta página resume qué datos personales recopilamos, por qué los recopilamos y los derechos que tienes sobre ellos.',
  swahili: 'Pieleaf huwashughulikia wakazi wa EU na UK chini ya Kanuni ya Jumla ya Ulinzi wa Data (GDPR) na UK GDPR. Ukurasa huu unafupisha data binafsi tunayokusanya, kwa nini tunaikusanya, na haki ulizonazo juu yake.',
  vietnamese: 'Pieleaf đối xử với cư dân EU và Vương quốc Anh theo Quy định Chung về Bảo vệ Dữ liệu (GDPR) và UK GDPR. Trang này tóm tắt dữ liệu cá nhân chúng tôi thu thập, lý do thu thập và các quyền bạn có đối với dữ liệu đó.',
};

export const gdprDataHeading: Translation = {
  amharic: 'የምንሰበስበው የግል መረጃ',
  arabic: 'البيانات الشخصية التي نجمعها',
  bengali: 'আমরা যে ব্যক্তিগত ডেটা সংগ্রহ করি',
  chinese: '我们收集的个人数据',
  english: 'Personal data we collect',
  estonian: 'Isikuandmed, mida kogume',
  filipino: 'Personal na data na kinokolekta namin',
  french: 'Données personnelles que nous collectons',
  german: 'Personenbezogene Daten, die wir erheben',
  hindi: 'हमारे द्वारा एकत्र किया गया व्यक्तिगत डेटा',
  indonesian: 'Data pribadi yang kami kumpulkan',
  japanese: '当社が収集する個人データ',
  korean: '당사가 수집하는 개인정보',
  portuguese: 'Dados pessoais que coletamos',
  russian: 'Персональные данные, которые мы собираем',
  spanish: 'Datos personales que recopilamos',
  swahili: 'Data binafsi tunayokusanya',
  vietnamese: 'Dữ liệu cá nhân chúng tôi thu thập',
};

export const gdprDataIntro: Translation = {
  amharic: 'በPieleaf ላይ ማዘዝ መለያ አያስፈልገውም። ትእዛዝን ለማስፈጸም የሚከተለውን እንሰበስባለን፦',
  arabic: 'الطلب على Pieleaf لا يتطلب حسابًا. لتنفيذ طلبك، نجمع:',
  bengali: 'Pieleaf-এ অর্ডার করতে কোনো অ্যাকাউন্ট লাগে না। অর্ডার সম্পন্ন করতে আমরা সংগ্রহ করি:',
  chinese: '在 Pieleaf 下单无需账户。为完成订单，我们收集：',
  english: 'Ordering on Pieleaf does not require an account. To fulfil an order, we collect:',
  estonian: 'Pieleafis tellimiseks pole kontot vaja. Tellimuse täitmiseks kogume:',
  filipino: 'Ang pag-order sa Pieleaf ay hindi nangangailangan ng account. Para matupad ang order, kinokolekta namin:',
  french: 'Commander sur Pieleaf ne nécessite pas de compte. Pour traiter votre commande, nous collectons :',
  german: 'Bestellungen bei Pieleaf erfordern kein Konto. Um deine Bestellung auszuführen, erheben wir:',
  hindi: 'Pieleaf पर ऑर्डर करने के लिए खाते की ज़रूरत नहीं है। ऑर्डर पूरा करने के लिए, हम एकत्र करते हैं:',
  indonesian: 'Memesan di Pieleaf tidak memerlukan akun. Untuk memenuhi pesanan, kami mengumpulkan:',
  japanese: 'Pieleaf でのご注文にアカウントは不要です。ご注文を処理するため、当社は以下を収集します。',
  korean: 'Pieleaf에서 주문하는 데 계정이 필요하지 않습니다. 주문을 처리하기 위해 당사는 다음을 수집합니다.',
  portuguese: 'Fazer pedidos na Pieleaf não exige uma conta. Para cumprir seu pedido, coletamos:',
  russian: 'Для заказа на Pieleaf аккаунт не нужен. Чтобы выполнить заказ, мы собираем:',
  spanish: 'Pedir en Pieleaf no requiere una cuenta. Para procesar tu pedido, recopilamos:',
  swahili: 'Kuagiza kwenye Pieleaf hakuhitaji akaunti. Ili kutimiza agizo, tunakusanya:',
  vietnamese: 'Đặt hàng trên Pieleaf không cần tài khoản. Để thực hiện đơn hàng, chúng tôi thu thập:',
};

export const gdprDataItemName: Translation = {
  amharic: 'ስምዎ',
  arabic: 'اسمك',
  bengali: 'আপনার নাম',
  chinese: '你的姓名',
  english: 'Your name',
  estonian: 'Sinu nimi',
  filipino: 'Ang iyong pangalan',
  french: 'Votre nom',
  german: 'Dein Name',
  hindi: 'आपका नाम',
  indonesian: 'Nama Anda',
  japanese: 'お名前',
  korean: '귀하의 이름',
  portuguese: 'Seu nome',
  russian: 'Ваше имя',
  spanish: 'Tu nombre',
  swahili: 'Jina lako',
  vietnamese: 'Tên của bạn',
};

export const gdprDataItemPhone: Translation = {
  amharic: 'የስልክ ቁጥርዎ',
  arabic: 'رقم هاتفك',
  bengali: 'আপনার ফোন নম্বর',
  chinese: '你的电话号码',
  english: 'Your phone number',
  estonian: 'Sinu telefoninumber',
  filipino: 'Ang iyong numero ng telepono',
  french: 'Votre numéro de téléphone',
  german: 'Deine Telefonnummer',
  hindi: 'आपका फोन नंबर',
  indonesian: 'Nomor telepon Anda',
  japanese: '電話番号',
  korean: '귀하의 전화번호',
  portuguese: 'Seu número de telefone',
  russian: 'Ваш номер телефона',
  spanish: 'Tu número de teléfono',
  swahili: 'Nambari yako ya simu',
  vietnamese: 'Số điện thoại của bạn',
};

export const gdprDataItemDelivery: Translation = {
  amharic: 'የማድረሻ ከተማዎ እና መረከቢያ ኤጀንሲዎ',
  arabic: 'مدينة التوصيل ووكالة الاستلام الخاصة بك',
  bengali: 'আপনার ডেলিভারি শহর ও সংগ্রহ এজেন্সি',
  chinese: '你的配送城镇和取货网点',
  english: 'Your delivery town and collection agency',
  estonian: 'Sinu tarnelinn ja väljastuspunkti agentuur',
  filipino: 'Ang iyong bayan ng paghahatid at ahensya ng pagkuha',
  french: 'Votre ville de livraison et votre agence de retrait',
  german: 'Dein Lieferort und deine Abholagentur',
  hindi: 'आपका डिलीवरी शहर और संग्रह एजेंसी',
  indonesian: 'Kota pengiriman dan agen pengambilan Anda',
  japanese: 'お届け先の町と受け取り代理店',
  korean: '배송 지역 및 수령 대리점',
  portuguese: 'Sua cidade de entrega e agência de coleta',
  russian: 'Ваш город доставки и пункт получения',
  spanish: 'Tu ciudad de entrega y agencia de recogida',
  swahili: 'Mji wako wa usafirishaji na wakala wa kuchukulia',
  vietnamese: 'Thị trấn giao hàng và đại lý nhận hàng của bạn',
};

export const gdprDataItemOrders: Translation = {
  amharic: 'የትዕዛዝ ታሪክዎ፣ የታዘዙ ዕቃዎችን እና የክፍያ ሁኔታን ጨምሮ',
  arabic: 'سجل طلباتك، بما في ذلك العناصر المطلوبة وحالة الدفع',
  bengali: 'আপনার অর্ডার ইতিহাস, অর্ডারকৃত আইটেম ও পেমেন্ট স্ট্যাটাসসহ',
  chinese: '你的订单历史，包括所订购的商品和付款状态',
  english: 'Your order history, including items ordered and payment status',
  estonian: 'Sinu tellimuste ajalugu, sh tellitud tooted ja makse olek',
  filipino: 'Ang iyong kasaysayan ng order, kabilang ang mga item na in-order at status ng bayad',
  french: 'Votre historique de commandes, y compris les articles commandés et le statut du paiement',
  german: 'Dein Bestellverlauf, einschließlich bestellter Artikel und Zahlungsstatus',
  hindi: 'आपका ऑर्डर इतिहास, जिसमें ऑर्डर किए गए आइटम और भुगतान की स्थिति शामिल है',
  indonesian: 'Riwayat pesanan Anda, termasuk barang yang dipesan dan status pembayaran',
  japanese: 'ご注文履歴（注文商品およびお支払い状況を含む）',
  korean: '주문 항목 및 결제 상태를 포함한 귀하의 주문 내역',
  portuguese: 'Seu histórico de pedidos, incluindo itens pedidos e status do pagamento',
  russian: 'История ваших заказов, включая заказанные товары и статус оплаты',
  spanish: 'Tu historial de pedidos, incluidos los artículos pedidos y el estado del pago',
  swahili: 'Historia yako ya maagizo, ikijumuisha bidhaa zilizoagizwa na hali ya malipo',
  vietnamese: 'Lịch sử đơn hàng của bạn, bao gồm các mặt hàng đã đặt và trạng thái thanh toán',
};

export const gdprLawfulBasesHeading: Translation = {
  amharic: 'ሕጋዊ መሠረቶች',
  arabic: 'الأسس القانونية',
  bengali: 'আইনি ভিত্তি',
  chinese: '合法依据',
  english: 'Lawful bases',
  estonian: 'Õiguslikud alused',
  filipino: 'Mga lawful basis',
  french: 'Bases légales',
  german: 'Rechtsgrundlagen',
  hindi: 'कानूनी आधार',
  indonesian: 'Dasar hukum',
  japanese: '適法な根拠',
  korean: '적법한 근거',
  portuguese: 'Bases legais',
  russian: 'Правовые основания',
  spanish: 'Bases legales',
  swahili: 'Misingi ya kisheria',
  vietnamese: 'Cơ sở pháp lý',
};

export const gdprBasisContractLabel: Translation = {
  amharic: 'የውል አፈጻጸም',
  arabic: 'تنفيذ العقد',
  bengali: 'চুক্তি পালন',
  chinese: '合同履行',
  english: 'Contract performance',
  estonian: 'Lepingu täitmine',
  filipino: 'Pagganap ng kontrata',
  french: 'Exécution du contrat',
  german: 'Vertragserfüllung',
  hindi: 'अनुबंध का निष्पादन',
  indonesian: 'Pelaksanaan kontrak',
  japanese: '契約の履行',
  korean: '계약 이행',
  portuguese: 'Execução do contrato',
  russian: 'Исполнение договора',
  spanish: 'Ejecución del contrato',
  swahili: 'Utekelezaji wa mkataba',
  vietnamese: 'Thực hiện hợp đồng',
};

export const gdprBasisContractBody: Translation = {
  amharic: 'ትዕዛዝዎን ለመቀበል፣ ወደ መረጡት ከተማ እና ኤጀንሲ ማድረሻ ለማዘጋጀት እና የሞባይል ገንዘብ ክፍያዎን ለማስኬድ',
  arabic: 'لاستلام طلبك، وترتيب التوصيل إلى المدينة والوكالة التي اخترتها، ومعالجة دفعتك عبر الأموال المتنقلة',
  bengali: 'আপনার অর্ডার নিতে, আপনার পছন্দের শহর ও এজেন্সিতে ডেলিভারি ব্যবস্থা করতে এবং আপনার মোবাইল মানি পেমেন্ট প্রক্রিয়া করতে',
  chinese: '用于接收你的订单、安排送达你选择的城镇和网点，以及处理你的移动支付',
  english: 'to take your order, arrange delivery to your chosen town and agency, and process your mobile money payment',
  estonian: 'sinu tellimuse vastuvõtmiseks, tarne korraldamiseks sinu valitud linna ja agentuuri ning mobiilimakse töötlemiseks',
  filipino: 'para kunin ang iyong order, ayusin ang paghahatid sa napili mong bayan at ahensya, at iproseso ang iyong bayad sa mobile money',
  french: 'pour prendre votre commande, organiser la livraison vers la ville et l’agence de votre choix, et traiter votre paiement mobile',
  german: 'um deine Bestellung entgegenzunehmen, die Lieferung an den von dir gewählten Ort und die Agentur zu organisieren und deine Mobile-Money-Zahlung zu verarbeiten',
  hindi: 'आपका ऑर्डर लेने, आपके चुने हुए शहर और एजेंसी तक डिलीवरी की व्यवस्था करने, और आपके मोबाइल मनी भुगतान को प्रोसेस करने के लिए',
  indonesian: 'untuk menerima pesanan Anda, mengatur pengiriman ke kota dan agen pilihan Anda, dan memproses pembayaran uang seluler Anda',
  japanese: 'ご注文を受け付け、選択された町・代理店への配送を手配し、モバイルマネーでのお支払いを処理するため',
  korean: '주문을 접수하고, 선택하신 지역과 대리점으로 배송을 준비하며, 모바일 머니 결제를 처리하기 위해',
  portuguese: 'para receber seu pedido, organizar a entrega na cidade e agência escolhidas e processar seu pagamento por dinheiro móvel',
  russian: 'чтобы принять ваш заказ, организовать доставку в выбранный вами город и пункт получения, а также обработать ваш платеж через мобильные деньги',
  spanish: 'para tomar tu pedido, organizar la entrega en la ciudad y agencia elegidas, y procesar tu pago por dinero móvil',
  swahili: 'kupokea agizo lako, kupanga usafirishaji hadi mji na wakala uliouchagua, na kuchakata malipo yako ya pesa za simu',
  vietnamese: 'để nhận đơn hàng của bạn, sắp xếp giao hàng đến thị trấn và đại lý bạn chọn, và xử lý thanh toán tiền di động của bạn',
};

export const gdprBasisLegitimateLabel: Translation = {
  amharic: 'ሕጋዊ ጥቅም',
  arabic: 'المصلحة المشروعة',
  bengali: 'বৈধ স্বার্থ',
  chinese: '正当利益',
  english: 'Legitimate interest',
  estonian: 'Õigustatud huvi',
  filipino: 'Lehitimong interes',
  french: 'Intérêt légitime',
  german: 'Berechtigtes Interesse',
  hindi: 'वैध हित',
  indonesian: 'Kepentingan sah',
  japanese: '正当な利益',
  korean: '정당한 이익',
  portuguese: 'Interesse legítimo',
  russian: 'Законный интерес',
  spanish: 'Interés legítimo',
  swahili: 'Maslahi halali',
  vietnamese: 'Lợi ích hợp pháp',
};

export const gdprBasisLegitimateBody: Translation = {
  amharic: 'አገልግሎቱን ለማንቀሳቀስ እና ለማስጠበቅ፣ ማጭበርበርን ለመከላከል እና ትዕዛዞች እንዴት እንደሚፈጸሙ ለማሻሻል',
  arabic: 'لتشغيل الخدمة وتأمينها، ومنع الاحتيال، وتحسين كيفية تنفيذ الطلبات',
  bengali: 'পরিষেবা পরিচালনা ও সুরক্ষিত রাখতে, জালিয়াতি প্রতিরোধ করতে এবং অর্ডার সম্পন্ন করার পদ্ধতি উন্নত করতে',
  chinese: '用于运营和保护服务、防止欺诈，以及改进订单履行方式',
  english: 'to operate and secure the service, prevent fraud, and improve how orders are fulfilled',
  estonian: 'teenuse käitamiseks ja turvamiseks, pettuste ennetamiseks ning tellimuste täitmise parandamiseks',
  filipino: 'para patakbuhin at protektahan ang serbisyo, maiwasan ang panloloko, at mapabuti kung paano natutupad ang mga order',
  french: 'pour exploiter et sécuriser le service, prévenir la fraude et améliorer la manière dont les commandes sont traitées',
  german: 'um den Dienst zu betreiben und abzusichern, Betrug zu verhindern und die Auftragsabwicklung zu verbessern',
  hindi: 'सेवा को संचालित और सुरक्षित करने, धोखाधड़ी रोकने, और ऑर्डर पूरे किए जाने के तरीके को बेहतर बनाने के लिए',
  indonesian: 'untuk mengoperasikan dan mengamankan layanan, mencegah penipuan, dan meningkatkan cara pesanan dipenuhi',
  japanese: 'サービスの運営と保護、不正防止、および注文処理方法の改善のため',
  korean: '서비스를 운영하고 보호하며, 사기를 방지하고, 주문 처리 방식을 개선하기 위해',
  portuguese: 'para operar e proteger o serviço, prevenir fraudes e melhorar a forma como os pedidos são cumpridos',
  russian: 'для работы и защиты сервиса, предотвращения мошенничества и улучшения процесса выполнения заказов',
  spanish: 'para operar y proteger el servicio, prevenir fraudes y mejorar cómo se procesan los pedidos',
  swahili: 'kuendesha na kulinda huduma, kuzuia udanganyifu, na kuboresha jinsi maagizo yanavyotimizwa',
  vietnamese: 'để vận hành và bảo mật dịch vụ, ngăn chặn gian lận, và cải thiện cách thực hiện đơn hàng',
};

export const gdprRightsHeading: Translation = {
  amharic: 'መብቶችዎ',
  arabic: 'حقوقك',
  bengali: 'আপনার অধিকার',
  chinese: '你的权利',
  english: 'Your rights',
  estonian: 'Sinu õigused',
  filipino: 'Ang mga karapatan mo',
  french: 'Vos droits',
  german: 'Deine Rechte',
  hindi: 'आपके अधिकार',
  indonesian: 'Hak Anda',
  japanese: 'お客様の権利',
  korean: '귀하의 권리',
  portuguese: 'Seus direitos',
  russian: 'Ваши права',
  spanish: 'Tus derechos',
  swahili: 'Haki zako',
  vietnamese: 'Quyền của bạn',
};

export const gdprRightAccess: Translation = {
  amharic: 'ስለ እርስዎ የያዝነውን የግል መረጃ ይድረሱ',
  arabic: 'الوصول إلى البيانات الشخصية التي نحتفظ بها عنك',
  bengali: 'আমরা আপনার সম্পর্কে যে ব্যক্তিগত ডেটা রাখি তা অ্যাক্সেস করুন',
  chinese: '访问我们持有的关于你的个人数据',
  english: 'Access the personal data we hold about you',
  estonian: 'Pääse ligi isikuandmetele, mida sinu kohta hoiame',
  filipino: 'I-access ang personal na data na hawak namin tungkol sa iyo',
  french: 'Accéder aux données personnelles que nous détenons sur vous',
  german: 'Zugriff auf die personenbezogenen Daten, die wir über dich speichern',
  hindi: 'हमारे पास आपके बारे में मौजूद व्यक्तिगत डेटा तक पहुँचें',
  indonesian: 'Mengakses data pribadi yang kami simpan tentang Anda',
  japanese: '当社が保有するお客様の個人データへのアクセス',
  korean: '당사가 보유한 귀하의 개인정보에 대한 접근',
  portuguese: 'Acessar os dados pessoais que mantemos sobre você',
  russian: 'Доступ к персональным данным, которые мы храним о вас',
  spanish: 'Acceder a los datos personales que tenemos sobre ti',
  swahili: 'Fikia data binafsi tunayoishikilia kukuhusu',
  vietnamese: 'Truy cập dữ liệu cá nhân chúng tôi lưu giữ về bạn',
};

export const gdprRightRectification: Translation = {
  amharic: 'ትክክል ያልሆነ መረጃ ያስተካክሉ',
  arabic: 'تصحيح البيانات غير الدقيقة',
  bengali: 'ভুল ডেটা সংশোধন করুন',
  chinese: '更正不准确的数据',
  english: 'Rectify inaccurate data',
  estonian: 'Paranda ebatäpsed andmed',
  filipino: 'Itama ang hindi tamang data',
  french: 'Rectifier les données inexactes',
  german: 'Unrichtige Daten berichtigen',
  hindi: 'गलत डेटा सुधारें',
  indonesian: 'Memperbaiki data yang tidak akurat',
  japanese: '不正確なデータの訂正',
  korean: '부정확한 데이터 정정',
  portuguese: 'Retificar dados imprecisos',
  russian: 'Исправить неточные данные',
  spanish: 'Rectificar datos inexactos',
  swahili: 'Sahihisha data isiyo sahihi',
  vietnamese: 'Chỉnh sửa dữ liệu không chính xác',
};

export const gdprRightErasure: Translation = {
  amharic: 'መረጃዎን ይሰርዙ (ለሕጋዊ የማቆያ መስፈርቶች ተገዢ)',
  arabic: 'محو بياناتك (مع مراعاة متطلبات الاحتفاظ القانونية)',
  bengali: 'আপনার ডেটা মুছুন (আইনি রিটেনশন প্রয়োজনীয়তা সাপেক্ষে)',
  chinese: '删除你的数据（受法定保留要求约束）',
  english: 'Erase your data (subject to legal retention requirements)',
  estonian: 'Kustuta oma andmed (kohaldades juriidilisi säilitamisnõudeid)',
  filipino: 'Burahin ang iyong data (napapailalim sa legal na retention requirements)',
  french: 'Effacer vos données (sous réserve des obligations légales de conservation)',
  german: 'Deine Daten löschen (vorbehaltlich gesetzlicher Aufbewahrungspflichten)',
  hindi: 'अपना डेटा मिटाएँ (कानूनी प्रतिधारण आवश्यकताओं के अधीन)',
  indonesian: 'Menghapus data Anda (tunduk pada persyaratan retensi hukum)',
  japanese: 'データの消去（法的な保持要件に従う）',
  korean: '귀하의 데이터 삭제(법적 보존 요건에 따름)',
  portuguese: 'Apagar seus dados (sujeito a requisitos legais de retenção)',
  russian: 'Удалить ваши данные (с учётом требований законодательства о хранении)',
  spanish: 'Borrar tus datos (sujeto a requisitos legales de conservación)',
  swahili: 'Futa data yako (kulingana na mahitaji ya kisheria ya kuhifadhi)',
  vietnamese: 'Xóa dữ liệu của bạn (tùy theo yêu cầu lưu giữ pháp lý)',
};

export const gdprRightPortability: Translation = {
  amharic: 'የመረጃ ተንቀሳቃሽነት፦ መረጃዎን በማሽን ሊነበብ በሚችል ቅርጸት ወደ ውጭ ይላኩ',
  arabic: 'قابلية نقل البيانات: تصدير بياناتك بتنسيق قابل للقراءة آليًا',
  bengali: 'ডেটা পোর্টেবিলিটি: আপনার ডেটা মেশিন-পঠনযোগ্য ফরম্যাটে এক্সপোর্ট করুন',
  chinese: '数据可携性：以机器可读格式导出你的数据',
  english: 'Data portability: export your data in a machine-readable format',
  estonian: 'Andmete teisaldatavus: ekspordi oma andmed masinloetavas vormingus',
  filipino: 'Data portability: i-export ang iyong data sa machine-readable na format',
  french: 'Portabilité des données : exportez vos données dans un format lisible par machine',
  german: 'Datenübertragbarkeit: Exportiere deine Daten in einem maschinenlesbaren Format',
  hindi: 'डेटा पोर्टेबिलिटी: अपना डेटा मशीन-पठनीय प्रारूप में निर्यात करें',
  indonesian: 'Portabilitas data: ekspor data Anda dalam format yang dapat dibaca mesin',
  japanese: 'データポータビリティ：機械可読形式でデータをエクスポート',
  korean: '데이터 이동성: 기계가 읽을 수 있는 형식으로 데이터 내보내기',
  portuguese: 'Portabilidade de dados: exporte seus dados em formato legível por máquina',
  russian: 'Переносимость данных: экспортируйте свои данные в машиночитаемом формате',
  spanish: 'Portabilidad de datos: exporta tus datos en un formato legible por máquina',
  swahili: 'Uhamishaji wa data: safirisha data yako katika muundo unaosomeka na mashine',
  vietnamese: 'Tính khả chuyển dữ liệu: xuất dữ liệu của bạn ở định dạng máy đọc được',
};

export const gdprRightObjection: Translation = {
  amharic: 'በሕጋዊ ጥቅም ላይ ለተመሠረተ ሂደት ይቃወሙ',
  arabic: 'الاعتراض على المعالجة القائمة على المصلحة المشروعة',
  bengali: 'বৈধ স্বার্থের ভিত্তিতে প্রক্রিয়াকরণে আপত্তি জানান',
  chinese: '反对基于正当利益的处理',
  english: 'Object to processing based on legitimate interest',
  estonian: 'Esita vastuväide õigustatud huvil põhineva töötlemise suhtes',
  filipino: 'Tumutol sa pagprosesong nakabatay sa lehitimong interes',
  french: 'Vous opposer au traitement fondé sur l’intérêt légitime',
  german: 'Der auf berechtigtem Interesse beruhenden Verarbeitung widersprechen',
  hindi: 'वैध हित पर आधारित प्रसंस्करण पर आपत्ति करें',
  indonesian: 'Menolak pemrosesan yang didasarkan pada kepentingan sah',
  japanese: '正当な利益に基づく処理への異議申し立て',
  korean: '정당한 이익에 근거한 처리에 대한 반대',
  portuguese: 'Opor-se ao processamento baseado em interesse legítimo',
  russian: 'Возражать против обработки, основанной на законном интересе',
  spanish: 'Oponerte al tratamiento basado en interés legítimo',
  swahili: 'Pinga uchakataji unaotegemea maslahi halali',
  vietnamese: 'Phản đối việc xử lý dựa trên lợi ích hợp pháp',
};

export const gdprRightRestriction: Translation = {
  amharic: 'ውሂብዎን እንዴት እንደምናካሂድ ይገድቡ',
  arabic: 'تقييد كيفية معالجتنا لبياناتك',
  bengali: 'আমরা কীভাবে আপনার ডেটা প্রক্রিয়া করি তা সীমিত করুন',
  chinese: '限制我们处理你数据的方式',
  english: 'Restrict how we process your data',
  estonian: 'Piira, kuidas me sinu andmeid töötleme',
  filipino: 'Limitahan kung paano namin pinoproseso ang iyong data',
  french: 'Limiter la façon dont nous traitons vos données',
  german: 'Einschränken, wie wir deine Daten verarbeiten',
  hindi: 'हम आपके डेटा को कैसे प्रोसेस करते हैं, इसे सीमित करें',
  indonesian: 'Membatasi cara kami memproses data Anda',
  japanese: '当社によるデータ処理方法の制限',
  korean: '당사의 데이터 처리 방식 제한',
  portuguese: 'Restringir como processamos seus dados',
  russian: 'Ограничить то, как мы обрабатываем ваши данные',
  spanish: 'Restringir cómo procesamos tus datos',
  swahili: 'Zuia jinsi tunavyochakata data yako',
  vietnamese: 'Hạn chế cách chúng tôi xử lý dữ liệu của bạn',
};

export const gdprRightsExerciseBody: Translation = {
  amharic: 'ከእነዚህ መብቶች ማንኛውንም ለመጠቀም {email} ኢሜይል ያድርጉ። በ30 ቀናት ውስጥ ምላሽ እንሰጣለን።',
  arabic: 'لممارسة أي من هذه الحقوق، راسلنا على {email}. نرد خلال 30 يومًا.',
  bengali: 'এই অধিকারগুলোর যেকোনোটি প্রয়োগ করতে {email}-এ ইমেইল করুন। আমরা ৩০ দিনের মধ্যে সাড়া দিই।',
  chinese: '要行使其中任何权利，请发送邮件至 {email}。我们将在 30 天内回复。',
  english: 'To exercise any of these rights, email {email}. We respond within 30 days.',
  estonian: 'Mis tahes nende õiguste kasutamiseks kirjuta aadressile {email}. Vastame 30 päeva jooksul.',
  filipino: 'Para gamitin ang alinman sa mga karapatang ito, mag-email sa {email}. Tumutugon kami sa loob ng 30 araw.',
  french: "Pour exercer l'un de ces droits, écrivez à {email}. Nous répondons sous 30 jours.",
  german: 'Um eines dieser Rechte auszuüben, schreib an {email}. Wir antworten innerhalb von 30 Tagen.',
  hindi: 'इनमें से किसी भी अधिकार का प्रयोग करने के लिए, {email} पर ईमेल करें। हम 30 दिनों के भीतर जवाब देते हैं।',
  indonesian: 'Untuk menggunakan salah satu hak ini, email ke {email}. Kami merespons dalam 30 hari.',
  japanese: 'これらの権利を行使するには、{email} までメールでご連絡ください。30 日以内に対応いたします。',
  korean: '이러한 권리를 행사하려면 {email}로 이메일을 보내주세요. 30일 이내에 응답합니다.',
  portuguese: 'Para exercer qualquer um desses direitos, envie um e-mail para {email}. Respondemos em até 30 dias.',
  russian: 'Чтобы воспользоваться любым из этих прав, напишите на {email}. Мы отвечаем в течение 30 дней.',
  spanish: 'Para ejercer cualquiera de estos derechos, escribe a {email}. Respondemos en un plazo de 30 días.',
  swahili: 'Kutumia haki yoyote kati ya hizi, tuma barua pepe kwa {email}. Tunajibu ndani ya siku 30.',
  vietnamese: 'Để thực hiện bất kỳ quyền nào trong số này, hãy gửi email đến {email}. Chúng tôi phản hồi trong vòng 30 ngày.',
};

export const gdprErasurePointer: Translation = {
  amharic: 'የውሂብዎን መሰረዝ በተለይ ለመጠየቅ የእኛን የመረጃ መሰረዝ ገጽ ይጠቀሙ፦',
  arabic: 'لطلب محو بياناتك تحديدًا، استخدم صفحة حذف البيانات لدينا:',
  bengali: 'বিশেষভাবে আপনার ডেটা মুছে ফেলার অনুরোধ করতে, আমাদের ডেটা ডিলিশন পৃষ্ঠা ব্যবহার করুন:',
  chinese: '如需专门请求删除你的数据，请使用我们的数据删除页面：',
  english: 'To request erasure of your data specifically, use our Data Deletion page:',
  estonian: 'Oma andmete kustutamise taotlemiseks kasuta meie andmete kustutamise lehte:',
  filipino: 'Para hilingin ang pagbura ng iyong data nang partikular, gamitin ang aming Data Deletion page:',
  french: 'Pour demander spécifiquement la suppression de vos données, utilisez notre page de suppression de données :',
  german: 'Um speziell die Löschung deiner Daten zu beantragen, nutze unsere Datenlöschungsseite:',
  hindi: 'विशेष रूप से अपने डेटा को मिटाने का अनुरोध करने के लिए, हमारे डेटा डिलीशन पेज का उपयोग करें:',
  indonesian: 'Untuk meminta penghapusan data Anda secara khusus, gunakan halaman Penghapusan Data kami:',
  japanese: 'データの消去を特に希望される場合は、当社のデータ削除ページをご利用ください。',
  korean: '데이터 삭제를 특별히 요청하려면 당사의 데이터 삭제 페이지를 이용하세요.',
  portuguese: 'Para solicitar especificamente a exclusão dos seus dados, use nossa página de Exclusão de Dados:',
  russian: 'Чтобы отдельно запросить удаление своих данных, используйте нашу страницу удаления данных:',
  spanish: 'Para solicitar específicamente la eliminación de tus datos, usa nuestra página de eliminación de datos:',
  swahili: 'Kuomba ufutaji wa data yako mahususi, tumia ukurasa wetu wa Kufuta Data:',
  vietnamese: 'Để yêu cầu xóa dữ liệu của bạn một cách cụ thể, hãy sử dụng trang Xóa Dữ liệu của chúng tôi:',
};

export const gdprRetentionHeading: Translation = {
  amharic: 'የመያዣ ጊዜ',
  arabic: 'الاحتفاظ بالبيانات',
  bengali: 'সংরক্ষণ',
  chinese: '数据保留',
  english: 'Retention',
  estonian: 'Säilitamine',
  filipino: 'Retention',
  french: 'Conservation',
  german: 'Aufbewahrung',
  hindi: 'प्रतिधारण',
  indonesian: 'Retensi',
  japanese: 'データの保持',
  korean: '보관',
  portuguese: 'Retenção',
  russian: 'Хранение данных',
  spanish: 'Conservación',
  swahili: 'Uhifadhi',
  vietnamese: 'Lưu giữ dữ liệu',
};

export const gdprRetentionBody: Translation = {
  amharic: 'ውዝግቦችን ለመፍታት፣ የግብር እና የሒሳብ ግዴታዎችን ለማሟላት እና የደንበኛ አገልግሎትን ለመደገፍ አስፈላጊ እስከሆነ ድረስ የትዕዛዝ መረጃን እንይዛለን። አስፈላጊ ካልሆነ በኋላ እንሰርዘዋለን።',
  arabic: 'نحتفظ ببيانات الطلبات طالما لزم الأمر لحل النزاعات، والوفاء بالتزامات الضرائب والمحاسبة، ودعم خدمة العملاء. وعندما لا نحتاجها بعد ذلك، نحذفها.',
  bengali: 'বিরোধ নিষ্পত্তি, কর ও হিসাব সংক্রান্ত বাধ্যবাধকতা পূরণ এবং গ্রাহক সেবা সমর্থন করতে যতদিন প্রয়োজন ততদিন আমরা অর্ডার ডেটা রাখি। আর প্রয়োজন না হলে, আমরা তা মুছে ফেলি।',
  chinese: '我们会保留订单数据，直至不再需要用于解决纠纷、履行税务和会计义务以及支持客户服务为止。届时我们会将其删除。',
  english: 'We keep order data for as long as needed to resolve disputes, meet tax and accounting obligations, and support customer service. When it is no longer needed, we delete it.',
  estonian: 'Hoiame tellimuse andmeid nii kaua, kui on vaja vaidluste lahendamiseks, maksu- ja raamatupidamiskohustuste täitmiseks ning klienditeeninduse toetamiseks. Kui neid enam vaja pole, kustutame need.',
  filipino: 'Iniingatan namin ang data ng order hangga’t kailangan para lutasin ang mga hindi pagkakaunawaan, matugunan ang mga obligasyon sa buwis at accounting, at suportahan ang serbisyo sa customer. Kapag hindi na kailangan, binubura namin ito.',
  french: 'Nous conservons les données de commande aussi longtemps que nécessaire pour résoudre les litiges, respecter les obligations fiscales et comptables, et soutenir le service client. Une fois qu’elles ne sont plus nécessaires, nous les supprimons.',
  german: 'Wir bewahren Bestelldaten so lange auf, wie es zur Klärung von Streitigkeiten, zur Erfüllung steuerlicher und buchhalterischer Pflichten und zur Unterstützung des Kundendienstes erforderlich ist. Sobald sie nicht mehr benötigt werden, löschen wir sie.',
  hindi: 'हम ऑर्डर डेटा को तब तक रखते हैं जब तक विवादों को सुलझाने, कर और लेखा दायित्वों को पूरा करने, और ग्राहक सेवा का समर्थन करने के लिए आवश्यक हो। जब इसकी आवश्यकता नहीं रहती, तो हम इसे हटा देते हैं।',
  indonesian: 'Kami menyimpan data pesanan selama diperlukan untuk menyelesaikan sengketa, memenuhi kewajiban pajak dan akuntansi, serta mendukung layanan pelanggan. Setelah tidak diperlukan lagi, kami menghapusnya.',
  japanese: '当社は、紛争の解決、税務・会計上の義務の履行、カスタマーサービスの提供に必要な期間、注文データを保持します。不要になった時点で削除します。',
  korean: '당사는 분쟁 해결, 세무 및 회계 의무 이행, 고객 서비스 지원에 필요한 기간 동안 주문 데이터를 보관합니다. 더 이상 필요하지 않으면 삭제합니다.',
  portuguese: 'Mantemos os dados dos pedidos pelo tempo necessário para resolver disputas, cumprir obrigações fiscais e contábeis, e apoiar o atendimento ao cliente. Quando não forem mais necessários, nós os excluímos.',
  russian: 'Мы храним данные о заказах столько, сколько необходимо для урегулирования споров, выполнения налоговых и бухгалтерских обязательств и поддержки клиентского сервиса. Когда данные больше не нужны, мы их удаляем.',
  spanish: 'Conservamos los datos de los pedidos durante el tiempo necesario para resolver disputas, cumplir con obligaciones fiscales y contables, y respaldar el servicio al cliente. Cuando ya no son necesarios, los eliminamos.',
  swahili: 'Tunahifadhi data ya maagizo kwa muda unaohitajika kutatua migogoro, kutimiza wajibu wa kodi na uhasibu, na kusaidia huduma kwa wateja. Isipohitajika tena, tunaifuta.',
  vietnamese: 'Chúng tôi lưu giữ dữ liệu đơn hàng trong thời gian cần thiết để giải quyết tranh chấp, đáp ứng nghĩa vụ thuế và kế toán, và hỗ trợ dịch vụ khách hàng. Khi không còn cần thiết, chúng tôi sẽ xóa nó.',
};

export const gdprTransfersHeading: Translation = {
  amharic: 'ዓለም አቀፍ ዝውውሮች',
  arabic: 'عمليات النقل الدولية',
  bengali: 'আন্তর্জাতিক স্থানান্তর',
  chinese: '国际传输',
  english: 'International transfers',
  estonian: 'Rahvusvahelised edastused',
  filipino: 'Mga internasyonal na transfer',
  french: 'Transferts internationaux',
  german: 'Internationale Übermittlungen',
  hindi: 'अंतर्राष्ट्रीय स्थानांतरण',
  indonesian: 'Transfer internasional',
  japanese: '国際的なデータ移転',
  korean: '국제 이전',
  portuguese: 'Transferências internacionais',
  russian: 'Международные передачи',
  spanish: 'Transferencias internacionales',
  swahili: 'Uhamishaji wa kimataifa',
  vietnamese: 'Chuyển dữ liệu quốc tế',
};

export const gdprTransfersBody: Translation = {
  amharic: 'የመሠረተ ልማት አቅራቢዎቻችን ውሂብን ከሀገርዎ ውጭ ሲያካሂዱ፣ ለመጠበቅ በStandard Contractual Clauses እና ተመጣጣኝ ጥበቃዎች እንመረኮዛለን።',
  arabic: 'حيثما يعالج مزودو البنية التحتية لدينا البيانات خارج بلدك، نعتمد على البنود التعاقدية القياسية وضمانات معادلة لحمايتها.',
  bengali: 'আমাদের অবকাঠামো প্রদানকারীরা যখন আপনার দেশের বাইরে ডেটা প্রক্রিয়া করে, তখন আমরা এটি সুরক্ষিত করতে Standard Contractual Clauses ও সমতুল্য সুরক্ষার উপর নির্ভর করি।',
  chinese: '当我们的基础设施提供商在你所在国家/地区之外处理数据时，我们依据标准合同条款及同等保护措施来保护这些数据。',
  english: 'Where our infrastructure providers process data outside your country, we rely on Standard Contractual Clauses and equivalent safeguards to protect it.',
  estonian: 'Kui meie infrastruktuuripakkujad töötlevad andmeid väljaspool sinu riiki, tugineme nende kaitsmisel standardsetele lepingutingimustele ja samaväärsetele kaitsemeetmetele.',
  filipino: 'Kapag ang aming mga infrastructure provider ay nagpoproseso ng data sa labas ng iyong bansa, umaasa kami sa Standard Contractual Clauses at katumbas na proteksyon para protektahan ito.',
  french: 'Lorsque nos fournisseurs d’infrastructure traitent des données en dehors de votre pays, nous nous appuyons sur les clauses contractuelles types et des garanties équivalentes pour les protéger.',
  german: 'Wenn unsere Infrastrukturanbieter Daten außerhalb deines Landes verarbeiten, stützen wir uns zu ihrem Schutz auf Standardvertragsklauseln und gleichwertige Schutzmaßnahmen.',
  hindi: 'जहां हमारे इंफ्रास्ट्रक्चर प्रदाता आपके देश के बाहर डेटा प्रोसेस करते हैं, वहां हम इसकी सुरक्षा के लिए Standard Contractual Clauses और समकक्ष सुरक्षा उपायों पर निर्भर रहते हैं।',
  indonesian: 'Ketika penyedia infrastruktur kami memproses data di luar negara Anda, kami mengandalkan Standard Contractual Clauses dan perlindungan setara untuk melindunginya.',
  japanese: '当社のインフラプロバイダーがお客様の国以外でデータを処理する場合、その保護のために標準契約条項および同等の保護措置に依拠します。',
  korean: '당사의 인프라 제공업체가 귀하의 국가 외부에서 데이터를 처리하는 경우, 당사는 이를 보호하기 위해 표준 계약 조항 및 이에 준하는 보호 조치에 의존합니다.',
  portuguese: 'Quando nossos provedores de infraestrutura processam dados fora do seu país, contamos com as Cláusulas Contratuais Padrão e salvaguardas equivalentes para protegê-los.',
  russian: 'Когда наши инфраструктурные провайдеры обрабатывают данные за пределами вашей страны, для их защиты мы полагаемся на Стандартные договорные положения и эквивалентные меры защиты.',
  spanish: 'Cuando nuestros proveedores de infraestructura procesan datos fuera de tu país, nos apoyamos en las Cláusulas Contractuales Tipo y garantías equivalentes para protegerlos.',
  swahili: 'Pale watoa huduma wetu wa miundombinu wanapochakata data nje ya nchi yako, tunategemea Vifungu vya Kawaida vya Kimkataba na hatua sawa za ulinzi kuilinda.',
  vietnamese: 'Khi các nhà cung cấp hạ tầng của chúng tôi xử lý dữ liệu bên ngoài quốc gia của bạn, chúng tôi dựa vào Điều khoản Hợp đồng Tiêu chuẩn và các biện pháp bảo vệ tương đương để bảo vệ dữ liệu đó.',
};

export const cookiePageTitle: Translation = {
  amharic: 'የኩኪ መመሪያ',
  arabic: 'سياسة ملفات تعريف الارتباط',
  bengali: 'কুকি নীতি',
  chinese: 'Cookie 政策',
  english: 'Cookie Policy',
  estonian: 'Küpsiste poliitika',
  filipino: 'Patakaran sa Cookie',
  french: 'Politique relative aux cookies',
  german: 'Cookie-Richtlinie',
  hindi: 'कुकी नीति',
  indonesian: 'Kebijakan Cookie',
  japanese: 'Cookie ポリシー',
  korean: '쿠키 정책',
  portuguese: 'Política de Cookies',
  russian: 'Политика использования cookie',
  spanish: 'Política de Cookies',
  swahili: 'Sera ya Vidakuzi',
  vietnamese: 'Chính sách Cookie',
};

export const cookieLastUpdated: Translation = {
  amharic: 'መጨረሻ የተዘመነው ነሐሴ 2፣ 2026',
  arabic: 'آخر تحديث 2 أغسطس 2026',
  bengali: 'সর্বশেষ আপডেট ২ আগস্ট, ২০২৬',
  chinese: '最后更新于 2026 年 8 月 2 日',
  english: 'Last updated August 2, 2026',
  estonian: 'Viimati uuendatud 2. august 2026',
  filipino: 'Huling na-update Agosto 2, 2026',
  french: 'Dernière mise à jour le 2 août 2026',
  german: 'Zuletzt aktualisiert am 2. August 2026',
  hindi: 'अंतिम बार 2 अगस्त, 2026 को अपडेट किया गया',
  indonesian: 'Terakhir diperbarui 2 Agustus 2026',
  japanese: '最終更新日 2026 年 8 月 2 日',
  korean: '최종 업데이트 2026년 8월 2일',
  portuguese: 'Última atualização em 2 de agosto de 2026',
  russian: 'Последнее обновление 2 августа 2026 г.',
  spanish: 'Última actualización el 2 de agosto de 2026',
  swahili: 'Ilisasishwa mwisho Agosti 2, 2026',
  vietnamese: 'Cập nhật lần cuối ngày 2 tháng 8 năm 2026',
};

export const cookieIntro: Translation = {
  amharic: 'ኩኪ ድረ-ገጽ በአሳሽዎ ውስጥ የሚያስቀምጠው ትንሽ የጽሑፍ ፋይል ነው። Pieleaf ያለ መለያ ወይም መግቢያ እንደ እንግዳ ትኩስ የግብርና ምርቶችን እንዲያስሱ እና እንዲያዝዙ ያስችልዎታል፣ ስለዚህ ጉብኝትዎን እና ትዕዛዝዎን ለማስኬድ የሚያስፈልጉትን አነስተኛ ኩኪዎች ብቻ እንጠቀማለን።',
  arabic: 'ملف تعريف الارتباط هو ملف نصي صغير يخزّنه موقع ويب في متصفحك. يتيح لك Pieleaf تصفح وطلب المنتجات الطازجة كضيف، دون حساب أو تسجيل دخول، لذلك نستخدم أقل عدد ممكن من ملفات تعريف الارتباط اللازمة لإبقاء زيارتك وطلبك يعملان.',
  bengali: 'কুকি হলো একটি ছোট টেক্সট ফাইল যা একটি ওয়েবসাইট আপনার ব্রাউজারে সংরক্ষণ করে। Pieleaf আপনাকে কোনো অ্যাকাউন্ট বা সাইন-ইন ছাড়াই অতিথি হিসেবে তাজা কৃষিপণ্য ব্রাউজ ও অর্ডার করতে দেয়, তাই আপনার ভিজিট ও অর্ডার সচল রাখতে আমরা সবচেয়ে কম প্রয়োজনীয় কুকি ব্যবহার করি।',
  chinese: 'Cookie 是网站在你浏览器中存储的小型文本文件。Pieleaf 允许你以访客身份浏览和订购新鲜农产品，无需注册或登录账户，因此我们只使用维持你的访问和订单正常运作所需的最少 Cookie。',
  english: 'A cookie is a small text file a website stores in your browser. Pieleaf lets you browse and order fresh produce as a guest, with no account or sign-in, so we use the fewest cookies needed to keep your visit and your order working.',
  estonian:
    'Küpsis on väike tekstifail, mille veebisait sinu brauserisse salvestab. Pieleaf võimaldab sul värskeid põllumajandustooteid sirvida ja tellida külalisena, ilma kontota või sisselogimiseta, seega kasutame vaid vähimat arvu küpsiseid, mis on vajalikud sinu külastuse ja tellimuse toimimiseks.',
  filipino:
    'Ang cookie ay isang maliit na text file na iniimbak ng isang website sa iyong browser. Hinahayaan ka ng Pieleaf na mag-browse at mag-order ng sariwang produkto bilang bisita, nang walang account o pag-sign in, kaya ginagamit namin ang pinakakaunting cookie na kailangan para mapanatiling gumagana ang iyong pagbisita at order.',
  french:
    "Un cookie est un petit fichier texte qu'un site web stocke dans votre navigateur. Pieleaf vous permet de parcourir et de commander des produits frais en tant qu'invité, sans compte ni connexion, nous utilisons donc le moins de cookies possible pour faire fonctionner votre visite et votre commande.",
  german:
    'Ein Cookie ist eine kleine Textdatei, die eine Website in deinem Browser speichert. Mit Pieleaf kannst du frische Erzeugnisse als Gast durchsuchen und bestellen, ganz ohne Konto oder Anmeldung, deshalb verwenden wir nur so wenige Cookies wie nötig, damit dein Besuch und deine Bestellung funktionieren.',
  hindi: 'कुकी एक छोटी टेक्स्ट फ़ाइल है जिसे कोई वेबसाइट आपके ब्राउज़र में संग्रहीत करती है। Pieleaf आपको बिना किसी खाते या साइन-इन के अतिथि के रूप में ताज़ा उपज ब्राउज़ करने और ऑर्डर करने देता है, इसलिए हम आपकी विज़िट और ऑर्डर को चालू रखने के लिए आवश्यक न्यूनतम कुकीज़ का ही उपयोग करते हैं।',
  indonesian:
    'Cookie adalah file teks kecil yang disimpan situs web di browser Anda. Pieleaf memungkinkan Anda menjelajah dan memesan produk segar sebagai tamu, tanpa akun atau login, sehingga kami hanya menggunakan cookie sesedikit mungkin yang diperlukan agar kunjungan dan pesanan Anda tetap berjalan.',
  japanese: 'Cookie とは、ウェブサイトがブラウザに保存する小さなテキストファイルです。Pieleaf では、アカウントやログインなしに、ゲストとして新鮮な農産物を閲覧・注文できるため、訪問と注文を正しく機能させるために必要最小限の Cookie のみを使用しています。',
  korean: '쿠키는 웹사이트가 브라우저에 저장하는 작은 텍스트 파일입니다. Pieleaf에서는 계정이나 로그인 없이 게스트로 신선한 농산물을 둘러보고 주문할 수 있으므로, 방문과 주문이 정상적으로 작동하는 데 필요한 최소한의 쿠키만 사용합니다.',
  portuguese: 'Um cookie é um pequeno arquivo de texto que um site armazena no seu navegador. O Pieleaf permite que você navegue e peça produtos frescos como convidado, sem conta ou login, por isso usamos o mínimo de cookies necessário para manter sua visita e seu pedido funcionando.',
  russian:
    'Cookie: это небольшой текстовый файл, который сайт сохраняет в вашем браузере. Pieleaf позволяет просматривать и заказывать свежие продукты в качестве гостя, без аккаунта и входа в систему, поэтому мы используем минимальное количество cookie, необходимое для работы вашего визита и заказа.',
  spanish: 'Una cookie es un pequeño archivo de texto que un sitio web almacena en tu navegador. Pieleaf te permite explorar y pedir productos frescos como invitado, sin cuenta ni inicio de sesión, por eso usamos la menor cantidad de cookies necesarias para que tu visita y tu pedido funcionen.',
  swahili: 'Kidakuzi ni faili dogo la maandishi ambalo tovuti huhifadhi katika kivinjari chako. Pieleaf hukuruhusu kuvinjari na kuagiza mazao mapya kama mgeni, bila akaunti au kuingia, hivyo tunatumia vidakuzi vichache zaidi vinavyohitajika kuweka ziara na agizo lako likifanya kazi.',
  vietnamese:
    'Cookie là một tệp văn bản nhỏ mà trang web lưu trong trình duyệt của bạn. Pieleaf cho phép bạn duyệt và đặt mua nông sản tươi với tư cách khách, không cần tài khoản hay đăng nhập, vì vậy chúng tôi chỉ sử dụng số lượng cookie ít nhất cần thiết để giữ cho lượt truy cập và đơn hàng của bạn hoạt động.',
};

export const cookieSetHeading: Translation = {
  amharic: 'የምናስቀምጣቸው ኩኪዎች',
  arabic: 'ملفات تعريف الارتباط التي نضعها',
  bengali: 'আমরা যে কুকি সেট করি',
  chinese: '我们设置的 Cookie',
  english: 'Cookies we set',
  estonian: 'Küpsised, mille me seame',
  filipino: 'Mga cookie na itinatakda namin',
  french: 'Cookies que nous déposons',
  german: 'Cookies, die wir setzen',
  hindi: 'हम जो कुकीज़ सेट करते हैं',
  indonesian: 'Cookie yang kami tetapkan',
  japanese: '当社が設定する Cookie',
  korean: '당사가 설정하는 쿠키',
  portuguese: 'Cookies que definimos',
  russian: 'Файлы cookie, которые мы устанавливаем',
  spanish: 'Cookies que establecemos',
  swahili: 'Vidakuzi tunavyoviweka',
  vietnamese: 'Cookie chúng tôi đặt',
};

export const cookieNecessaryHeading: Translation = {
  amharic: 'በጥብቅ አስፈላጊ',
  arabic: 'ضرورية للغاية',
  bengali: 'কঠোরভাবে প্রয়োজনীয়',
  chinese: '严格必要',
  english: 'Strictly necessary',
  estonian: 'Rangelt vajalikud',
  filipino: 'Mahigpit na kinakailangan',
  french: 'Strictement nécessaires',
  german: 'Unbedingt erforderlich',
  hindi: 'अत्यावश्यक',
  indonesian: 'Sangat diperlukan',
  japanese: '厳密に必要',
  korean: '엄격히 필요',
  portuguese: 'Estritamente necessários',
  russian: 'Строго необходимые',
  spanish: 'Estrictamente necesarias',
  swahili: 'Muhimu kabisa',
  vietnamese: 'Thực sự cần thiết',
};

export const cookieNecessaryBody: Translation = {
  amharic: 'የመረጃ ቋት አቅራቢያችን በገጾች መካከል ሲንቀሳቀሱ የሚያስሱትን ምርትና የሚያዙትን ትዕዛዝ ከጉብኝትዎ ጋር አያይዞ ለማቆየት አንድ የክፍለ-ጊዜ ኩኪ ያስቀምጣል። ትዕዛዝዎ ከሚያስፈልገው ውጪ ስም፣ ስልክ ቁጥር ወይም የክፍያ ዝርዝሮችን አልያዘም፣ እንዲሁም ለማስታወቂያ በጭራሽ አይጠቅምም።',
  arabic: 'يضع مزوّد قاعدة بياناتنا ملف تعريف ارتباط واحد للجلسة حتى يبقى المنتج الذي تتصفحه والطلب الذي تقدمه مرتبطين بزيارتك أثناء تنقلك بين الصفحات. لا يحتوي على اسم أو رقم هاتف أو تفاصيل دفع تتجاوز ما يحتاجه طلبك، ولا يُستخدم أبدًا للإعلانات.',
  bengali: 'আমাদের ডেটাবেস প্রদানকারী একটি সেশন কুকি সেট করে, যাতে আপনি পৃষ্ঠাগুলোর মধ্যে চলাফেরা করার সময় আপনি যে পণ্য দেখছেন এবং যে অর্ডার দিচ্ছেন তা আপনার ভিজিটের সাথে যুক্ত থাকে। এতে আপনার অর্ডারের প্রয়োজনের বাইরে কোনো নাম, ফোন নম্বর, বা পেমেন্ট বিবরণ থাকে না, এবং এটি কখনো বিজ্ঞাপনের জন্য ব্যবহৃত হয় না।',
  chinese: '我们的数据库服务商会设置一个会话 Cookie，让你在页面间切换时，正在浏览的产品和正在下的订单仍与本次访问保持关联。除了完成订单所需的信息外，它不包含姓名、电话号码或支付明细，也绝不会用于广告投放。',
  english:
    "Our database provider sets one session cookie so the produce you're browsing and the order you're placing stay attached to your visit as you move between pages. It holds no name, phone number, or payment details beyond what your order already needs, and it is never used for advertising.",
  estonian:
    'Meie andmebaasiteenuse pakkuja seab ühe seansiküpsise, et toode, mida sirvid, ja tellimus, mida esitad, jääksid seotuks sinu külastusega, kui liigud lehtede vahel. See ei sisalda nime, telefoninumbrit ega maksete andmeid rohkem, kui su tellimus vajab, ja seda ei kasutata kunagi reklaami jaoks.',
  filipino:
    'Nagtatakda ang aming database provider ng isang session cookie para ang produktong bini-browse mo at ang order na inilalagay mo ay manatiling nakadugtong sa iyong pagbisita habang lumilipat ka sa mga pahina. Wala itong pangalan, numero ng telepono, o detalye ng bayad maliban sa kailangan ng iyong order, at hindi ito ginagamit para sa advertising.',
  french:
    "Notre fournisseur de base de données dépose un cookie de session pour que le produit que vous consultez et la commande que vous passez restent liés à votre visite pendant que vous naviguez entre les pages. Il ne contient ni nom, ni numéro de téléphone, ni détails de paiement au-delà de ce que votre commande exige déjà, et il n'est jamais utilisé à des fins publicitaires.",
  german:
    'Unser Datenbankanbieter setzt ein Sitzungscookie, damit das Produkt, das du dir ansiehst, und die Bestellung, die du aufgibst, mit deinem Besuch verknüpft bleiben, während du zwischen Seiten wechselst. Es enthält weder Namen, Telefonnummer noch Zahlungsdetails über das hinaus, was deine Bestellung ohnehin braucht, und wird niemals für Werbung genutzt.',
  hindi: 'हमारा डेटाबेस प्रदाता एक सेशन कुकी सेट करता है ताकि जिस उत्पाद को आप देख रहे हैं और जो ऑर्डर आप दे रहे हैं, वह पेजों के बीच जाने पर भी आपकी विज़िट से जुड़ा रहे। इसमें आपके ऑर्डर की ज़रूरत से अधिक कोई नाम, फ़ोन नंबर, या भुगतान विवरण नहीं होता, और इसका उपयोग कभी विज्ञापन के लिए नहीं किया जाता।',
  indonesian:
    'Penyedia basis data kami menetapkan satu cookie sesi agar produk yang sedang Anda telusuri dan pesanan yang sedang Anda buat tetap terhubung dengan kunjungan Anda saat berpindah halaman. Cookie ini tidak menyimpan nama, nomor telepon, atau detail pembayaran melebihi yang dibutuhkan pesanan Anda, dan tidak pernah digunakan untuk iklan.',
  japanese: '当社のデータベースプロバイダーは、ページを移動する間も閲覧中の商品と注文がお客様の訪問に紐づいたままになるよう、1つのセッション Cookie を設定します。これには注文に必要な範囲を超えた氏名、電話番号、支払い情報は含まれず、広告に使用されることは一切ありません。',
  korean: '당사의 데이터베이스 제공업체는 페이지를 이동하는 동안에도 둘러보고 있는 상품과 주문이 방문 세션에 계속 연결되도록 세션 쿠키 하나를 설정합니다. 여기에는 주문에 필요한 범위를 넘어서는 이름, 전화번호, 결제 정보가 포함되지 않으며, 광고 목적으로 사용되는 일도 없습니다.',
  portuguese:
    'Nosso provedor de banco de dados define um cookie de sessão para que o produto que você está navegando e o pedido que está fazendo permaneçam vinculados à sua visita enquanto você navega entre as páginas. Ele não contém nome, número de telefone ou dados de pagamento além do que seu pedido já exige, e nunca é usado para publicidade.',
  russian:
    'Наш поставщик базы данных устанавливает один сеансовый cookie-файл, чтобы просматриваемый вами товар и оформляемый заказ оставались привязаны к вашему визиту при переходе между страницами. Он не содержит имени, номера телефона или платёжных данных сверх того, что уже требуется для вашего заказа, и никогда не используется для рекламы.',
  spanish:
    'Nuestro proveedor de base de datos establece una cookie de sesión para que el producto que estás viendo y el pedido que estás haciendo permanezcan vinculados a tu visita mientras te desplazas entre páginas. No contiene nombre, número de teléfono ni datos de pago más allá de lo que tu pedido ya necesita, y nunca se usa con fines publicitarios.',
  swahili:
    'Mtoa huduma wetu wa hifadhidata huweka kidakuzi kimoja cha kikao ili bidhaa unayovinjari na agizo unaloweka viendelee kuunganishwa na ziara yako unapohama kati ya kurasa. Hakina jina, nambari ya simu, au maelezo ya malipo zaidi ya yale agizo lako linayohitaji, na halijawahi kutumika kwa matangazo.',
  vietnamese:
    'Nhà cung cấp cơ sở dữ liệu của chúng tôi đặt một cookie phiên để sản phẩm bạn đang xem và đơn hàng bạn đang đặt vẫn được gắn với lượt truy cập của bạn khi bạn di chuyển giữa các trang. Cookie này không chứa tên, số điện thoại hay chi tiết thanh toán ngoài những gì đơn hàng của bạn đã cần, và không bao giờ được dùng cho mục đích quảng cáo.',
};

export const cookieAnalyticsHeading: Translation = {
  amharic: 'ትንተና',
  arabic: 'التحليلات',
  bengali: 'অ্যানালিটিক্স',
  chinese: '分析',
  english: 'Analytics',
  estonian: 'Analüütika',
  filipino: 'Analytics',
  french: 'Analytique',
  german: 'Analytik',
  hindi: 'एनालिटिक्स',
  indonesian: 'Analitik',
  japanese: 'アナリティクス',
  korean: '분석',
  portuguese: 'Análise',
  russian: 'Аналитика',
  spanish: 'Analítica',
  swahili: 'Uchanganuzi',
  vietnamese: 'Phân tích',
};

export const cookieAnalyticsBody: Translation = {
  amharic: 'ለዚህ ጣቢያ ትንተና ሲበራ፣ የራሳችን የመጀመሪያ-ወገን ትንተና ስክሪፕት ጣቢያው እንዴት ጥቅም ላይ እንደሚውል ለመረዳት እንዲረዳን የገጽ እይታዎችን እና በገጽ ላይ ያሉ መስተጋብሮችን ይመዘግባል። ተደጋጋሚ ጉብኝቶች እንዲታወቁ በአሳሽዎ የአካባቢ ማከማቻ ውስጥ በዘፈቀደ የተፈጠረ መለያ ያከማቻል፤ ኩኪ አይደለም። መለያው ምንም ስም፣ የመገኛ አድራሻ ዝርዝሮች ወይም የትዕዛዝ መረጃ አልያዘም። ትንተና ካልበራ ይህ ስክሪፕት በጭራሽ አይጫንም።',
  arabic:
    'عندما تكون التحليلات مفعّلة لهذا الموقع، يسجّل نص التحليلات الخاص بنا من الطرف الأول مشاهدات الصفحات والتفاعلات داخل الصفحة لمساعدتنا على فهم كيفية استخدام الموقع. يخزّن معرّفًا يُنشأ عشوائيًا في التخزين المحلي لمتصفحك، وليس في ملف تعريف ارتباط، ليتم التعرّف على الزيارات المتكررة؛ ولا يحمل هذا المعرّف أي اسم أو بيانات تواصل أو معلومات عن الطلب. وعندما تكون التحليلات غير مفعّلة، لا يتم تحميل هذا النص إطلاقًا.',
  bengali:
    'এই সাইটের জন্য অ্যানালিটিক্স চালু থাকলে, আমাদের নিজস্ব ফার্স্ট-পার্টি অ্যানালিটিক্স স্ক্রিপ্ট পৃষ্ঠা দেখা ও পৃষ্ঠায় মিথস্ক্রিয়া রেকর্ড করে, যাতে সাইটটি কীভাবে ব্যবহৃত হচ্ছে তা আমরা বুঝতে পারি। এটি আপনার ব্রাউজারের লোকাল স্টোরেজে একটি এলোমেলোভাবে তৈরি শনাক্তকারী সংরক্ষণ করে, কুকি নয়, যাতে পুনরাবৃত্ত ভিজিট শনাক্ত করা যায়; এই শনাক্তকারীতে কোনো নাম, যোগাযোগের বিবরণ, বা অর্ডারের তথ্য থাকে না। অ্যানালিটিক্স চালু না থাকলে, এই স্ক্রিপ্টটি একেবারেই লোড হয় না।',
  chinese: '当本网站开启分析功能时，我们自有的第一方分析脚本会记录页面浏览量和页内互动，以帮助我们了解网站的使用情况。它会在你浏览器的本地存储（而非 Cookie）中保存一个随机生成的标识符，以便识别重复访问；该标识符不包含姓名、联系方式或订单信息。若未开启分析功能，该脚本根本不会加载。',
  english:
    "When analytics is switched on for this site, our own first-party analytics script records page views and on-page interactions to help us understand how the site is used. It stores a randomly generated identifier in your browser's local storage, not a cookie, so repeat visits can be recognized; the identifier carries no name, contact details, or order information. When analytics is not switched on, this script does not load at all.",
  estonian:
    'Kui selle saidi analüütika on sisse lülitatud, salvestab meie enda esimese osapoole analüütikaskript lehekülje vaatamisi ja lehel toimuvaid interaktsioone, et aidata meil mõista, kuidas saiti kasutatakse. See salvestab sinu brauseri kohalikku salvestusruumi (mitte küpsisesse) juhuslikult loodud tunnuse, et korduvaid külastusi ära tunda; tunnus ei sisalda nime, kontaktandmeid ega tellimuse teavet. Kui analüütika ei ole sisse lülitatud, ei laadita seda skripti üldse.',
  filipino:
    'Kapag naka-on ang analytics para sa site na ito, ire-record ng aming sariling first-party analytics script ang mga pagtingin sa page at mga interaksyon sa page para matulungan kaming maunawaan kung paano ginagamit ang site. Nag-iimbak ito ng random na nabuong identifier sa local storage ng iyong browser, hindi cookie, para makilala ang mga paulit-ulit na pagbisita; walang pangalan, detalye ng contact, o impormasyon ng order ang identifier na ito. Kapag naka-off ang analytics, hindi talaga lumo-load ang script na ito.',
  french:
    "Lorsque l'analytique est activée pour ce site, notre propre script d'analyse propriétaire enregistre les pages vues et les interactions sur la page pour nous aider à comprendre comment le site est utilisé. Il stocke un identifiant généré aléatoirement dans le stockage local de votre navigateur, et non dans un cookie, afin de reconnaître les visites répétées ; cet identifiant ne contient ni nom, ni coordonnées, ni information de commande. Lorsque l'analytique n'est pas activée, ce script ne se charge pas du tout.",
  german:
    'Wenn die Analyse für diese Website aktiviert ist, erfasst unser eigenes First-Party-Analyseskript Seitenaufrufe und Interaktionen auf der Seite, um uns zu helfen zu verstehen, wie die Website genutzt wird. Es speichert eine zufällig generierte Kennung im lokalen Speicher deines Browsers, nicht in einem Cookie, damit wiederholte Besuche erkannt werden können; diese Kennung enthält weder Namen, Kontaktdaten noch Bestellinformationen. Wenn die Analyse nicht aktiviert ist, wird dieses Skript überhaupt nicht geladen.',
  hindi:
    'जब इस साइट के लिए एनालिटिक्स चालू होता है, तो हमारी अपनी फ़र्स्ट-पार्टी एनालिटिक्स स्क्रिप्ट पेज व्यू और पेज पर होने वाली गतिविधियों को रिकॉर्ड करती है ताकि हमें यह समझने में मदद मिले कि साइट का उपयोग कैसे किया जा रहा है। यह बार-बार आने वाली विज़िट को पहचानने के लिए आपके ब्राउज़र के लोकल स्टोरेज में एक बेतरतीब ढंग से बना पहचानकर्ता संग्रहीत करती है, कुकी में नहीं; इस पहचानकर्ता में कोई नाम, संपर्क विवरण, या ऑर्डर की जानकारी नहीं होती। जब एनालिटिक्स चालू नहीं होता, तो यह स्क्रिप्ट बिल्कुल लोड नहीं होती।',
  indonesian:
    'Saat analitik diaktifkan untuk situs ini, skrip analitik pihak pertama milik kami sendiri mencatat tampilan halaman dan interaksi di halaman untuk membantu kami memahami cara situs ini digunakan. Skrip ini menyimpan pengenal yang dibuat secara acak di penyimpanan lokal browser Anda, bukan cookie, agar kunjungan berulang dapat dikenali; pengenal ini tidak memuat nama, detail kontak, atau informasi pesanan. Saat analitik tidak diaktifkan, skrip ini sama sekali tidak dimuat.',
  japanese:
    'このサイトでアナリティクスが有効になっている場合、当社独自のファーストパーティのアナリティクススクリプトが、サイトの利用状況を把握するためにページビューとページ内の操作を記録します。再訪問を識別できるよう、Cookie ではなくブラウザのローカルストレージにランダムに生成された識別子を保存します。この識別子には氏名、連絡先、注文情報は一切含まれません。アナリティクスが有効になっていない場合、このスクリプトはまったく読み込まれません。',
  korean:
    '이 사이트에서 애널리틱스가 켜져 있는 경우, 당사 자체의 퍼스트파티 애널리틱스 스크립트가 사이트 이용 방식을 파악하는 데 도움이 되도록 페이지 조회수와 페이지 내 상호작용을 기록합니다. 재방문을 인식할 수 있도록 쿠키가 아닌 브라우저의 로컬 스토리지에 무작위로 생성된 식별자를 저장하며, 이 식별자에는 이름, 연락처, 주문 정보가 포함되지 않습니다. 애널리틱스가 꺼져 있는 경우 이 스크립트는 전혀 로드되지 않습니다.',
  portuguese:
    'Quando a análise está ativada para este site, nosso próprio script de análise próprio registra visualizações de página e interações na página para nos ajudar a entender como o site é usado. Ele armazena um identificador gerado aleatoriamente no armazenamento local do seu navegador, não em um cookie, para que visitas repetidas possam ser reconhecidas; esse identificador não contém nome, dados de contato ou informações do pedido. Quando a análise não está ativada, esse script simplesmente não é carregado.',
  russian:
    'Когда аналитика включена для этого сайта, наш собственный первичный скрипт аналитики фиксирует просмотры страниц и взаимодействия на странице, чтобы помочь нам понять, как используется сайт. Он сохраняет случайно сгенерированный идентификатор в локальном хранилище вашего браузера, а не в cookie-файле, чтобы распознавать повторные посещения; этот идентификатор не содержит имени, контактных данных или информации о заказе. Когда аналитика не включена, этот скрипт вообще не загружается.',
  spanish:
    'Cuando la analítica está activada para este sitio, nuestro propio script de analítica de origen propio registra las vistas de página y las interacciones en la página para ayudarnos a entender cómo se usa el sitio. Almacena un identificador generado aleatoriamente en el almacenamiento local de tu navegador, no en una cookie, para reconocer las visitas repetidas; este identificador no contiene nombre, datos de contacto ni información del pedido. Cuando la analítica no está activada, este script no se carga en absoluto.',
  swahili:
    'Wakati uchanganuzi umewashwa kwa tovuti hii, hati yetu ya uchanganuzi ya mhusika wa kwanza hurekodi mionekano ya ukurasa na mwingiliano kwenye ukurasa ili kutusaidia kuelewa jinsi tovuti inavyotumika. Huhifadhi kitambulisho kilichoundwa kwa nasibu katika hifadhi ya ndani ya kivinjari chako, si kidakuzi, ili ziara zinazorudiwa ziweze kutambuliwa; kitambulisho hicho hakina jina, maelezo ya mawasiliano, au taarifa za agizo. Wakati uchanganuzi haujawashwa, hati hii haipakiwi kabisa.',
  vietnamese:
    'Khi tính năng phân tích được bật cho trang web này, tập lệnh phân tích bên thứ nhất của riêng chúng tôi sẽ ghi lại lượt xem trang và tương tác trên trang để giúp chúng tôi hiểu cách trang web được sử dụng. Nó lưu một mã định danh được tạo ngẫu nhiên trong bộ nhớ cục bộ của trình duyệt, không phải cookie, để nhận biết các lượt truy cập lặp lại; mã định danh này không chứa tên, thông tin liên hệ hay thông tin đơn hàng. Khi tính năng phân tích không được bật, tập lệnh này hoàn toàn không được tải.',
};

export const cookieThirdPartyHeading: Translation = {
  amharic: 'የሦስተኛ ወገን ኩኪዎች',
  arabic: 'ملفات تعريف ارتباط الطرف الثالث',
  bengali: 'থার্ড-পার্টি কুকি',
  chinese: '第三方 Cookie',
  english: 'Third-party cookies',
  estonian: 'Kolmandate osapoolte küpsised',
  filipino: 'Mga third-party cookie',
  french: 'Cookies tiers',
  german: 'Drittanbieter-Cookies',
  hindi: 'तृतीय-पक्ष कुकीज़',
  indonesian: 'Cookie pihak ketiga',
  japanese: 'サードパーティ Cookie',
  korean: '제3자 쿠키',
  portuguese: 'Cookies de terceiros',
  russian: 'Сторонние файлы cookie',
  spanish: 'Cookies de terceros',
  swahili: 'Vidakuzi vya wahusika wengine',
  vietnamese: 'Cookie bên thứ ba',
};

export const cookieThirdPartyBody: Translation = {
  amharic: 'Pieleaf የማስታወቂያ አውታረ መረቦችን፣ የመከታተያ ፒክስሎችን ወይም የማኅበራዊ ሚዲያ ዊጄቶችን አይጠቀምም። ትዕዛዝ ማስቀመጥ ወደ ውጫዊ የክፍያ ገጽ አይወስድዎትም: የትዕዛዝዎ እና የክፍያ ዝርዝሮችዎ በቀጥታ ወደ Pieleaf የራሱ ጀርባ-ስርዓት ይላካሉ፣ ስለዚህ ምንም የሦስተኛ ወገን የክፍያ ኩኪ አይቀመጥም።',
  arabic: 'لا يستخدم Pieleaf شبكات إعلانية، ولا بكسلات تتبّع، ولا أدوات تواصل اجتماعي. تقديم الطلب لا يرسلك إلى صفحة دفع خارجية: تُرسل تفاصيل طلبك ودفعك مباشرة إلى الخلفية الخاصة بـ Pieleaf، لذا لا تُوضع أي ملفات تعريف ارتباط دفع من طرف ثالث.',
  bengali: 'Pieleaf বিজ্ঞাপন নেটওয়ার্ক, ট্র্যাকিং পিক্সেল, বা সোশ্যাল-মিডিয়া উইজেট ব্যবহার করে না। অর্ডার দেওয়া আপনাকে কোনো বাহ্যিক পেমেন্ট পেজে পাঠায় না: আপনার অর্ডার ও পেমেন্টের বিবরণ সরাসরি Pieleaf-এর নিজস্ব ব্যাকএন্ডে জমা দেওয়া হয়, তাই কোনো থার্ড-পার্টি পেমেন্ট কুকি সেট করা হয় না।',
  chinese: 'Pieleaf 不使用广告网络、跟踪像素或社交媒体插件。下单不会将你转到外部支付页面：你的订单和支付信息会直接提交给 Pieleaf 自己的后端，因此不会设置任何第三方支付 Cookie。',
  english: "Pieleaf does not use advertising networks, tracking pixels, or social-media widgets. Placing an order does not send you to an external payment page: your order and payment details are submitted directly to Pieleaf's own backend, so no third-party payment cookies are set.",
  estonian: 'Pieleaf ei kasuta reklaamivõrgustikke, jälgimispiksleid ega sotsiaalmeediavidinaid. Tellimuse esitamine ei suuna sind välisele maksete lehele: sinu tellimuse ja makse andmed saadetakse otse Pieleafi enda taustsüsteemi, seega ei seata ühtegi kolmanda osapoole makseküpsist.',
  filipino:
    'Hindi gumagamit ang Pieleaf ng advertising networks, tracking pixels, o social-media widgets. Ang paglalagay ng order ay hindi ka pinapadala sa isang external na payment page: direktang isinusumite ang detalye ng iyong order at bayad sa sariling backend ng Pieleaf, kaya walang third-party payment cookie na itinatakda.',
  french:
    "Pieleaf n'utilise ni régies publicitaires, ni pixels de suivi, ni widgets de réseaux sociaux. Passer une commande ne vous redirige pas vers une page de paiement externe : les détails de votre commande et de votre paiement sont transmis directement au backend propre de Pieleaf, si bien qu'aucun cookie de paiement tiers n'est déposé.",
  german:
    'Pieleaf verwendet keine Werbenetzwerke, Tracking-Pixel oder Social-Media-Widgets. Eine Bestellung aufzugeben leitet dich nicht auf eine externe Zahlungsseite weiter: deine Bestell- und Zahlungsdaten werden direkt an das eigene Backend von Pieleaf übermittelt, sodass keine Drittanbieter-Zahlungscookies gesetzt werden.',
  hindi: 'Pieleaf विज्ञापन नेटवर्क, ट्रैकिंग पिक्सेल, या सोशल-मीडिया विजेट का उपयोग नहीं करता। ऑर्डर देने से आप किसी बाहरी भुगतान पेज पर नहीं भेजे जाते: आपके ऑर्डर और भुगतान विवरण सीधे Pieleaf के अपने बैकएंड को भेजे जाते हैं, इसलिए कोई तृतीय-पक्ष भुगतान कुकी सेट नहीं होती।',
  indonesian:
    'Pieleaf tidak menggunakan jaringan iklan, piksel pelacak, atau widget media sosial. Melakukan pemesanan tidak mengirim Anda ke halaman pembayaran eksternal: detail pesanan dan pembayaran Anda dikirim langsung ke backend milik Pieleaf sendiri, sehingga tidak ada cookie pembayaran pihak ketiga yang ditetapkan.',
  japanese: 'Pieleaf は広告ネットワーク、トラッキングピクセル、ソーシャルメディアウィジェットを使用しません。注文しても外部の支払いページに移動することはありません。注文と支払いの詳細は Pieleaf 自身のバックエンドに直接送信されるため、第三者の支払い Cookie が設定されることはありません。',
  korean: 'Pieleaf는 광고 네트워크, 추적 픽셀, 소셜 미디어 위젯을 사용하지 않습니다. 주문을 하더라도 외부 결제 페이지로 이동하지 않습니다. 주문 및 결제 정보는 Pieleaf 자체 백엔드로 직접 전송되므로 제3자 결제 쿠키가 설정되지 않습니다.',
  portuguese:
    'O Pieleaf não usa redes de publicidade, pixels de rastreamento ou widgets de redes sociais. Fazer um pedido não redireciona você para uma página de pagamento externa: os detalhes do seu pedido e pagamento são enviados diretamente ao próprio backend do Pieleaf, portanto nenhum cookie de pagamento de terceiros é definido.',
  russian:
    'Pieleaf не использует рекламные сети, пиксели отслеживания или виджеты социальных сетей. Оформление заказа не перенаправляет вас на внешнюю страницу оплаты: данные вашего заказа и оплаты отправляются напрямую на собственный бэкенд Pieleaf, поэтому сторонние платёжные cookie-файлы не устанавливаются.',
  spanish:
    'Pieleaf no utiliza redes publicitarias, píxeles de seguimiento ni widgets de redes sociales. Realizar un pedido no te envía a una página de pago externa: los datos de tu pedido y pago se envían directamente al propio backend de Pieleaf, por lo que no se establece ninguna cookie de pago de terceros.',
  swahili:
    'Pieleaf haitumii mitandao ya matangazo, pikseli za kufuatilia, au vifaa vya mitandao ya kijamii. Kuweka agizo hakukupelekei kwenye ukurasa wa malipo wa nje: maelezo ya agizo lako na malipo hutumwa moja kwa moja kwenye mfumo wa nyuma wa Pieleaf mwenyewe, hivyo hakuna kidakuzi cha malipo cha mhusika wa tatu kinachowekwa.',
  vietnamese:
    'Pieleaf không sử dụng mạng quảng cáo, pixel theo dõi hay tiện ích mạng xã hội. Việc đặt hàng không đưa bạn đến trang thanh toán bên ngoài: chi tiết đơn hàng và thanh toán của bạn được gửi trực tiếp đến hệ thống phụ trợ của riêng Pieleaf, vì vậy không có cookie thanh toán bên thứ ba nào được đặt.',
};

export const cookieChoicesHeading: Translation = {
  amharic: 'የእርስዎ ምርጫዎች',
  arabic: 'خياراتك',
  bengali: 'আপনার পছন্দ',
  chinese: '你的选择',
  english: 'Your choices',
  estonian: 'Sinu valikud',
  filipino: 'Ang iyong mga pagpipilian',
  french: 'Vos choix',
  german: 'Deine Optionen',
  hindi: 'आपके विकल्प',
  indonesian: 'Pilihan Anda',
  japanese: 'お客様の選択',
  korean: '귀하의 선택',
  portuguese: 'Suas escolhas',
  russian: 'Ваш выбор',
  spanish: 'Tus opciones',
  swahili: 'Chaguo zako',
  vietnamese: 'Lựa chọn của bạn',
};

export const cookieChoicesBody: Translation = {
  amharic: 'በማንኛውም ጊዜ በአሳሽዎ ቅንብሮች ውስጥ ኩኪዎችን እና የአካባቢ ማከማቻን ማጽዳት ወይም ማገድ ይችላሉ። በጥብቅ አስፈላጊ የሆነውን ኩኪ ማገድ ትዕዛዝ ከማስቀመጥ ሊያግድዎት ይችላል። ቋንቋዎ እና ቀላል ወይም ጨለማ መልኩ በኩኪ ውስጥ አይቀመጡም: ቋንቋ የሚከፍቱትን ገጽ ይከተላል፣ መልኩ ደግሞ የመሣሪያዎን የራሱ ቅንብር ይከተላል።',
  arabic: 'يمكنك مسح أو حظر ملفات تعريف الارتباط والتخزين المحلي في أي وقت من إعدادات متصفحك. حظر ملف تعريف الارتباط الضروري للغاية قد يمنعك من تقديم طلب. لا يتم تخزين لغتك أو مظهرك الفاتح أو الداكن في ملف تعريف ارتباط: فاللغة تتبع الصفحة التي تفتحها، والمظهر يتبع إعداد جهازك الخاص.',
  bengali: 'আপনি যেকোনো সময় আপনার ব্রাউজার সেটিংসে কুকি ও লোকাল স্টোরেজ মুছে ফেলতে বা ব্লক করতে পারেন। কঠোরভাবে প্রয়োজনীয় কুকিটি ব্লক করলে আপনি অর্ডার দিতে ব্যর্থ হতে পারেন। আপনার ভাষা এবং লাইট বা ডার্ক অ্যাপিয়ারেন্স কোনো কুকিতে সংরক্ষিত হয় না: ভাষা আপনি যে পৃষ্ঠা খোলেন তা অনুসরণ করে, এবং অ্যাপিয়ারেন্স আপনার ডিভাইসের নিজস্ব সেটিং অনুসরণ করে।',
  chinese: '你可以随时在浏览器设置中清除或阻止 Cookie 和本地存储。阻止严格必要的 Cookie 可能会导致你无法下单。你的语言以及浅色或深色外观并不存储在 Cookie 中：语言由你打开的页面决定，外观则跟随你设备本身的设置。',
  english:
    "You can clear or block cookies and local storage at any time in your browser settings. Blocking the strictly necessary cookie may stop you from placing an order. Your language and your light or dark appearance are not stored in a cookie: language follows the page you open, and appearance follows your device's own setting.",
  estonian:
    'Saad igal ajal oma brauseri seadetes küpsised ja kohaliku salvestusruumi kustutada või blokeerida. Rangelt vajaliku küpsise blokeerimine võib takistada sul tellimuse esitamist. Sinu keelt ning heledat või tumedat välimust ei salvestata küpsisesse: keel järgib avatud lehte ja välimus järgib sinu seadme enda seadistust.',
  filipino:
    'Maaari mong i-clear o i-block ang cookies at local storage anumang oras sa mga setting ng iyong browser. Ang pag-block sa mahigpit na kinakailangang cookie ay maaaring pumigil sa iyo na maglagay ng order. Ang iyong wika at ang iyong light o dark na hitsura ay hindi nakaimbak sa isang cookie: sinusunod ng wika ang page na binuksan mo, at sinusunod ng hitsura ang sarili nitong setting sa iyong device.',
  french:
    'Vous pouvez effacer ou bloquer les cookies et le stockage local à tout moment dans les paramètres de votre navigateur. Bloquer le cookie strictement nécessaire peut vous empêcher de passer une commande. Votre langue et votre apparence claire ou sombre ne sont pas stockées dans un cookie : la langue suit la page que vous ouvrez, et l’apparence suit le réglage propre de votre appareil.',
  german:
    'Du kannst Cookies und den lokalen Speicher jederzeit in deinen Browsereinstellungen löschen oder blockieren. Das Blockieren des unbedingt erforderlichen Cookies kann dich daran hindern, eine Bestellung aufzugeben. Deine Sprache und deine helle oder dunkle Darstellung werden nicht in einem Cookie gespeichert: die Sprache richtet sich nach der geöffneten Seite, und die Darstellung richtet sich nach der eigenen Einstellung deines Geräts.',
  hindi: 'आप अपने ब्राउज़र सेटिंग्स में किसी भी समय कुकीज़ और लोकल स्टोरेज साफ़ या ब्लॉक कर सकते हैं। अत्यावश्यक कुकी को ब्लॉक करने से आप ऑर्डर देने से रुक सकते हैं। आपकी भाषा और आपका लाइट या डार्क रूप किसी कुकी में संग्रहीत नहीं होता: भाषा आपके खोले गए पेज का अनुसरण करती है, और रूप आपके डिवाइस की अपनी सेटिंग का अनुसरण करता है।',
  indonesian:
    'Anda dapat menghapus atau memblokir cookie dan penyimpanan lokal kapan saja di pengaturan browser Anda. Memblokir cookie yang sangat diperlukan dapat menghalangi Anda melakukan pemesanan. Bahasa serta tampilan terang atau gelap Anda tidak disimpan dalam cookie: bahasa mengikuti halaman yang Anda buka, dan tampilan mengikuti pengaturan perangkat Anda sendiri.',
  japanese: 'ブラウザの設定でいつでも Cookie とローカルストレージを消去またはブロックできます。厳密に必要な Cookie をブロックすると、注文ができなくなる場合があります。言語やライト・ダーク表示は Cookie に保存されません。言語は開いているページに従い、表示はお使いの端末自体の設定に従います。',
  korean: '브라우저 설정에서 언제든지 쿠키와 로컬 스토리지를 지우거나 차단할 수 있습니다. 엄격히 필요한 쿠키를 차단하면 주문을 진행하지 못할 수 있습니다. 사용 언어와 밝은/어두운 화면 모드는 쿠키에 저장되지 않습니다. 언어는 열어 본 페이지를 따르고, 화면 모드는 기기 자체 설정을 따릅니다.',
  portuguese:
    'Você pode limpar ou bloquear cookies e armazenamento local a qualquer momento nas configurações do seu navegador. Bloquear o cookie estritamente necessário pode impedir você de fazer um pedido. Seu idioma e sua aparência clara ou escura não são armazenados em um cookie: o idioma segue a página que você abre, e a aparência segue a própria configuração do seu dispositivo.',
  russian:
    'Вы можете в любое время очистить или заблокировать файлы cookie и локальное хранилище в настройках браузера. Блокировка строго необходимого файла cookie может помешать вам оформить заказ. Ваш язык и светлое или тёмное оформление не хранятся в cookie: язык определяется открытой страницей, а оформление следует настройке вашего устройства.',
  spanish:
    'Puedes borrar o bloquear cookies y almacenamiento local en cualquier momento en la configuración de tu navegador. Bloquear la cookie estrictamente necesaria puede impedirte realizar un pedido. Tu idioma y tu apariencia clara u oscura no se almacenan en una cookie: el idioma sigue la página que abres, y la apariencia sigue la configuración propia de tu dispositivo.',
  swahili:
    'Unaweza kufuta au kuzuia vidakuzi na hifadhi ya ndani wakati wowote katika mipangilio ya kivinjari chako. Kuzuia kidakuzi muhimu kabisa kunaweza kukuzuia kuweka agizo. Lugha yako na muonekano wako mwepesi au mweusi hazihifadhiwi kwenye kidakuzi: lugha hufuata ukurasa unaofungua, na muonekano hufuata mpangilio wa kifaa chako mwenyewe.',
  vietnamese:
    'Bạn có thể xóa hoặc chặn cookie và bộ nhớ cục bộ bất cứ lúc nào trong cài đặt trình duyệt. Việc chặn cookie thực sự cần thiết có thể khiến bạn không đặt được đơn hàng. Ngôn ngữ và giao diện sáng hay tối của bạn không được lưu trong cookie: ngôn ngữ theo trang bạn mở, còn giao diện theo cài đặt riêng của thiết bị bạn.',
};

export const cookieContactHeading: Translation = {
  amharic: 'ጥያቄዎች',
  arabic: 'أسئلة',
  bengali: 'প্রশ্ন',
  chinese: '问题',
  english: 'Questions',
  estonian: 'Küsimused',
  filipino: 'Mga Tanong',
  french: 'Questions',
  german: 'Fragen',
  hindi: 'प्रश्न',
  indonesian: 'Pertanyaan',
  japanese: 'お問い合わせ',
  korean: '문의',
  portuguese: 'Dúvidas',
  russian: 'Вопросы',
  spanish: 'Preguntas',
  swahili: 'Maswali',
  vietnamese: 'Câu hỏi',
};

export const cookieContactBody: Translation = {
  amharic: 'ጥያቄዎች፦ {email}',
  arabic: 'استفسارات: {email}',
  bengali: 'প্রশ্ন: {email}',
  chinese: '咨询：{email}',
  english: 'Questions about this policy: {email}',
  estonian: 'Küsimused: {email}',
  filipino: 'Mga tanong: {email}',
  french: 'Questions : {email}',
  german: 'Fragen: {email}',
  hindi: 'प्रश्न: {email}',
  indonesian: 'Pertanyaan: {email}',
  japanese: 'お問い合わせ：{email}',
  korean: '문의: {email}',
  portuguese: 'Dúvidas: {email}',
  russian: 'Вопросы: {email}',
  spanish: 'Consultas: {email}',
  swahili: 'Maswali: {email}',
  vietnamese: 'Câu hỏi: {email}',
};
export const savedCardsText: Translation = {
  amharic: 'የተቀመጡ ካርዶች',
  arabic: 'البطاقات المحفوظة',
  bengali: 'সংরক্ষিত কার্ড',
  chinese: '已保存的银行卡',
  english: 'Saved cards',
  estonian: 'Salvestatud kaardid',
  filipino: 'Mga naka-save na card',
  french: 'Cartes enregistrées',
  german: 'Gespeicherte Karten',
  hindi: 'सहेजे गए कार्ड',
  indonesian: 'Kartu tersimpan',
  japanese: '保存済みのカード',
  korean: '저장된 카드',
  portuguese: 'Cartões guardados',
  russian: 'Сохранённые карты',
  spanish: 'Tarjetas guardadas',
  swahili: 'Kadi zilizohifadhiwa',
  vietnamese: 'Thẻ đã lưu',
};
export const noSavedCardsText: Translation = {
  amharic: 'ምንም የተቀመጠ ካርድ የለም',
  arabic: 'لا توجد بطاقات محفوظة',
  bengali: 'কোনও সংরক্ষিত কার্ড নেই',
  chinese: '没有已保存的银行卡',
  english: 'No saved cards',
  estonian: 'Salvestatud kaarte ei ole',
  filipino: 'Walang naka-save na card',
  french: 'Aucune carte enregistrée',
  german: 'Keine gespeicherten Karten',
  hindi: 'कोई सहेजा गया कार्ड नहीं',
  indonesian: 'Tidak ada kartu tersimpan',
  japanese: '保存済みのカードはありません',
  korean: '저장된 카드가 없습니다',
  portuguese: 'Nenhum cartão guardado',
  russian: 'Нет сохранённых карт',
  spanish: 'No hay tarjetas guardadas',
  swahili: 'Hakuna kadi zilizohifadhiwa',
  vietnamese: 'Chưa có thẻ nào được lưu',
};
export const cardsNotAcceptedText: Translation = {
  amharic: 'በአሁኑ ጊዜ በሞባይል ገንዘብ ብቻ ነው የምንቀበለው፤ ስለዚህ የሚቀመጥ ካርድ የለም።',
  arabic: 'نقبل حاليًا الدفع عبر الهاتف المحمول فقط، لذا لا توجد بطاقة لحفظها.',
  bengali: 'আমরা এখন কেবল মোবাইল মানি নিই, তাই সংরক্ষণের মতো কোনও কার্ড নেই।',
  chinese: '我们目前仅接受移动支付，因此没有可保存的银行卡。',
  english: 'We currently take mobile money only, so there is no card to save.',
  estonian: 'Praegu võtame vastu ainult mobiiliraha, seega ei ole kaarti, mida salvestada.',
  filipino: 'Mobile money lang po ang tinatanggap namin ngayon, kaya walang card na maise-save.',
  french: 'Nous acceptons uniquement le mobile money pour le moment : il n’y a donc aucune carte à enregistrer.',
  german: 'Wir akzeptieren derzeit nur Mobile Money, daher gibt es keine Karte zum Speichern.',
  hindi: 'फ़िलहाल हम केवल मोबाइल मनी लेते हैं, इसलिए सहेजने के लिए कोई कार्ड नहीं है।',
  indonesian: 'Saat ini kami hanya menerima mobile money, jadi tidak ada kartu yang bisa disimpan.',
  japanese: '現在はモバイルマネーのみのお取り扱いのため、保存できるカードはありません。',
  korean: '현재는 모바일 머니만 지원하므로 저장할 카드가 없습니다.',
  portuguese: 'De momento aceitamos apenas mobile money, por isso não há cartão para guardar.',
  russian: 'Сейчас мы принимаем только мобильные платежи, поэтому сохранять нечего.',
  spanish: 'Por ahora solo aceptamos dinero móvil, así que no hay tarjeta que guardar.',
  swahili: 'Kwa sasa tunapokea pesa za simu pekee, hivyo hakuna kadi ya kuhifadhi.',
  vietnamese: 'Hiện chúng tôi chỉ nhận ví điện thoại, nên chưa có thẻ nào để lưu.',
};
